/*
@license
  Impulse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/impulse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/
let customFilter = '';
window.theme = window.theme || {};
window.Shopify = window.Shopify || {};
let slideshowThumb;
let mainThumb;
let mainLimited;
let mainSliderArgs2;
let mainSliderInit;
let mainSliderArgs;
let mainSliderCache;
let mainSliderInitColor;
let mainSliderArgsColor;
let mainSliderCacheColor;
let navSliderCacheColor;
let navSliderinitColor;
let navArgsColor;

theme.config = {
  bpSmall: false,
  hasSessionStorage: true,
  hasLocalStorage: true,
  mediaQuerySmall: "screen and (max-width: " + 769 + "px)",
  youTubeReady: false,
  vimeoReady: false,
  vimeoLoading: false,
  isTouch:
    "ontouchstart" in window ||
    (window.DocumentTouch && window.document instanceof DocumentTouch) ||
    window.navigator.maxTouchPoints ||
    window.navigator.msMaxTouchPoints
      ? true
      : false,
  stickyHeader: false,
  rtl: document.documentElement.getAttribute("dir") == "rtl" ? true : false,
};

if (theme.config.isTouch) {
  document.documentElement.className += " supports-touch";
}

if (console && console.log) {
  console.log(
    "Impulse theme (" +
      theme.settings.themeVersion +
      ") by ARCHΞTYPE | Learn more at https://archetypethemes.co"
  );
}

theme.recentlyViewed = {
  recent: {}, // will store handle+url of recent products
  productInfo: {}, // will store product data to reduce API calls
};

window.lazySizesConfig = window.lazySizesConfig || {};
lazySizesConfig.expFactor = 4;

(function () {
  "use strict";

  theme.delegate = {
    on: function (event, callback, options) {
      if (!this.namespaces)
        // save the namespaces on the DOM element itself
        this.namespaces = {};

      this.namespaces[event] = callback;
      options = options || false;

      this.addEventListener(event.split(".")[0], callback, options);
      return this;
    },
    off: function (event) {
      if (!this.namespaces) {
        return;
      }
      this.removeEventListener(event.split(".")[0], this.namespaces[event]);
      delete this.namespaces[event];
      return this;
    },
  };

  // Extend the DOM with these above custom methods
  window.on = Element.prototype.on = theme.delegate.on;
  window.off = Element.prototype.off = theme.delegate.off;

  theme.utils = {
    defaultTo: function (value, defaultValue) {
      return value == null || value !== value ? defaultValue : value;
    },

    wrap: function (el, wrapper) {
      el.parentNode.insertBefore(wrapper, el);
      wrapper.appendChild(el);
    },

    debounce: function (wait, callback, immediate) {
      var timeout;
      return function () {
        var context = this,
          args = arguments;
        var later = function () {
          timeout = null;
          if (!immediate) callback.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) callback.apply(context, args);
      };
    },

    throttle: function (limit, callback) {
      var waiting = false;
      return function () {
        if (!waiting) {
          callback.apply(this, arguments);
          waiting = true;
          setTimeout(function () {
            waiting = false;
          }, limit);
        }
      };
    },

    prepareTransition: function (el, callback) {
      el.addEventListener("transitionend", removeClass);

      function removeClass(evt) {
        el.classList.remove("is-transitioning");
        el.removeEventListener("transitionend", removeClass);
      }

      el.classList.add("is-transitioning");
      el.offsetWidth; // check offsetWidth to force the style rendering

      if (typeof callback === "function") {
        callback();
      }
    },

    // _.compact from lodash
    // Creates an array with all falsey values removed. The values `false`, `null`,
    // `0`, `""`, `undefined`, and `NaN` are falsey.
    // _.compact([0, 1, false, 2, '', 3]);
    // => [1, 2, 3]
    compact: function (array) {
      var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    },

    serialize: function (form) {
      var arr = [];
      Array.prototype.slice.call(form.elements).forEach(function (field) {
        if (
          !field.name ||
          field.disabled ||
          ["file", "reset", "submit", "button"].indexOf(field.type) > -1
        )
          return;
        if (field.type === "select-multiple") {
          Array.prototype.slice.call(field.options).forEach(function (option) {
            if (!option.selected) return;
            arr.push(
              encodeURIComponent(field.name) +
                "=" +
                encodeURIComponent(option.value)
            );
          });
          return;
        }
        if (["checkbox", "radio"].indexOf(field.type) > -1 && !field.checked)
          return;
        arr.push(
          encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value)
        );
      });
      return arr.join("&");
    },
  };

  theme.a11y = {
    trapFocus: function (options) {
      var eventsName = {
        focusin: options.namespace ? "focusin." + options.namespace : "focusin",
        focusout: options.namespace
          ? "focusout." + options.namespace
          : "focusout",
        keydown: options.namespace
          ? "keydown." + options.namespace
          : "keydown.handleFocus",
      };

      // Get every possible visible focusable element
      var focusableEls = options.container.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
      );
      var elArray = [].slice.call(focusableEls);
      var focusableElements = elArray.filter((el) => el.offsetParent !== null);

      var firstFocusable = focusableElements[0];
      var lastFocusable = focusableElements[focusableElements.length - 1];

      if (!options.elementToFocus) {
        options.elementToFocus = options.container;
      }

      options.container.setAttribute("tabindex", "-1");
      options.elementToFocus.focus();

      document.documentElement.off("focusin");
      document.documentElement.on(eventsName.focusout, function () {
        document.documentElement.off(eventsName.keydown);
      });

      document.documentElement.on(eventsName.focusin, function (evt) {
        if (evt.target !== lastFocusable && evt.target !== firstFocusable)
          return;

        document.documentElement.on(eventsName.keydown, function (evt) {
          _manageFocus(evt);
        });
      });

      function _manageFocus(evt) {
        if (evt.keyCode !== 9) return;
        /**
         * On the first focusable element and tab backward,
         * focus the last element
         */
        if (evt.target === firstFocusable && evt.shiftKey) {
          evt.preventDefault();
          lastFocusable.focus();
        }
      }
    },
    removeTrapFocus: function (options) {
      var eventName = options.namespace
        ? "focusin." + options.namespace
        : "focusin";

      if (options.container) {
        options.container.removeAttribute("tabindex");
      }

      document.documentElement.off(eventName);
    },

    lockMobileScrolling: function (namespace, element) {
      var el = element ? element : document.documentElement;
      document.documentElement.classList.add("lock-scroll");
      el.on("touchmove" + namespace, function () {
        return true;
      });
    },

    unlockMobileScrolling: function (namespace, element) {
      document.documentElement.classList.remove("lock-scroll");
      var el = element ? element : document.documentElement;
      el.off("touchmove" + namespace);
    },
  };

  // Add class when tab key starts being used to show outlines
  document.documentElement.on("keyup.tab", function (evt) {
    if (evt.keyCode === 9) {
      document.documentElement.classList.add("tab-outline");
      document.documentElement.off("keyup.tab");
    }
  });

  /**
   * Currency Helpers
   * -----------------------------------------------------------------------------
   * A collection of useful functions that help with currency formatting
   *
   * Current contents
   * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
   *   - When theme.settings.superScriptPrice is enabled, format cents in <sup> tag
   * - getBaseUnit - Splits unit price apart to get value + unit
   *
   */

  theme.Currency = (function () {
    var moneyFormat = "${{amount}}";
    var superScript =
      theme && theme.settings && theme.settings.superScriptPrice;

    function formatMoney(cents, format) {
      if (!format) {
        format = theme.settings.moneyFormat;
      }

      if (typeof cents === "string") {
        cents = cents.replace(".", "");
      }
      var value = "";
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = format || moneyFormat;

      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = theme.utils.defaultTo(precision, 2);
        thousands = theme.utils.defaultTo(thousands, ",");
        decimal = theme.utils.defaultTo(decimal, ".");

        if (isNaN(number) || number == null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split(".");
        var dollarsAmount = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          "$1" + thousands
        );
        var centsAmount = parts[1] ? decimal + parts[1] : "";

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case "amount":
          value = formatWithDelimiters(cents, 2);

          if (superScript && value && value.includes(".")) {
            value = value.replace(".", "<sup>") + "</sup>";
          }

          break;
        case "amount_no_decimals":
          value = formatWithDelimiters(cents, 0);
          break;
        case "amount_with_comma_separator":
          value = formatWithDelimiters(cents, 2, ".", ",");

          if (superScript && value && value.includes(".")) {
            value = value.replace(",", "<sup>") + "</sup>";
          }

          break;
        case "amount_no_decimals_with_comma_separator":
          value = formatWithDelimiters(cents, 0, ".", ",");
          break;
        case "amount_no_decimals_with_space_separator":
          value = formatWithDelimiters(cents, 0, " ");
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }

    function getBaseUnit(variant) {
      if (!variant) {
        return;
      }

      if (
        !variant.unit_price_measurement ||
        !variant.unit_price_measurement.reference_value
      ) {
        return;
      }

      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
            variant.unit_price_measurement.reference_unit;
    }

    return {
      formatMoney: formatMoney,
      getBaseUnit: getBaseUnit,
    };
  })();

  theme.Images = (function () {
    /**
     * Find the Shopify image attribute size
     */
    function imageSize(src) {
      if (!src) {
        return "620x"; // default based on theme
      }

      var match = src.match(
        /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
      );

      if (match !== null) {
        return match[1];
      } else {
        return null;
      }
    }

    /**
     * Adds a Shopify size attribute to a URL
     */
    function getSizedImageUrl(src, size) {
      if (!src) {
        return src;
      }

      if (size == null) {
        return src;
      }

      if (size === "master") {
        return this.removeProtocol(src);
      }

      var match = src.match(
        /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
      );

      if (match != null) {
        var prefix = src.split(match[0]);
        var suffix = match[0];

        return this.removeProtocol(prefix[0] + "_" + size + suffix);
      }

      return null;
    }

    function removeProtocol(path) {
      return path.replace(/http(s)?:/, "");
    }

    function lazyloadImagePath(string) {
      var image;

      if (string !== null) {
        image = string.replace(/(\.[^.]*)$/, "_{width}x$1");
      }

      return image;
    }

    return {
      imageSize: imageSize,
      getSizedImageUrl: getSizedImageUrl,
      removeProtocol: removeProtocol,
      lazyloadImagePath: lazyloadImagePath,
    };
  })();

  theme.loadImageSection = function (container) {
    // Wait until images inside container have lazyloaded class
    function setAsLoaded() {
      container.classList.remove("loading", "loading--delayed");
      container.classList.add("loaded");
    }

    function checkForLazyloadedImage() {
      return container.querySelector(".lazyloaded");
    }

    // If it has SVGs it's in the onboarding state so set as loaded
    if (container.querySelector("svg")) {
      setAsLoaded();
      return;
    }

    if (checkForLazyloadedImage()) {
      setAsLoaded();
      return;
    }

    var interval = setInterval(function () {
      if (checkForLazyloadedImage()) {
        clearInterval(interval);
        setAsLoaded();
      }
    }, 25);
  };

  // Init section function when it's visible, then disable observer
  theme.initWhenVisible = function (options) {
    var threshold = options.threshold ? options.threshold : 0;

    var observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (typeof options.callback === "function") {
              options.callback();
              observer.unobserve(entry.target);
            }
          }
        });
      },
      { rootMargin: "0px 0px " + threshold + "px 0px" }
    );

    observer.observe(options.element);
  };

  theme.LibraryLoader = (function () {
    var types = {
      link: "link",
      script: "script",
    };

    var status = {
      requested: "requested",
      loaded: "loaded",
    };

    var cloudCdn = "https://cdn.shopify.com/shopifycloud/";

    var libraries = {
      youtubeSdk: {
        tagId: "youtube-sdk",
        src: "https://www.youtube.com/iframe_api",
        type: types.script,
      },
      vimeo: {
        tagId: "vimeo-api",
        src: "https://player.vimeo.com/api/player.js",
        type: types.script,
      },
      shopifyXr: {
        tagId: "shopify-model-viewer-xr",
        src: cloudCdn + "shopify-xr-js/assets/v1.0/shopify-xr.en.js",
        type: types.script,
      },
      modelViewerUi: {
        tagId: "shopify-model-viewer-ui",
        src: cloudCdn + "model-viewer-ui/assets/v1.0/model-viewer-ui.en.js",
        type: types.script,
      },
      modelViewerUiStyles: {
        tagId: "shopify-model-viewer-ui-styles",
        src: cloudCdn + "model-viewer-ui/assets/v1.0/model-viewer-ui.css",
        type: types.link,
      },
    };

    function load(libraryName, callback) {
      var library = libraries[libraryName];

      if (!library) return;
      if (library.status === status.requested) return;

      callback = callback || function () {};
      if (library.status === status.loaded) {
        callback();
        return;
      }

      library.status = status.requested;

      var tag;

      switch (library.type) {
        case types.script:
          tag = createScriptTag(library, callback);
          break;
        case types.link:
          tag = createLinkTag(library, callback);
          break;
      }

      tag.id = library.tagId;
      library.element = tag;

      var firstScriptTag = document.getElementsByTagName(library.type)[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    function createScriptTag(library, callback) {
      var tag = document.createElement("script");
      tag.src = library.src;
      tag.addEventListener("load", function () {
        library.status = status.loaded;
        callback();
      });
      return tag;
    }

    function createLinkTag(library, callback) {
      var tag = document.createElement("link");
      tag.href = library.src;
      tag.rel = "stylesheet";
      tag.type = "text/css";
      tag.addEventListener("load", function () {
        library.status = status.loaded;
        callback();
      });
      return tag;
    }

    return {
      load: load,
    };
  })();

  theme.rteInit = function () {
    // Wrap tables so they become scrollable on small screens
    document.querySelectorAll(".rte table").forEach((table) => {
      var wrapWith = document.createElement("div");
      wrapWith.classList.add("table-wrapper");
      theme.utils.wrap(table, wrapWith);
    });

    // Wrap video iframe embeds so they are responsive
    document
      .querySelectorAll('.rte iframe[src*="youtube.com/embed"]')
      .forEach((iframe) => {
        wrapVideo(iframe);
      });
    document
      .querySelectorAll('.rte iframe[src*="player.vimeo"]')
      .forEach((iframe) => {
        wrapVideo(iframe);
      });

    function wrapVideo(iframe) {
      // Reset the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      iframe.src = iframe.src;
      var wrapWith = document.createElement("div");
      wrapWith.classList.add("video-wrapper");
      theme.utils.wrap(iframe, wrapWith);
    }

    // Remove CSS that adds animated underline under image links
    document.querySelectorAll(".rte a img").forEach((img) => {
      img.parentNode.classList.add("rte__image");
    });
  };

  theme.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];

    document.addEventListener(
      "shopify:section:load",
      this._onSectionLoad.bind(this)
    );
    document.addEventListener(
      "shopify:section:unload",
      this._onSectionUnload.bind(this)
    );
    document.addEventListener(
      "shopify:section:select",
      this._onSelect.bind(this)
    );
    document.addEventListener(
      "shopify:section:deselect",
      this._onDeselect.bind(this)
    );
    document.addEventListener(
      "shopify:block:select",
      this._onBlockSelect.bind(this)
    );
    document.addEventListener(
      "shopify:block:deselect",
      this._onBlockDeselect.bind(this)
    );
  };

  theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
    _createInstance: function (container, constructor, scope) {
      var id = container.getAttribute("data-section-id");
      var type = container.getAttribute("data-section-type");

      constructor = constructor || this.constructors[type];

      if (typeof constructor === "undefined") {
        return;
      }

      // If custom scope passed, check to see if instance
      // is already initialized so we don't double up
      if (scope) {
        var instanceExists = this._findInstance(id);
        if (instanceExists) {
          this._removeInstance(id);
        }
      }

      // If a section fails to init, handle the error without letting all subsequest section registers to fail
      try {
        var instance = Object.assign(new constructor(container), {
          id: id,
          type: type,
          container: container,
        });
        this.instances.push(instance);
      } catch (e) {
        console.error(e);
      }
    },

    _findInstance: function (id) {
      for (var i = 0; i < this.instances.length; i++) {
        if (this.instances[i].id === id) {
          return this.instances[i];
        }
      }
    },

    _removeInstance: function (id) {
      var i = this.instances.length;
      var instance;

      while (i--) {
        if (this.instances[i].id === id) {
          instance = this.instances[i];
          this.instances.splice(i, 1);
          break;
        }
      }

      return instance;
    },

    _onSectionLoad: function (evt, subSection, subSectionId) {
      if (window.AOS) {
        AOS.refreshHard();
      }
      if (theme && theme.initGlobals) {
        theme.initGlobals();
      }

      var container = subSection ? subSection : evt.target;
      var section = subSection
        ? subSection
        : evt.target.querySelector("[data-section-id]");

      if (!section) {
        return;
      }

      this._createInstance(section);

      var instance = subSection
        ? subSectionId
        : this._findInstance(evt.detail.sectionId);

      // Check if we have subsections to load
      var haveSubSections = container.querySelectorAll("[data-subsection]");
      if (haveSubSections.length) {
        this.loadSubSections(container);
      }

      // Run JS only in case of the section being selected in the editor
      // before merchant clicks "Add"
      if (instance && typeof instance.onLoad === "function") {
        instance.onLoad(evt);
      }

      // Force editor to trigger scroll event when loading a section
      setTimeout(function () {
        window.dispatchEvent(new Event("scroll"));
      }, 200);
    },

    _onSectionUnload: function (evt) {
      this.instances = this.instances.filter(function (instance) {
        var isEventInstance = instance.id === evt.detail.sectionId;

        if (isEventInstance) {
          if (typeof instance.onUnload === "function") {
            instance.onUnload(evt);
          }
        }

        return !isEventInstance;
      });
    },

    loadSubSections: function (scope) {
      if (!scope) {
        return;
      }

      var sections = scope.querySelectorAll("[data-section-id]");

      sections.forEach((el) => {
        this._onSectionLoad(null, el, el.dataset.sectionId);
      });
    },

    _onSelect: function (evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (
        typeof instance !== "undefined" &&
        typeof instance.onSelect === "function"
      ) {
        instance.onSelect(evt);
      }
    },

    _onDeselect: function (evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (
        typeof instance !== "undefined" &&
        typeof instance.onDeselect === "function"
      ) {
        instance.onDeselect(evt);
      }
    },

    _onBlockSelect: function (evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (
        typeof instance !== "undefined" &&
        typeof instance.onBlockSelect === "function"
      ) {
        instance.onBlockSelect(evt);
      }
    },

    _onBlockDeselect: function (evt) {
      var instance = this._findInstance(evt.detail.sectionId);

      if (
        typeof instance !== "undefined" &&
        typeof instance.onBlockDeselect === "function"
      ) {
        instance.onBlockDeselect(evt);
      }
    },

    register: function (type, constructor, scope) {
      this.constructors[type] = constructor;

      var sections = document.querySelectorAll(
        '[data-section-type="' + type + '"]'
      );

      if (scope) {
        sections = scope.querySelectorAll('[data-section-type="' + type + '"]');
      }

      sections.forEach(
        function (container) {
          this._createInstance(container, constructor, scope);
        }.bind(this)
      );
    },

    reinit: function (section) {
      for (var i = 0; i < this.instances.length; i++) {
        var instance = this.instances[i];
        if (instance["type"] === section) {
          if (typeof instance.forceReload === "function") {
            instance.forceReload();
          }
        }
      }
    },
  });

  theme.Variants = (function () {
    function Variants(options) {
      this.container = options.container;
      this.variants = options.variants;
      this.singleOptionSelector = options.singleOptionSelector;
      this.originalSelectorId = options.originalSelectorId;
      this.enableHistoryState = options.enableHistoryState;
      this.currentVariant = this._getVariantFromOptions();

      this.container
        .querySelectorAll(this.singleOptionSelector)
        .forEach((el) => {
          el.addEventListener("change", this._onSelectChange.bind(this));
        });
    }

    Variants.prototype = Object.assign({}, Variants.prototype, {
      _getCurrentOptions: function () {
        var result = [];

        this.container
          .querySelectorAll(this.singleOptionSelector)
          .forEach((el) => {
            var type = el.getAttribute("type");

            if (type === "radio" || type === "checkbox") {
              if (el.checked) {
                result.push({
                  value: el.value,
                  index: el.dataset.index,
                });
              }
            } else {
              result.push({
                value: el.value,
                index: el.dataset.index,
              });
            }
          });

        // remove any unchecked input values if using radio buttons or checkboxes
        result = theme.utils.compact(result);

        return result;
      },

      _getVariantFromOptions: function () {
        var selectedValues = this._getCurrentOptions();
        var variants = this.variants;
        var found = false;

        variants.forEach(function (variant) {
          var match = true;
          var options = variant.options;

          selectedValues.forEach(function (option) {
            if (match) {
              match = variant[option.index] === option.value;
            }
          });

          if (match) {
            found = variant;
          }
        });

        return found || null;
      },

      _onSelectChange: function () {
        var variant = this._getVariantFromOptions();

        this.container.dispatchEvent(
          new CustomEvent("variantChange", {
            detail: {
              variant: variant,
            },
          })
        );

        document.dispatchEvent(
          new CustomEvent("variant:change", {
            detail: {
              variant: variant,
            },
          })
        );

        if (!variant) {
          return;
        }

        this._updateMasterSelect(variant);
        this._updateImages(variant);
        this._updatePrice(variant);
        this._updateUnitPrice(variant);
        this._updateSKU(variant);
        this.currentVariant = variant;

        if (this.enableHistoryState) {
          this._updateHistoryState(variant);
        }
      },

      _updateImages: function (variant) {
        //var getVersion = jQuery('.page-content--product').find('[name="Version"]:checked').val();
        //if(getVersion!="Limited Edition"){
          var variantImage = variant.featured_image || {};
          var currentVariantImage = this.currentVariant.featured_image || {};

          if (
            !variant.featured_image ||
            variantImage.src === currentVariantImage.src
          ) {
            return;
          }

          this.container.dispatchEvent(
            new CustomEvent("variantImageChange", {
              detail: {
                variant: variant,
              },
            })
          );
        //}
      },

      _updatePrice: function (variant) {
        if (
          variant.price === this.currentVariant.price &&
          variant.compare_at_price === this.currentVariant.compare_at_price
        ) {
          return;
        }

        var vPrice = variant.price;
        var afterPrice = variant.price / 4;
        console.log("afterPrice-->", Math.trunc(afterPrice));
        var finalAfterPrice = theme.Currency.formatMoney(
          Math.trunc(afterPrice),
          theme.settings.moneyFormat
        );
        $('.afterpay-main-text').find('strong').text(finalAfterPrice);
        this.container.dispatchEvent(
          new CustomEvent("variantPriceChange", {
            detail: {
              variant: variant,
            },
          })
        );
      },

      _updateUnitPrice: function (variant) {
        if (variant.unit_price === this.currentVariant.unit_price) {
          return;
        }

        this.container.dispatchEvent(
          new CustomEvent("variantUnitPriceChange", {
            detail: {
              variant: variant,
            },
          })
        );
      },

      _updateSKU: function (variant) {
        if (variant.sku === this.currentVariant.sku) {
          return;
        }

        this.container.dispatchEvent(
          new CustomEvent("variantSKUChange", {
            detail: {
              variant: variant,
            },
          })
        );
      },

      _updateHistoryState: function (variant) {
        if (!history.replaceState || !variant) {
          return;
        }

        var newurl =
          window.location.protocol +
          "//" +
          window.location.host +
          window.location.pathname +
          "?variant=" +
          variant.id;
        window.history.replaceState({ path: newurl }, "", newurl);
      },

      _updateMasterSelect: function (variant) {
        this.container.querySelector(this.originalSelectorId).value =
          variant.id;
        // Force a change event so Shop Pay installments works after a variant is changed
        this.container
          .querySelector(this.originalSelectorId)
          .dispatchEvent(new Event("change", { bubbles: true }));
      },
    });

    return Variants;
  })();

  window.vimeoApiReady = function () {
    theme.config.vimeoLoading = true;

    // Because there's no way to check for the Vimeo API being loaded
    // asynchronously, we use this terrible timeout to wait for it being ready
    checkIfVimeoIsReady().then(function () {
      theme.config.vimeoReady = true;
      theme.config.vimeoLoading = false;
      document.dispatchEvent(new CustomEvent("vimeoReady"));
    });
  };

  function checkIfVimeoIsReady() {
    var wait;
    var timeout;

    var deferred = new Promise((resolve, reject) => {
      wait = setInterval(function () {
        if (!Vimeo) {
          return;
        }

        clearInterval(wait);
        clearTimeout(timeout);
        resolve();
      }, 500);

      timeout = setTimeout(function () {
        clearInterval(wait);
        reject();
      }, 4000); // subjective. test up to 8 times over 4 seconds
    });

    return deferred;
  }

  theme.VimeoPlayer = (function () {
    var classes = {
      loading: "loading",
      loaded: "loaded",
      interactable: "video-interactable",
    };

    var defaults = {
      background: true,
      byline: false,
      controls: false,
      loop: true,
      muted: true,
      playsinline: true,
      portrait: false,
      title: false,
    };

    function VimeoPlayer(divId, videoId, options) {
      this.divId = divId;
      this.el = document.getElementById(divId);
      this.videoId = videoId;
      this.iframe = null;
      this.options = options;

      if (this.options && this.options.videoParent) {
        this.parent = this.el.closest(this.options.videoParent);
      }

      this.setAsLoading();

      if (theme.config.vimeoReady) {
        this.init();
      } else {
        theme.LibraryLoader.load("vimeo", window.vimeoApiReady);
        document.addEventListener("vimeoReady", this.init.bind(this));
      }
    }

    VimeoPlayer.prototype = Object.assign({}, VimeoPlayer.prototype, {
      init: function () {
        var args = defaults;
        args.id = this.videoId;

        this.videoPlayer = new Vimeo.Player(this.el, args);

        this.videoPlayer.ready().then(this.playerReady.bind(this));
      },

      playerReady: function () {
        this.iframe = this.el.querySelector("iframe");
        this.iframe.setAttribute("tabindex", "-1");

        this.videoPlayer.setMuted(true);

        this.setAsLoaded();

        // pause when out of view
        var observer = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.play();
              } else {
                this.pause();
              }
            });
          },
          { rootMargin: "0px 0px 50px 0px" }
        );

        observer.observe(this.iframe);
      },

      setAsLoading: function () {
        if (!this.parent) return;
        this.parent.classList.add(classes.loading);
      },

      setAsLoaded: function () {
        if (!this.parent) return;
        this.parent.classList.remove(classes.loading);
        this.parent.classList.add(classes.loaded);
        if (Shopify && Shopify.designMode) {
          if (window.AOS) {
            AOS.refreshHard();
          }
        }
      },

      enableInteraction: function () {
        if (!this.parent) return;
        this.parent.classList.add(classes.interactable);
      },

      play: function () {
        if (this.videoPlayer && typeof this.videoPlayer.play === "function") {
          this.videoPlayer.play();
        }
      },

      pause: function () {
        if (this.videoPlayer && typeof this.videoPlayer.pause === "function") {
          this.videoPlayer.pause();
        }
      },

      destroy: function () {
        if (
          this.videoPlayer &&
          typeof this.videoPlayer.destroy === "function"
        ) {
          this.videoPlayer.destroy();
        }
      },
    });

    return VimeoPlayer;
  })();

  window.onYouTubeIframeAPIReady = function () {
    theme.config.youTubeReady = true;
    document.dispatchEvent(new CustomEvent("youTubeReady"));
  };

  /*============================================================================
    YouTube SDK method
    Parameters:
      - player div id (required)
      - arguments
        - videoId (required)
        - videoParent (selector, optional for section loading state)
        - events (object, optional)
  ==============================================================================*/
  theme.YouTube = (function () {
    var classes = {
      loading: "loading",
      loaded: "loaded",
      interactable: "video-interactable",
    };

    var defaults = {
      width: 1280,
      height: 720,
      playerVars: {
        autohide: 0,
        autoplay: 1,
        cc_load_policy: 0,
        controls: 0,
        fs: 0,
        iv_load_policy: 3,
        modestbranding: 1,
        playsinline: 1,
        rel: 0,
      },
    };

    function YouTube(divId, options) {
      this.divId = divId;
      this.iframe = null;

      this.attemptedToPlay = false;

      // API callback events
      defaults.events = {
        onReady: this.onVideoPlayerReady.bind(this),
        onStateChange: this.onVideoStateChange.bind(this),
      };

      this.options = Object.assign({}, defaults, options);

      if (this.options) {
        if (this.options.videoParent) {
          this.parent = document
            .getElementById(this.divId)
            .closest(this.options.videoParent);
        }

        // Most YT videos will autoplay. If in product media,
        // will handle in theme.Product instead
        if (!this.options.autoplay) {
          this.options.playerVars.autoplay = this.options.autoplay;
        }

        if (this.options.style === "sound") {
          this.options.playerVars.controls = 1;
          this.options.playerVars.autoplay = 0;
        }
      }

      this.setAsLoading();

      if (theme.config.youTubeReady) {
        this.init();
      } else {
        theme.LibraryLoader.load("youtubeSdk");
        document.addEventListener("youTubeReady", this.init.bind(this));
      }
    }

    YouTube.prototype = Object.assign({}, YouTube.prototype, {
      init: function () {
        this.videoPlayer = new YT.Player(this.divId, this.options);
      },

      onVideoPlayerReady: function (evt) {
        this.iframe = document.getElementById(this.divId); // iframe once YT loads
        this.iframe.setAttribute("tabindex", "-1");

        if (this.options.style !== "sound") {
          evt.target.mute();
        }

        // pause when out of view
        var observer = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.play();
              } else {
                this.pause();
              }
            });
          },
          { rootMargin: "0px 0px 50px 0px" }
        );

        observer.observe(this.iframe);
      },

      onVideoStateChange: function (evt) {
        switch (evt.data) {
          case -1: // unstarted
            // Handle low power state on iOS by checking if
            // video is reset to unplayed after attempting to buffer
            if (this.attemptedToPlay) {
              this.setAsLoaded();
              this.enableInteraction();
            }
            break;
          case 0: // ended, loop it
            this.play(evt);
            break;
          case 1: // playing
            this.setAsLoaded();
            break;
          case 3: // buffering
            this.attemptedToPlay = true;
            break;
        }
      },

      setAsLoading: function () {
        if (!this.parent) return;
        this.parent.classList.add(classes.loading);
      },

      setAsLoaded: function () {
        if (!this.parent) return;
        this.parent.classList.remove(classes.loading);
        this.parent.classList.add(classes.loaded);
        if (Shopify && Shopify.designMode) {
          if (window.AOS) {
            AOS.refreshHard();
          }
        }
      },

      enableInteraction: function () {
        if (!this.parent) return;
        this.parent.classList.add(classes.interactable);
      },

      play: function () {
        if (
          this.videoPlayer &&
          typeof this.videoPlayer.playVideo === "function"
        ) {
          this.videoPlayer.playVideo();
        }
      },

      pause: function () {
        if (
          this.videoPlayer &&
          typeof this.videoPlayer.pauseVideo === "function"
        ) {
          this.videoPlayer.pauseVideo();
        }
      },

      destroy: function () {
        if (
          this.videoPlayer &&
          typeof this.videoPlayer.destroy === "function"
        ) {
          this.videoPlayer.destroy();
        }
      },
    });

    return YouTube;
  })();

  // Patch Flickity resize event for iOS15 jank fix
  (function () {
    var originalResizeMethod = Flickity.prototype.resize;
    var lastWidth = window.innerWidth;

    Flickity.prototype.resize = function () {
      if (window.innerWidth === lastWidth) {
        return;
      }

      lastWidth = window.innerWidth;
      originalResizeMethod.apply(this, arguments); // Call original method
    };
  })();

  // Prevent vertical scroll while using flickity sliders
  (function () {
    var e = !1;
    var t;

    document.body.addEventListener("touchstart", function (i) {
      if (!i.target.closest(".flickity-slider")) {
        return (e = !1);
        void 0;
      }
      e = !0;
      t = {
        x: i.touches[0].pageX,
        y: i.touches[0].pageY,
      };
    });

    document.body.addEventListener(
      "touchmove",
      function (i) {
        if (e && i.cancelable) {
          var n = {
            x: i.touches[0].pageX - t.x,
            y: i.touches[0].pageY - t.y,
          };
          Math.abs(n.x) > Flickity.defaults.dragThreshold && i.preventDefault();
        }
      },
      { passive: !1 }
    );
  })();

  /**
   * Ajax Renderer
   * -----------------------------------------------------------------------------
   * Render sections without reloading the page.
   * @param {Object[]} sections - The section to update on render.
   * @param {string} sections[].sectionId - The ID of the section from Shopify.
   * @param {string} sections[].nodeId - The ID of the DOM node to replace.
   * @param {Function} sections[].onReplace (optional) - The custom render function.
   * @param {string[]} preserveParams - The param name to preserve in the URL.
   * @param {boolean} debug - Output logs to console for debugging.
   *
   */

  theme.AjaxRenderer = (function () {
    function AjaxRenderer({ sections, preserveParams, onReplace, debug } = {}) {
      this.sections = sections || [];
      this.preserveParams = preserveParams || [];
      this.cachedSections = [];
      this.onReplace = onReplace;
      this.debug = Boolean(debug);
    }

    AjaxRenderer.prototype = Object.assign({}, AjaxRenderer.prototype, {
      renderPage: function (basePath, searchParams, updateURLHash = true, tempPart='') {
        if (searchParams) this.appendPreservedParams(searchParams);
        var tempPart = $('#CollectionSidebar').attr('class');
        
        const sectionRenders = this.sections.map((section) => {
          const url = `${basePath}?section_id=${section.sectionId}&${searchParams}`;
          const cachedSectionUrl = (cachedSection) => cachedSection.url === url;

          return this.cachedSections.some(cachedSectionUrl)
            ? this.renderSectionFromCache(cachedSectionUrl, section)
            : this.renderSectionFromFetch(url, section);
        });

        if (updateURLHash) this.updateURLHash(searchParams, tempPart);

        return Promise.all(sectionRenders);
      },

      renderSectionFromCache: function (url, section) {
        const cachedSection = this.cachedSections.find(url);

        this.log(
          `[AjaxRenderer] rendering from cache: url=${cachedSection.url}`
        );
        this.renderSection(cachedSection.html, section);
        return Promise.resolve(section);
      },

      renderSectionFromFetch: function (url, section) {
        this.log(`[AjaxRenderer] redering from fetch: url=${url}`);

        return new Promise((resolve, reject) => {
          fetch(url)
            .then((response) => response.text())
            .then((responseText) => {
              const html = responseText;
              this.cachedSections = [...this.cachedSections, { html, url }];
              this.renderSection(html, section);
              resolve(section);
            })
            .catch((err) => reject(err));
        });
      },

      renderSection: function (html, section) {
        this.log(
          `[AjaxRenderer] rendering section: section=${JSON.stringify(section)}`
        );

        const newDom = new DOMParser().parseFromString(html, "text/html");
        if (this.onReplace) {
          this.onReplace(newDom, section);
        } else {
          if (typeof section.nodeId === "string") {
            var newContentEl = newDom.getElementById(section.nodeId);
            if (!newContentEl) {
              return;
            }

            document.getElementById(section.nodeId).innerHTML =
              newContentEl.innerHTML;
          } else {
            section.nodeId.forEach((id) => {
              document.getElementById(id).innerHTML =
                newDom.getElementById(id).innerHTML;
            });
          }
        }

        return section;
      },

      appendPreservedParams: function (searchParams) {
        this.preserveParams.forEach((paramName) => {
          const param = new URLSearchParams(window.location.search).get(
            paramName
          );

          if (param) {
            this.log(`[AjaxRenderer] Preserving ${paramName} param`);
            searchParams.append(paramName, param);
          }
        });
      },

      updateURLHash: function (searchParams, tempPart='') {
        var testUrl = window.location.href;
        if (testUrl.indexOf('?convert_action') !== -1 || testUrl.indexOf('&convert_action') !== -1) {
          var urlParts = testUrl.split('?');
          var queryString = urlParts[1];
          var params = queryString.split('&');

          // Loop through each parameter to check if "convert_action" exists
          var convertActionExists = false;
          $.each(params, function(index, param) {
              var paramParts = param.split('=');
              if (paramParts[0] === 'convert_v') {
                if(paramParts[1] == '1004235035'){
                  setTimeout(function(){
                    $('.collaction-filter-styles').removeClass('collaction-filter-v3');
                    $('.collaction-filter-styles').addClass('collaction-filter-v6');
                  }, 1000);
                }
                if(paramParts[1] == '1004235034'){
                  setTimeout(function(){
                    $('.collaction-filter-styles').removeClass('collaction-filter-v3');
                    $('.collaction-filter-styles').addClass('collaction-filter-v5');
                  }, 1000);
                }
                if(paramParts[1] == '1004235033'){
                  setTimeout(function(){
                    $('.collaction-filter-styles').removeClass('collaction-filter-v3');
                    $('.collaction-filter-styles').addClass('collaction-filter-v4');
                  }, 1000);
                }
                if(paramParts[1] == '1004235036'){
                  setTimeout(function(){
                    $('.collaction-filter-styles').removeClass('collaction-filter-v3');
                    $('.collaction-filter-styles').addClass('collaction-filter-v7');
                  }, 1000);
                }
              }
          });
        }

        if(tempPart != ''){
          setTimeout(function(){
            $('.collaction-filter-styles').removeClass('collaction-filter-v3');
            $('.collaction-filter-styles').addClass(tempPart);
          }, 1000);
        }
        
        history.pushState(
          {},
          "",
          `${window.location.pathname}${
            searchParams && "?".concat(searchParams)
          }`
        );
      },

      log: function (...args) {
        if (this.debug) {
          console.log(...args);
        }
      },
    });

    return AjaxRenderer;
  })();

  if (
    window.Shopify &&
    window.Shopify.theme &&
    navigator &&
    navigator.sendBeacon &&
    window.Shopify.designMode
  ) {
    navigator.sendBeacon(
      "https://api.archetypethemes.co/api/beacon",
      new URLSearchParams({
        shop: window.Shopify.shop,
        themeName: window.Shopify.theme.name,
        role: window.Shopify.theme.role,
        route: window.location.pathname,
        themeId: window.Shopify.theme.id,
        themeStoreId: window.Shopify.theme.theme_store_id || 0,
        isThemeEditor: !!window.Shopify.designMode,
      })
    );
  }
  theme.cart = {
    getCart: function () {
      var url = "".concat(theme.routes.cart, "?t=").concat(Date.now());
      return fetch(url, {
        credentials: "same-origin",
        method: "GET",
      }).then((response) => response.json());
    },

    getCartProductMarkup: function () {
      var url = "".concat(theme.routes.cartPage, "?t=").concat(Date.now());

      url = url.indexOf("?") === -1 ? url + "?view=ajax" : url + "&view=ajax";

      return fetch(url, {
        credentials: "same-origin",
        method: "GET",
      }).then(function (response) {
        return response.text();
      });
    },

    changeFreeItem: function (key, qty) {
      console.log("key====>" + key);

      return this._updateCart({
        url: "".concat(theme.routes.cartChange, "?t=").concat(Date.now()),
        data: JSON.stringify({
          id: key,
          quantity: qty,
        }),
      });
    },

    changeItem: function (key, qty) {
      console.log("key====>" + key);
      var keyArr = key.split(":");
      key = keyArr[0];
      if(jQuery('[data-pid="'+key+'"]').length!=0){
        jQuery('[data-pid="'+key+'"]').show();
      }
      return this._updateCart({
        url: "".concat(theme.routes.cartChange, "?t=").concat(Date.now()),
        data: JSON.stringify({
          id: key,
          quantity: qty,
        }),
      });
    },

    _updateCart: function (params) {
      return fetch(params.url, {
        method: "POST",
        body: params.data,
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
      })
        .then((response) => response.json())
        .then(function (cart) {
          return cart;
        });
    },

    updateAttribute: function (key, value) {
      return this._updateCart({
        url: "/cart/update.js",
        data: JSON.stringify({
          attributes: {
            [key]: theme.cart.attributeToString(value),
          },
        }),
      });
    },

    updateNote: function (note) {
      return this._updateCart({
        url: "/cart/update.js",
        data: JSON.stringify({
          note: theme.cart.attributeToString(note),
        }),
      });
    },

    attributeToString: function (attribute) {
      if (typeof attribute !== "string") {
        attribute += "";
        if (attribute === "undefined") {
          attribute = "";
        }
      }
      return attribute.trim();
    },
  };

  /*============================================================================
    CartForm
    - Prevent checkout when terms checkbox exists
    - Listen to quantity changes, rebuild cart (both widget and page)
  ==============================================================================*/
  theme.CartForm = (function () {
    var selectors = {
      products: "[data-products]",
      qtySelector: ".js-qty__wrapper",
      discounts: "[data-discounts]",
      compare: "[data-compare]",
      savings: "[data-savings]",
      subTotal: "[data-subtotal]",
      //subTotalStyle: '.data-subtotal-style',

      cartBubble: ".cart-link__bubble",
      cartNote: '[name="note"]',
      termsCheckbox: ".cart__terms-checkbox",
      checkoutBtn: ".cart__checkout",
    };

    var classes = {
      btnLoading: "btn--loading",
    };

    var config = {
      requiresTerms: false,
    };

    function CartForm(form) {
      if (!form) {
        return;
      }

      this.form = form;
      this.wrapper = form.parentNode;
      this.location = form.dataset.location;
      this.namespace = ".cart-" + this.location;
      this.products = form.querySelector(selectors.products);
      this.submitBtn = form.querySelector(selectors.checkoutBtn);

      this.discounts = form.querySelector(selectors.discounts);
      this.savings = form.querySelector(selectors.savings);
      this.compare = form.querySelector(selectors.compare);
      this.subtotal = form.querySelector(selectors.subTotal);
      //this.subTotalStyle = form.querySelector(selectors.subTotalStyle);
      this.termsCheckbox = form.querySelector(selectors.termsCheckbox);
      this.noteInput = form.querySelector(selectors.cartNote);

      if (this.termsCheckbox) {
        config.requiresTerms = true;
      }

      this.init();
    }

    CartForm.prototype = Object.assign({}, CartForm.prototype, {
      init: function () {
        this.initQtySelectors();

        document.addEventListener(
          "cart:quantity" + this.namespace,
          this.quantityChanged.bind(this)
        );

        this.form.on("submit" + this.namespace, this.onSubmit.bind(this));

        if (this.noteInput) {
          this.noteInput.addEventListener("change", function () {
            var newNote = this.value;
            theme.cart.updateNote(newNote);
          });
        }

        // Dev-friendly way to build the cart
        document.addEventListener(
          "cart:build",
          function () {
            this.buildCart();
          }.bind(this)
        );
      },

      reInit: function () {
        this.initQtySelectors();
      },

      onSubmit: function (evt) {
        this.submitBtn.classList.add(classes.btnLoading);

        if (config.requiresTerms) {
          if (this.termsCheckbox.checked) {
            // continue to checkout
          } else {
            alert(theme.strings.cartTermsConfirmation);
            this.submitBtn.classList.remove(classes.btnLoading);
            evt.preventDefault();
            return false;
          }
        }
      },

      /*============================================================================
        Query cart page to get markup
      ==============================================================================*/
      _parseProductHTML: function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, "text/html");
        return {
          items: doc.querySelector(".cart__items"),
          discounts: doc.querySelector(".cart__discounts"),
        };
      },

      buildCart: function () {
        theme.cart.getCartProductMarkup().then(this.cartMarkup.bind(this));
      },

      cartMarkup: function (html) {
        var markup = this._parseProductHTML(html);
        var items = markup.items;
        var count = parseInt(items.dataset.count);
        var subtotal = items.dataset.cartSubtotal;
        var savings = items.dataset.cartSavings;

        this.updateCartDiscounts(markup.discounts);
        this.updateSavings(savings);

        if (count > 0) {
          this.wrapper.classList.remove("is-empty");
        } else {
          this.wrapper.classList.add("is-empty");
        }

        this.updateCount(count);

        // Append item markup
        this.products.innerHTML = "";
        this.products.append(items);

        // Update subtotal

        this.subtotal.innerHTML = theme.Currency.formatMoney(
          subtotal,
          theme.settings.moneyFormat
        );
        //this.subTotalStyle.innerHTML = theme.Currency.formatMoney(subtotal, theme.settings.moneyFormat);

        let savingsHtml = this.savings;
        let compareHtml = this.compare;
        $(".cartitem-discount-v1").html("");
        $(".cartitem-discount-v2").html("");
        $(".cartitem-discount-v3").html("");
        if (parseFloat(subtotal) > 0) {
          subtotal = parseFloat(subtotal) / 100;

          // Custom
          $.ajax({
            url: "/cart",
            dataType: "json",
            error: function (items) {
              //console.error(items[0]);
              loadingBarTrigger("done");
            },
            success: function (cart) {
              $(".custom--upsell-item").removeClass("hide");
              let upsell_1ID = $(".upsell_1_id").attr("product--id");
              let upsell_2ID = $(".upsell_2_id").attr("product--id");
              let upsell_3ID = $(".upsell_3_id").attr("product--id");
              let upsell_4ID = $(".upsell_4_id").attr("product--id");
              let mainCartItems = cart.items;

              let original_total_price = cart.original_total_price;
              let items_subtotal_price = cart.items_subtotal_price;
              var totalCents = cart.total_price;
              if (original_total_price > 0) {
                var amount = theme.Currency.formatMoney(
                  original_total_price,
                  theme.settings.moneyFormat
                );
                compareHtml.innerHTML = amount;

                savingsHtml.innerHTML =
                  "(Save " +
                  theme.Currency.formatMoney(
                    original_total_price - items_subtotal_price,
                    theme.settings.moneyFormat
                  ) +
                  ")";
              }

              let totalCompare1 = 0;
              let requests1 = [];

              cart.items.forEach(function(item){
                if(item.original_line_price === item.final_line_price){
                  let req1 = $.getJSON('/products/' + item.handle + '.js', function(product){
                    let variant = product.variants.find(v => v.id == item.variant_id);
                    if(variant){
                      let comparePrices1 = variant.compare_at_price || variant.price;
                      totalCompare1 += comparePrices1 * item.quantity;
                    }
                  });
                  requests1.push(req1);
                }
              });

              $.when.apply($, requests1).then(function(){
                if (totalCompare1 > 0) {
                  var savingsHtml1 =
                    theme.Currency.formatMoney(
                      (totalCompare1 - totalCents),
                      theme.settings.moneyFormat
                    );
                  var setComparePrice1 = theme.Currency.formatMoney(
                      (totalCompare1),
                      theme.settings.moneyFormat
                    );
                  var totalPriceAb =  theme.Currency.formatMoney(totalCents,theme.settings.moneyFormat);
                  if(jQuery('.cart__item__subtotal').find('.ajaxcart__totalprice .saving-total').length>0){
                    jQuery('.cart__item__subtotal').find('.ajaxcart__totalprice .saving-total').text(`${savingsHtml1}`);
                  }
                  if(jQuery('.cart-checkout-button-box.for-ab-test').find('.checkout-total-compare').length>0){
                    jQuery('.cart-checkout-button-box.for-ab-test').find('.checkout-total-compare').text(`${setComparePrice1}`);
                  }
                  if(jQuery('.cart-checkout-button-box.for-ab-test').find('.checkout_total_price').length>0){
                    jQuery('.cart-checkout-button-box.for-ab-test').find('.checkout_total_price').text(`${totalPriceAb}`);
                  }
                }
              });


              let found_package_in_cart = false;
              let line_item_id = null;
              let chkFlashCode = "";
              let chkFlashCodeTitle = "";
              let chkDiscountType = "";
              let strapCheck = 0;
              let productCount = 0;
              let countProduct = 0;
              let roseGoldPrice=0;
              let cartCancerAmount=0;
              let mainCancerAmount=(2.75*100);
              jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap').hide();
              jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap').removeClass('show-bogo');
              for (var i = 0; i < mainCartItems.length; i++) {
                if (mainCartItems[i].discounts.length > 0) {
                  for (var d = 0; d < mainCartItems[i].discounts.length; d++) {
                    if (mainCartItems[i].discounts[d].title == "FLASH24" || mainCartItems[i].discounts[d].title == "BOGO-FLASH") {
                      chkDiscountType = "1";
                    }
                    if (mainCartItems[i].discounts[d].title == "B2G3FLASH" || mainCartItems[i].discounts[d].title == "B2G3-FLASH") {
                      chkDiscountType = "2";
                    }
                    if (mainCartItems[i].discounts[d].title == "B3G4FLASH" || mainCartItems[i].discounts[d].title == "B3G4-FLASH") {
                      chkDiscountType = "3";
                    }
                    if (
                      mainCartItems[i].discounts[d].title == "FLASH24" ||
                      mainCartItems[i].discounts[d].title == "B2G3FLASH" ||
                      mainCartItems[i].discounts[d].title == "B3G4FLASH" ||
                      mainCartItems[i].discounts[d].title == "BOGO-FLASH" ||
                      mainCartItems[i].discounts[d].title == "B2G3-FLASH" ||
                      mainCartItems[i].discounts[d].title == "B3G4-FLASH" ||
                      mainCartItems[i].discounts[d].title == "B2G1"
                    ) {
                      chkFlashCode = 1;
                      chkFlashCodeTitle = mainCartItems[i].discounts[d].title;
                    }
                  }
                }
                if (mainCartItems[i] != undefined) {
                  var productTitle = mainCartItems[i].title.toLowerCase();
                  if(productTitle && productTitle.includes('strap') && !productTitle.includes('strap bag')) {
                    strapCheck = 1;
                    productCount+=mainCartItems[i].quantity;
                  }
                  if(mainCartItems[i].variant_title!=null){
                    var titleVariant = mainCartItems[i].variant_title.toLowerCase();
                    if(titleVariant && titleVariant.includes('rose gold')) {
                      roseGoldPrice+=(mainCartItems[i].discounted_price * mainCartItems[i].quantity);
                      mainCancerAmount=(mainCancerAmount);
                      cartCancerAmount+=(mainCancerAmount*mainCartItems[i].quantity);
                    }
                  }
                  //console.log("iiiiii",titleVariant);
                }
                if(productCount>=5){
                  chkFlashCode = 1;
                }
                console.log("upsell_1ID",upsell_1ID,upsell_2ID);
                countProduct++;
                line_item_id = mainCartItems[i].product_id;
                if (
                  line_item_id == upsell_1ID ||
                  line_item_id == upsell_2ID ||
                  line_item_id == upsell_3ID ||
                  line_item_id == upsell_4ID
                ) {
                  $(
                    ".custom--upsell-item[product--id=" + line_item_id + "]"
                  ).addClass("hide");
                }
              }
              console.log("chkFlashCode", productCount);
              if(jQuery('body.new_offer_progress').find('.offer-box-wrapper').length>0){
                objFlash = jQuery('body.new_offer_progress').find('.offer-box-wrapper.code-bogo-offer-vcommon');
                jQuery('.cart__drawer').find('.offer-box-wrapper.code-bogo-offer-vcommon').removeClass('hidden-bogo');
                defaultProgress=1;
              }
              /* For BOGO snnippet product page */
              $(".bf_progressbar_list").removeClass(
                "bf_progressbar_list_complate_one"
              );
              $(".bf_progressbar_list").removeClass(
                "bf_progressbar_list_complate"
              );
              $("#bogo_sn1_v3").prop("checked", false);
              $("#bogo_sn2_v3").prop("checked", false);
              $("#bogo_sn3_v3").prop("checked", false);
              if (chkDiscountType == 1) {
                $("#bogo_sn1_v3").prop("checked", true);
                $(".bf_progressbar_list_v1").addClass(
                  "bf_progressbar_list_complate_one"
                );
              }
              if (chkDiscountType == 2) {
                $("#bogo_sn1_v3").prop("checked", true);
                $("#bogo_sn2_v3").prop("checked", true);
                $(".bf_progressbar_list_v1").addClass(
                  "bf_progressbar_list_complate_one"
                );
                $(".bf_progressbar_list_v1").addClass(
                  "bf_progressbar_list_complate"
                );
                $(".bf_progressbar_list_v2").addClass(
                  "bf_progressbar_list_complate_one"
                );
              }
              if (chkDiscountType == 3) {
                $("#bogo_sn1_v3").prop("checked", true);
                $("#bogo_sn2_v3").prop("checked", true);
                $("#bogo_sn3_v3").prop("checked", true);
                $(".bf_progressbar_list_v1").addClass(
                  "bf_progressbar_list_complate_one"
                );
                $(".bf_progressbar_list_v1").addClass(
                  "bf_progressbar_list_complate"
                );
                $(".bf_progressbar_list_v2").addClass(
                  "bf_progressbar_list_complate_one"
                );
                $(".bf_progressbar_list_v2").addClass(
                  "bf_progressbar_list_complate"
                );
                $(".bf_progressbar_list_v3").addClass(
                  "bf_progressbar_list_complate_one"
                );
              }
              /* For BOGO snnippet product page */

              if (chkFlashCode == 1) {
                var discountLable = "BUY 1 GET 1 FREE COUPON APPLIED";
                var discountLable2 = "BUY 1 GET 1 FREE";
                if (chkFlashCodeTitle == "B2G3FLASH" || chkFlashCodeTitle == "B2G3-FLASH") {
                  discountLable = "BUY 2 GET 3 FREE COUPON APPLIED";
                  discountLable2 = "BUY 2 GET 3 FREE";
                } else if (chkFlashCodeTitle == "B3G4FLASH" || chkFlashCodeTitle == "B3G4-FLASH") {
                  discountLable = "BUY 3 GET 4 FREE COUPON APPLIED";
                  discountLable2 = "BUY 3 GET 4 FREE";
                }else if (chkFlashCodeTitle == "B2G1") {
                  discountLable = "BUY 2 GET 1 FREE COUPON APPLIED";
                  discountLable2 = "BUY 2 GET 1 FREE";
                }else if (productCount>=5){
                  discountLable = "5 FOR $150 APPLIED";
                  discountLable2 = "5 FOR $150";
                }

                var cartDiscountStyle3 =
                  '<div class="cart__discounts cart__item-sub cart__item-row">';
                cartDiscountStyle3 += '<div class="discount__info text-right">';
                cartDiscountStyle3 += '<div class="cart__discount Discounts">';
                cartDiscountStyle3 +=
                  '<svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none">';
                cartDiscountStyle3 +=
                  '<path d="M3.3125 15.7109C3.3125 16.0221 3.56387 16.2734 3.875 16.2734H8.90234V9.66406H3.3125V15.7109ZM10.0977 16.2734H15.125C15.4361 16.2734 15.6875 16.0221 15.6875 15.7109V9.66406H10.0977V16.2734ZM15.9688 5.44531H13.3742C13.6133 5.06914 13.7539 4.62266 13.7539 4.14453C13.7539 2.80684 12.6658 1.71875 11.3281 1.71875C10.6004 1.71875 9.94473 2.04219 9.5 2.55195C9.05527 2.04219 8.39961 1.71875 7.67188 1.71875C6.33418 1.71875 5.24609 2.80684 5.24609 4.14453C5.24609 4.62266 5.38496 5.06914 5.62578 5.44531H3.03125C2.72012 5.44531 2.46875 5.69668 2.46875 6.00781V8.46875H8.90234V5.44531H10.0977V8.46875H16.5312V6.00781C16.5312 5.69668 16.2799 5.44531 15.9688 5.44531ZM8.90234 5.375H7.67188C6.99336 5.375 6.44141 4.82305 6.44141 4.14453C6.44141 3.46602 6.99336 2.91406 7.67188 2.91406C8.35039 2.91406 8.90234 3.46602 8.90234 4.14453V5.375ZM11.3281 5.375H10.0977V4.14453C10.0977 3.46602 10.6496 2.91406 11.3281 2.91406C12.0066 2.91406 12.5586 3.46602 12.5586 4.14453C12.5586 4.82305 12.0066 5.375 11.3281 5.375Z" fill="white"></path>';
                cartDiscountStyle3 += "</svg>";
                cartDiscountStyle3 += "<span>" + discountLable + "</span>";
                cartDiscountStyle3 += "</div>";
                cartDiscountStyle3 += "</div>";
                cartDiscountStyle3 += "</div>";

                $(".cartitem-discount-v3").html("");
                $(".cartitem-discount-v3").append(cartDiscountStyle3);

                var cartDiscountStyle1 =
                  '<div class="cart__discounts cart__item-sub cart__item-row">';
                cartDiscountStyle1 += '<div class="discount__info text-right">';
                cartDiscountStyle1 += '<div class="cart__discount">';
                cartDiscountStyle1 +=
                  '<svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none">';
                cartDiscountStyle1 +=
                  '<path d="M5.86208 9.62424L1.375 5.13715V6.43424L5.86208 10.9213L10.0054 6.77799L9.35458 6.13174L5.86208 9.62424Z" fill="#D2A741"></path>';
                cartDiscountStyle1 +=
                  '<path d="M1.375 4.14333L5.86208 8.63042L10.0054 4.48708L5.51833 0H1.375V4.14333ZM3.32292 1.375C3.47486 1.375 3.62059 1.43536 3.72803 1.5428C3.83547 1.65025 3.89583 1.79597 3.89583 1.94792C3.89583 2.09986 3.83547 2.24559 3.72803 2.35303C3.62059 2.46047 3.47486 2.52083 3.32292 2.52083C3.17097 2.52083 3.02525 2.46047 2.9178 2.35303C2.81036 2.24559 2.75 2.09986 2.75 1.94792C2.75 1.79597 2.81036 1.65025 2.9178 1.5428C3.02525 1.43536 3.17097 1.375 3.32292 1.375Z" fill="#D2A741"></path>';
                cartDiscountStyle1 += "</svg>";
                cartDiscountStyle1 +=
                  "DISCOUNT <span>" + discountLable2 + "</span> APPLIED";
                cartDiscountStyle1 += "</div>";
                cartDiscountStyle1 += "</div>";
                cartDiscountStyle1 += "</div>";

                $(".cartitem-discount-v1").html("");
                $(".cartitem-discount-v1").append(cartDiscountStyle1);

                var cartDiscountStyle2 =
                  '<div class="cart__discounts cart__item-sub cart__item-row">';
                cartDiscountStyle2 +=
                  '<div class="discount__title">Discounts</div>';
                cartDiscountStyle2 += '<div class="discount__info text-right">';
                cartDiscountStyle2 += '<div class="cart__discount">';
                cartDiscountStyle2 +=
                  '<svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none">';
                cartDiscountStyle2 +=
                  '<path d="M5.86208 9.62424L1.375 5.13715V6.43424L5.86208 10.9213L10.0054 6.77799L9.35458 6.13174L5.86208 9.62424Z" fill="#D2A741"></path>';
                cartDiscountStyle2 +=
                  '<path d="M1.375 4.14333L5.86208 8.63042L10.0054 4.48708L5.51833 0H1.375V4.14333ZM3.32292 1.375C3.47486 1.375 3.62059 1.43536 3.72803 1.5428C3.83547 1.65025 3.89583 1.79597 3.89583 1.94792C3.89583 2.09986 3.83547 2.24559 3.72803 2.35303C3.62059 2.46047 3.47486 2.52083 3.32292 2.52083C3.17097 2.52083 3.02525 2.46047 2.9178 2.35303C2.81036 2.24559 2.75 2.09986 2.75 1.94792C2.75 1.79597 2.81036 1.65025 2.9178 1.5428C3.02525 1.43536 3.17097 1.375 3.32292 1.375Z" fill="#D2A741"></path>';
                cartDiscountStyle2 += "</svg>";
                cartDiscountStyle2 += discountLable2;
                cartDiscountStyle2 += "</div>";
                cartDiscountStyle2 += "</div>";
                cartDiscountStyle2 += "</div>";

                $(".cartitem-discount-v2").html("");
                $(".cartitem-discount-v2").append(cartDiscountStyle2);
              }
              
              /****************************************************
               * MPS-65 STRAP START OF PROGRESSBAR 
              ****************************************************/
              console.log("countProduct theme js",countProduct,mainCartItems.length);
              if(mainCartItems.length == countProduct){
                let freeShippingPrice = 80;
                let freeShippingProgressTarget = freeShippingPrice;
                if(jQuery('.drawer.cart__drawer').attr('data-goal-amount')!=null){
                  freeShippingPrice = parseInt(jQuery('.drawer.cart__drawer').attr('data-goal-amount'));
                  freeShippingProgressTarget = freeShippingPrice;
                }

                let subtotal = (items_subtotal_price/100);

                var conversionRate = Shopify.currency.rate || 1;
                freeShippingProgressTarget = Math.round(freeShippingProgressTarget * conversionRate);

                //console.log("freeShippingProgressTarget",freeShippingProgressTarget);
                let freeship = Math.round((subtotal * 100) / freeShippingProgressTarget);
                if (freeship > 100) freeship = 100;

                /* ------------------------- V1,V2: Initialization ------------------------- */
                if(jQuery('body').hasClass('offer-box-wrapper-v1') || jQuery('body').hasClass('offer-box-wrapper-v2') || jQuery('body').hasClass('offer-box-wrapper-v3') || jQuery('body').hasClass('offer-box-wrapper-v4')){
                  //console.log("hiiiiii",chkFlashCodeTitle,chkFlashCode);
                  jQuery('.delivery--progress-wrapper').find('.delivery--progress-card').removeClass('unlock');
                  var defaultProgress = 0;
                  if(jQuery('.offer-box-wrapper.code-bogo-offer-vcommon').length>0){
                    jQuery('.offer-box-wrapper.code-bogo-offer-vcommon').hide();
                  }
                  var objFlash = jQuery('body.offer-box-wrapper-v1').find('.offer-box-wrapper');
                  if(jQuery('body.offer-box-wrapper-v1').find('.offer-box-wrapper').length>0){
                    jQuery('.cart__drawer').find('.offer-box-wrapper.code-bogo-offer-vcommon').removeClass('hidden-bogo');
                    defaultProgress=1;
                  }else if(jQuery('body.offer-box-wrapper-v2').find('.offer-box-wrapper').length>0){
                    objFlash = jQuery('body.offer-box-wrapper-v2').find('.offer-box-wrapper.code-bogo-offer-vcommon');
                    jQuery('.cart__drawer').find('.offer-box-wrapper.code-bogo-offer-vcommon').removeClass('hidden-bogo');
                    defaultProgress=1;
                  }else if(jQuery('body.offer-box-wrapper-v3').find('.offer-box-wrapper').length>0){
                    objFlash = jQuery('body.offer-box-wrapper-v3').find('.offer-box-wrapper');
                    var $target = jQuery('.cart__drawer .offer-box-wrapper.code-bogo-offer-vcommon');
                    if ($target.length > 0) {
                      setTimeout(function(){
                        $target.addClass('hidden-bogo');
                      },500);
                    }
                    defaultProgress=1;
                  }else if(jQuery('body.offer-box-wrapper-v4').find('.main-delivery--progress-wrapper').length>0){
                    objFlash = jQuery('body.offer-box-wrapper-v4').find('.main-delivery--progress-wrapper');
                    var $target = jQuery('.cart__drawer .offer-box-wrapper.code-bogo-offer-vcommon');
                    if ($target.length > 0) {
                      setTimeout(function(){
                        $target.addClass('hidden-bogo');
                      },1000);
                    }
                  }
                  var goal1 = 5;
                  var goal3 = 7;
                  productCount = parseInt(productCount);
                  if (productCount > 0) {
                    objFlash.show();
                    var discountFlashBuy = "1";
                    var discountFlashFree = " 1 "; 
                    var discountMoreStrap = 1;
                    var discountStraps = 1;
                    if(productCount>=2 && productCount<5){
                      discountFlashBuy = "2";
                      discountFlashFree = " 3 "; 
                      var remaincount = (goal1-productCount);
                      discountMoreStrap = remaincount;
                      discountStraps = remaincount;
                    }else if (productCount>=5 && productCount<7) {
                      discountFlashBuy = "3";
                      discountFlashFree = " 4 "; 
                      var remaincount = (goal3-productCount);
                      discountMoreStrap = remaincount;
                      discountStraps = remaincount;
                    }else if(productCount>=7){
                      discountFlashBuy = "";
                      discountFlashFree = ""; 
                      discountMoreStrap = '';
                      discountStraps = '';
                    }
                    if(discountMoreStrap!=""){
                      if(discountMoreStrap>1){
                        discountMoreStrap=discountMoreStrap+ ' more straps';
                      }else{
                        discountMoreStrap =discountMoreStrap+ ' more strap';
                      }
                    }
                    if(objFlash.find('.offer-button').find('.text-box .buy-text').length>0){
                      objFlash.find('.offer-button').find('.text-box .buy-text').text(discountFlashBuy);
                    }
                    if(objFlash.find('.offer-button').find('.text-box .free-text').length>0){
                      objFlash.find('.offer-button').find('.text-box .free-text').text(discountFlashFree);
                    }
                    if(objFlash.find('.offer-popup strong').length>0){
                      objFlash.find('.offer-popup strong').find('span').text(discountMoreStrap);
                    }
                    if(objFlash.find('.offer-pargh.offer-boxbogo-flash').length>0){
                      objFlash.find('.offer-pargh.offer-boxbogo-flash').find('strong').text(discountMoreStrap);
                    }
                    if(discountFlashBuy=="" && (jQuery('body.offer-box-wrapper-v1').find('.offer-box-wrapper').length > 0 || jQuery('body.offer-box-wrapper-v2').find('.offer-box-wrapper').length > 0)){
                      objFlash.hide();
                    }

                    var goal1 = 5;
                    var goal3 = 7;
                    var progressPercent = 0;
                    var statusText = "";
                    productCount = parseInt(productCount);
                    console.log("goal1",goal1,productCount);
                    if(jQuery('body.offer-box-wrapper-v4').find('.main-delivery--progress-wrapper').length>0){
                      var inetrshowId = setInterval(function(){
                        console.log("chhhh",jQuery('.multi-step-form-bogo-offer').length);
                        if(jQuery('.multi-step-form-bogo-offer').length>0){
                          jQuery('.multi-step-form-bogo-offer').show();
                          clearInterval(inetrshowId);
                        }
                      },500);
                      var flagBogo = 0;
                      var goalfreeShip=0;
                      if (productCount < goal1) {
                        progressPercent = 20;
                        jQuery('.delivery--progress-wrapper').find('.delivery--progress-card.first-card').addClass('unlock');
                        jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.strap-free-text').addClass('show-bogo');
                        flagBogo = 1;
                        goalfreeShip=1;
                      }else if (productCount === goal1) {
                        progressPercent = 50;
                        console.log("progressPercent",progressPercent);
                        jQuery('.delivery--progress-wrapper').find('.delivery--progress-card.first-card').addClass('unlock');
                        jQuery('.delivery--progress-wrapper').find('.delivery--progress-card.second-card').addClass('unlock');
                        flagBogo = 1;
                        goalfreeShip=1;
                      }else if (productCount > goal1 && productCount < goal3) {
                        console.log("goal 1 reach",goal1,productCount);
                        var inetrId = setInterval(function(){
                          //if(!jQuery('.multi-step-form-bogo-offer').is(':visible')){
                            jQuery('.multi-step-form-bogo-offer').show();
                          //}
                        },500);
                        progressPercent = 75;
                        jQuery('.delivery--progress-wrapper').find('.delivery--progress-card.second-card').addClass('unlock');
                        jQuery('.delivery--progress-wrapper').find('.delivery--progress-card.first-card').addClass('unlock');
                        if(freeship<100){
                          jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.strap-free-text').addClass('show-bogo');
                          jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.strap-free-text').removeClass('hidden-bogo');
                          jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.goal-congrates-msg').hide();
                          jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.unlock-free-ship').show();
                        }else if(freeship>=100){
                          jQuery('.delivery--progress-wrapper').find('.delivery--progress-card.third-card').addClass('unlock');
                          jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.goal-congrates-msg').hide();
                          jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.strap-free-text').addClass('hidden-bogo');
                          jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.strap-free-text').removeClass('show-bogo');
                          jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.unlock-free-ship').removeAttr('style');
                        }
                        flagBogo = 1;
                      }else if (productCount >= goal3 && discountFlashBuy!="") {
                        progressPercent = 90;
                        var inetrshowId = setInterval(function(){
                        console.log("chhhh",jQuery('.multi-step-form-bogo-offer').length);
                        if(jQuery('.multi-step-form-bogo-offer').length>0){
                          jQuery('.multi-step-form-bogo-offer').show();
                          clearInterval(inetrshowId);
                        }
                      },500);
                        jQuery('.delivery--progress-wrapper').find('.delivery--progress-card.first-card').addClass('unlock');
                        jQuery('.delivery--progress-wrapper').find('.delivery--progress-card.second-card').addClass('unlock');
                        jQuery('.delivery--progress-wrapper').find('.delivery--progress-card.third-card').addClass('unlock');
                        jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.goal-congrates-msg').hide();
                        if(freeship<100){
                          jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.strap-free-text').addClass('show-bogo');
                          jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.strap-free-text').removeClass('hidden-bogo')
                        }else if(freeship>=100){
                          jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.strap-free-text').addClass('hidden-bogo');
                          jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.strap-free-text').removeClass('show-bogo');
                          jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.unlock-free-ship').show();
                        }
                      }else if (productCount >= goal3 && discountFlashBuy=="") {
                        progressPercent = 100;
                        jQuery('.delivery--progress-wrapper').find('.delivery--progress-card.first-card').addClass('unlock');
                        jQuery('.delivery--progress-wrapper').find('.delivery--progress-card.second-card').addClass('unlock');
                        jQuery('.delivery--progress-wrapper').find('.delivery--progress-card.third-card').addClass('unlock');
                        jQuery('.delivery--progress-wrapper').find('.delivery--progress-card.last-card').addClass('unlock');
                        if(freeship<100){
                          jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.strap-free-text').addClass('show-bogo');
                          jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.strap-free-text').removeClass('hidden-bogo');
                          jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.goal-congrates-msg').hide();
                        }else if(freeship>=100){
                          jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.strap-free-text').addClass('hidden-bogo');
                          jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.strap-free-text').removeClass('show-bogo');
                          jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.unlock-free-ship').hide();
                          jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.goal-congrates-msg').show();
                        }
                        var inetrshowId = setInterval(function(){
                          console.log("chhhh",jQuery('.multi-step-form-bogo-offer').length);
                          if(jQuery('.multi-step-form-bogo-offer').length>0){
                            jQuery('.multi-step-form-bogo-offer').show();
                            clearInterval(inetrshowId);
                          }
                        },500);
                      }
                      if(discountFlashFree!=""){
                        var bogoMsg = jQuery('.cart__drawer').find('.multi-step-form-bogo-offer');
                        if(bogoMsg!=undefined && bogoMsg!=""){
                          if(discountStraps == 1){
                            bogoMsg.find('.bogo-offer-strap.strap-free-text').find('.strap-count-text').text(discountStraps+' strap');
                          }else{
                            bogoMsg.find('.bogo-offer-strap.strap-free-text').find('.strap-count-text').text(discountStraps+' straps');
                          }
                        }
                      }
                      console.log("freeship",freeship,goalfreeShip);
                      if(freeship>=100 && goalfreeShip==1){
                        progressPercent = 75;
                        jQuery('.delivery--progress-wrapper').find('.delivery--progress-card.first-card').addClass('unlock');
                        jQuery('.delivery--progress-wrapper').find('.delivery--progress-card.second-card').addClass('unlock');
                        jQuery('.delivery--progress-wrapper').find('.delivery--progress-card.third-card').addClass('unlock');
                        jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.goal-congrates-msg').hide();
                        jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.strap-free-text').addClass('hidden-bogo');
                        jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.strap-free-text').removeClass('show-bogo');
                        jQuery('.multi-step-form-bogo-offer').find('.bogo-offer-strap.unlock-free-ship').removeAttr('style');
                      }
                    }else if(jQuery('body.offer-box-wrapper-v3').find('.main-delivery--progress-wrapper').length>0){
                      jQuery('.drawer.cart__drawer').find('.multi-step-form-default').addClass('bogo-offer-vthree-progress');
                      if(freeship>=100){
                        jQuery('.drawer.cart__drawer').find('.congrats-msg--n.bogo-offer-congrats').show();
                        jQuery('.drawer.cart__drawer').find('.multi-step-form-default').find('.cart-rest-msg-n.common-congrats').hide();
                      }else if(freeship<100){
                        jQuery('.drawer.cart__drawer').find('.congrats-msg--n.bogo-offer-congrats').hide();
                        jQuery('.drawer.cart__drawer').find('.multi-step-form-default').find('.cart-rest-msg-n.common-congrats').show();
                      }
                      if($('.drawer.cart__drawer').find('.progress-segment.segment-1').length>0){
                        $('.drawer.cart__drawer').find('.progress-segment.segment-1').css({
                          width: freeship + '%',
                          '--after-content': freeship + '%'
                        });
                        $('.drawer.cart__drawer').find('.progress-text').text(freeship + '%');
                        let remaining = parseFloat(((freeShippingProgressTarget - subtotal)*100));
                        remaining = Math.max(0, remaining);
                        remaining = Shopify.formatMoney(remaining);
                        remaining=remaining.replace(/.00/g, '');
                        $('.drawer.cart__drawer').find('.cart-rest-price-n').text(`${remaining}`);
                      }
                      if (productCount < goal1) {
                          progressPercent = (productCount / goal3) * 100;
                          if(progressPercent>50){
                            progressPercent = 40;
                          }
                          jQuery('.delivery--progress-wrapper').find('.delivery--progress-card.first-card').addClass('unlock');
                      } 
                      else if (productCount === goal1) {
                          progressPercent = (goal1 / goal3) * 100;
                          jQuery('.delivery--progress-wrapper').find('.delivery--progress-card.first-card').addClass('unlock');
                          jQuery('.delivery--progress-wrapper').find('.delivery--progress-card.second-card').addClass('unlock');
                      } 
                      else if (productCount > goal1 && productCount < goal3) {
                          progressPercent = (productCount / goal3) * 100;
                          jQuery('.delivery--progress-wrapper').find('.delivery--progress-card.second-card').addClass('unlock');
                          jQuery('.delivery--progress-wrapper').find('.delivery--progress-card.first-card').addClass('unlock');
                      } 
                      else if (productCount >= goal3 && discountFlashBuy!="") {
                          progressPercent = 90;
                          jQuery('.delivery--progress-wrapper').find('.delivery--progress-card.first-card').addClass('unlock');
                          jQuery('.delivery--progress-wrapper').find('.delivery--progress-card.second-card').addClass('unlock');
                      }else if (productCount >= goal3 && discountFlashBuy=="") {
                          progressPercent = 100;
                          jQuery('.delivery--progress-wrapper').find('.delivery--progress-card.first-card').addClass('unlock');
                          jQuery('.delivery--progress-wrapper').find('.delivery--progress-card.second-card').addClass('unlock');
                          jQuery('.delivery--progress-wrapper').find('.delivery--progress-card.last-card').addClass('unlock');
                      }
                    }
                    if(jQuery('.main-delivery--progress-wrapper').find('.delivery--progress-bar').length>0){
                      jQuery('.main-delivery--progress-wrapper').find('.delivery--progress-bar').css('width',progressPercent+'%');
                    }
                    if(defaultProgress==1 && jQuery('.cart__drawer').find('.multi-step-form-default').length>0){
                      jQuery('.cart__drawer').find('.multi-step-form-default').removeAttr('style');
                    }
                  }
                }else{
                  jQuery('.cart__drawer').find('.multi-step-form-2').show();
                }
                /* ------------------------- V1,V2: END ------------------------- */
                /****************************************************
                 * MPS-65 STRAP END OF STRAP PROGRESSBAR
                ****************************************************/

                

                /****************************************************
                 * BREAST CANCER SUPPORT ROSE GOLD PROGRESSBAR START
                ****************************************************/
                if(jQuery('body').hasClass('rose_gold_active')){
                  if(jQuery('.rose_gold_active').find('.cancer-support-section').is(':visible')){
                    if(jQuery('.rose_gold_active').find('.cancer-support-section').find('.progress-bar-fill').length>0 && roseGoldPrice!=0){
                      var getCancerGoal = jQuery('.rose_gold_active').find('.cancer-support-section').find('.goal-amount').attr('data-goal-amount');
                      var amountCalc = (roseGoldPrice/100);
                      var remaining = getCancerGoal - amountCalc;
                      if (remaining < 0) remaining = 0;

                      var percent = (amountCalc / getCancerGoal) * 100;
                      if (percent > 100) percent = 100;

                      percent = Math.round(percent * 100) / 100;
                      if(remaining>0){
                        remaining = (remaining*100);
                      }
                      if(percent<100){
                        jQuery('.rose_gold_active').find('.cancer-support-section').find('.progress-stats').show();
                        jQuery('.rose_gold_active').find('.cancer-support-section').find('.amount-raised').text(Shopify.formatMoney(remaining));
                      }else{
                        jQuery('.rose_gold_active').find('.cancer-support-section').find('.progress-stats').hide();
                      }
                      jQuery('.rose_gold_active').find('.cancer-support-section').find('.progress-bar-fill').css('width',percent+'%');
                    }else if(roseGoldPrice==0){
                      jQuery('.rose_gold_active').find('.cancer-support-section.cancer-support-vvtwo').hide();
                    }
                  }
                  if(jQuery('.drawer.cart__drawer').find('.cancer-support-section.cancer-support-cart').is(':visible') && cartCancerAmount!=0){
                    jQuery('.drawer.cart__drawer').find('.cancer-support-section.cancer-support-cart').find('.cancer-support-subtitle strong').text(Shopify.formatMoney(cartCancerAmount)); 
                  }
                  
                }
                /****************************************************
                 * BREAST CANCER SUPPORT ROSE GOLD PROGRESSBAR END
                ****************************************************/

                 /****************************************************
                 * NEW OFFER PROGRESSBAR START 27-MAR-2026 (Q1 CART AB TEST)
                ****************************************************/
                /*if(jQuery('body').hasClass('new_offer_progress')){
                  if(jQuery('.cart__drawer').find('.cart-offer-block-wrapper').find('.cart-progress').length>0){
                    var goal1 = 4;
                    var goal3 = 5;
                    console.log("productCount addtocart",productCount,strapCheck);
                    if (strapCheck == 1) {
                      objFlash.show();
                      var discountFlashBuy = "2";
                      var discountFlashFree = " Get 2 "; 
                      var discountMoreStrap = 1;
                      var discountStraps = 1;
                      if(productCount>=1 && productCount<4){
                        discountFlashBuy = "2";
                        discountFlashFree = " Get 2 "; 
                        var remaincount = (goal1-productCount);
                        discountMoreStrap = remaincount;
                        discountStraps = remaincount;
                        objFlash.find('.offer-button').find('.text-box .free-static-text').show(); 
                        if(objFlash.find('.offer-popup').find('.free-desc-text').length>0){
                          objFlash.find('.offer-popup').find('.free-desc-text').show();
                          objFlash.find('.offer-popup').find('.fivestrap-desc-text').hide();
                        }
                      }else if(productCount>=4 && productCount<5){
                        discountFlashBuy = "5";
                        discountFlashFree = " Pay $150 ";
                        objFlash.find('.offer-button').find('.text-box .free-static-text').hide(); 
                        var remaincount = (goal3-productCount);
                        discountMoreStrap = remaincount;
                        discountStraps = remaincount;
                        if(objFlash.find('.offer-popup').find('.free-desc-text').length>0){
                          objFlash.find('.offer-popup').find('.free-desc-text').hide();
                          objFlash.find('.offer-popup').find('.fivestrap-desc-text').show();
                        }
                      }else if (productCount>=5) {
                        discountFlashBuy = "";
                        discountFlashFree = ""; 
                        discountMoreStrap = '';
                        discountStraps = '';
                        if(objFlash.find('.offer-button').find('.text-box .free-static-text').length>0){
                          objFlash.find('.offer-button').find('.text-box .free-static-text').hide();
                        }
                        if(objFlash.find('.offer-popup').find('.free-desc-text').length>0){
                          objFlash.find('.offer-popup').find('.free-desc-text').hide();
                          objFlash.find('.offer-popup').find('.fivestrap-desc-text').show();
                        }
                      }
                      if(productCount>0){
                        var stringset = 'is';
                        if(discountMoreStrap!=""){
                          if(discountMoreStrap>1){
                            discountMoreStrap=discountMoreStrap+ ' more straps';
                            stringset = 'are';
                          }else{
                            discountMoreStrap=discountMoreStrap+ ' more strap';
                          }
                        }
                        if(objFlash.find('.offer-button').find('.text-box .buy-text').length>0){
                          objFlash.find('.offer-button').find('.text-box .buy-text').text(discountFlashBuy);
                        }
                        if(objFlash.find('.offer-button').find('.text-box .free-text').length>0){
                          if(discountFlashFree == ' Pay $150 '){
                            var rawPrice = 150;
                            var rate = parseFloat(Shopify.currency.rate);
                            var converted = (rawPrice * rate).toFixed(2);

                            var convertPrice = Shopify.formatMoney(converted * 100, Shopify.currency.active_format);
                          }
                          console.log("discountFlashFree--->", convertPrice)
                          if(discountFlashFree!=""){
                            objFlash.find('.offer-button').find('.text-box .free-text').text(discountFlashFree);
                          }else{
                            objFlash.find('.offer-button').find('.text-box .free-text').text(' Pay '+convertPrice);
                          }
                        }
                        if(objFlash.find('.offer-popup strong').length>0){
                          objFlash.find('.offer-popup strong').text(discountMoreStrap);
                        }
                        if(objFlash.find('.offer-popup .two-step-text').length>0){
                          objFlash.find('.offer-popup .two-step-text').text(stringset);
                        }
                        if(discountFlashBuy=="" && jQuery('body.new_offer_progress').find('.offer-box-wrapper').length > 0){
                          objFlash.hide();
                        }
                      }else{
                        objFlash.hide();
                      }
                    }else{
                      objFlash.hide();
                    }

                    if(jQuery('.new_offer_progress').find('.cartitem-discount-v1.top').length>0){
                      jQuery('.new_offer_progress').find('.cartitem-discount-v1.top').hide();
                    }
                    var goal1 = 4;
                    var goal3 = 5;
                    var progressPercent = 0;
                    var statusText = "";
                    productCount = parseInt(productCount);
                    //console.log("goal1",goal1,productCount);
                    jQuery('.cart-progress-wrapper').find('.offer-block').addClass('lock');
                    //jQuery('.drawer.cart__drawer').find('.common-offer-congrats').hide();
                    if($('.drawer.cart__drawer').find('.progress-segment.segment-1').length>0){
                      $('.drawer.cart__drawer').find('.progress-text').text(freeship + '%');
                      let remaining = parseFloat(((freeShippingProgressTarget - subtotal)*100));
                      remaining = Math.max(0, remaining);
                      remaining = Shopify.formatMoney(remaining);
                      remaining=remaining.replace(/.00/g, '');
                      $('.drawer.cart__drawer').find('.cart-rest-price-n').text(`${remaining}`);
                    }
                    if(freeship>=100){
                      $('.drawer.cart__drawer').find('.cart-offer-block-wrapper').find('.offer-cart-msg-ship').hide();
                      if (productCount < goal1) {
                          // progressPercent = (productCount / goal3) * 100;
                          // if(progressPercent>50){
                          //   progressPercent = 40;
                          // }
                          var totalRequired = goal1 + goal3;
                          progressPercent = (goal1 / totalRequired) * 100;

                          jQuery('.cart-progress-wrapper').find('.offer-block.first-lock').removeClass('lock');
                          if(freeship>=100){
                            jQuery('.drawer.cart__drawer').find('.congrats-offer-msg-n').show();
                          }else{
                            jQuery('.drawer.cart__drawer').find('.offer-cart-msg-ship').show();
                          }
                      }
                      else if (productCount === goal1) {
                        progressPercent = (goal1 / goal3) * 100;
                        if(jQuery('.cart-progress-wrapper').find('.offer-block').length>0){
                          jQuery('.cart-progress-wrapper').find('.offer-block.first-lock').removeClass('lock');
                          jQuery('.cart-progress-wrapper').find('.offer-block.second-lock').removeClass('lock');
                        }
                        jQuery('.drawer.cart__drawer').find('.congrats-offer-msg-n').hide();
                        if(freeship>=100){
                          var remaincount = (goal3-productCount);
                          jQuery('.drawer.cart__drawer').find('.offer-info-text.strap-info-msg').find('.strap-msgcount').text(remaincount);
                        }
                        if(jQuery('.new_offer_progress').find('.cartitem-discount-v1.top').length>0){
                          jQuery('.new_offer_progress').find('.cartitem-discount-v1.top').show();
                        }
                        if(jQuery('.drawer.cart__drawer').find('.congrats-offer-buytwo-msg-n').length>0){
                          jQuery('.drawer.cart__drawer').find('.congrats-offer-buytwo-msg-n').show();
                        }
                      } 
                      else if (productCount > goal1 && productCount < goal3) {
                        progressPercent = (productCount / goal3) * 100;
                        jQuery('.cart-progress-wrapper').find('.offer-block.first-lock').removeClass('lock');
                        jQuery('.cart-progress-wrapper').find('.offer-block.second-lock').removeClass('lock');
                        jQuery('.drawer.cart__drawer').find('.offer-info-text.strap-info-msg').show();
                        if(freeship>=100){
                          var remaincount = (goal3-productCount);
                          jQuery('.drawer.cart__drawer').find('.offer-info-text.strap-info-msg').find('.strap-msgcount').text(remaincount);
                        }
                        if(jQuery('.drawer.cart__drawer').find('.congrats-offer-buytwo-msg-n').length>0){
                          jQuery('.drawer.cart__drawer').find('.congrats-offer-buytwo-msg-n').hide();
                        }
                        if(jQuery('.new_offer_progress').find('.cartitem-discount-v1.top').length>0){
                          jQuery('.new_offer_progress').find('.cartitem-discount-v1.top').show();
                        }
                      } 
                      else if (productCount >= goal3) {
                        progressPercent = 100;
                        jQuery('.cart-progress-wrapper').find('.offer-block').removeClass('lock');
                        jQuery('.drawer.cart__drawer').find('.congrats-five-offer-msg-n').show();
                        if(jQuery('.new_offer_progress').find('.cartitem-discount-v1.top').length>0){
                          jQuery('.new_offer_progress').find('.cartitem-discount-v1.top').show();
                        }
                      }
                      //console.log("set progress",progressPercent);
                      jQuery('.cart__drawer').find('.cart-offer-block-wrapper').find('.cart-progress').css('width',progressPercent+'%');
                      
                    }else{
                      $('.drawer.cart__drawer').find('.cart-offer-block-wrapper').find('.offer-cart-msg-ship').show();
                      jQuery('.cart__drawer').find('.cart-offer-block-wrapper').find('.cart-progress').css('width','0%');
                    }
                  }
                }*/
                /****************************************************
                 * NEW OFFER PROGRESSBAR END 27-MAR-2026
                ****************************************************/

                /****************************************************
                 * NEW OFFER PROGRESSBAR START
                ****************************************************/
                /*if(jQuery('body').hasClass('new_offer_progress')){
                  if(jQuery('.cart__drawer').find('.cart-offer-block-wrapper').find('.cart-progress').length>0){
                    var goal1 = 4;
                    var goal3 = 5;
                    console.log("productCount addtocart",productCount,strapCheck);
                    if (strapCheck == 1) {
                      objFlash.show();
                      var discountFlashBuy = "2";
                      var discountFlashFree = " Get 2 "; 
                      var discountMoreStrap = 1;
                      var discountStraps = 1;
                      if(productCount>=1 && productCount<4){
                        discountFlashBuy = "2";
                        discountFlashFree = " Get 2 "; 
                        var remaincount = (goal1-productCount);
                        discountMoreStrap = remaincount;
                        discountStraps = remaincount;
                        objFlash.find('.offer-button').find('.text-box .free-static-text').show(); 
                        if(objFlash.find('.offer-popup').find('.free-desc-text').length>0){
                          objFlash.find('.offer-popup').find('.free-desc-text').show();
                          objFlash.find('.offer-popup').find('.fivestrap-desc-text').hide();
                        }
                      }else if(productCount>=4 && productCount<5){
                        discountFlashBuy = "5";
                        discountFlashFree = " Pay $150 ";
                        objFlash.find('.offer-button').find('.text-box .free-static-text').hide(); 
                        var remaincount = (goal3-productCount);
                        discountMoreStrap = remaincount;
                        discountStraps = remaincount;
                        if(objFlash.find('.offer-popup').find('.free-desc-text').length>0){
                          objFlash.find('.offer-popup').find('.free-desc-text').hide();
                          objFlash.find('.offer-popup').find('.fivestrap-desc-text').show();
                        }
                      }else if (productCount>=5) {
                        discountFlashBuy = "";
                        discountFlashFree = ""; 
                        discountMoreStrap = '';
                        discountStraps = '';
                        if(objFlash.find('.offer-button').find('.text-box .free-static-text').length>0){
                          objFlash.find('.offer-button').find('.text-box .free-static-text').hide();
                        }
                        if(objFlash.find('.offer-popup').find('.free-desc-text').length>0){
                          objFlash.find('.offer-popup').find('.free-desc-text').hide();
                          objFlash.find('.offer-popup').find('.fivestrap-desc-text').show();
                        }
                      }
                      if(productCount>0){
                        var stringset = 'is';
                        if(discountMoreStrap!=""){
                          if(discountMoreStrap>1){
                            discountMoreStrap=discountMoreStrap+ ' more straps';
                            stringset = 'are';
                          }else{
                            discountMoreStrap=discountMoreStrap+ ' more strap';
                          }
                        }
                        if(objFlash.find('.offer-button').find('.text-box .buy-text').length>0){
                          objFlash.find('.offer-button').find('.text-box .buy-text').text(discountFlashBuy);
                        }
                        if(objFlash.find('.offer-button').find('.text-box .free-text').length>0){
                          if(discountFlashFree == ' Pay $150 '){
                            var rawPrice = 150;
                            var rate = parseFloat(Shopify.currency.rate);
                            var converted = (rawPrice * rate).toFixed(2);

                            var convertPrice = Shopify.formatMoney(converted * 100, Shopify.currency.active_format);
                          }
                          console.log("discountFlashFree--->", convertPrice)
                          if(discountFlashFree!=""){
                            objFlash.find('.offer-button').find('.text-box .free-text').text(discountFlashFree);
                          }else{
                            objFlash.find('.offer-button').find('.text-box .free-text').text(' Pay '+convertPrice);
                          }
                        }
                        if(objFlash.find('.offer-popup strong').length>0){
                          objFlash.find('.offer-popup strong').text(discountMoreStrap);
                        }
                        if(objFlash.find('.offer-popup .two-step-text').length>0){
                          objFlash.find('.offer-popup .two-step-text').text(stringset);
                        }
                        if(discountFlashBuy=="" && jQuery('body.new_offer_progress').find('.offer-box-wrapper').length > 0){
                          objFlash.hide();
                        }
                      }else{
                        objFlash.hide();
                      }
                    }else{
                      objFlash.hide();
                    }

                    if(jQuery('.new_offer_progress').find('.cartitem-discount-v1.top').length>0){
                      jQuery('.new_offer_progress').find('.cartitem-discount-v1.top').hide();
                    }
                    var goal1 = 4;
                    var goal3 = 5;
                    var progressPercent = 0;
                    var statusText = "";
                    productCount = parseInt(productCount);
                    //console.log("goal1",goal1,productCount);
                    jQuery('.cart-progress-wrapper').find('.offer-block').addClass('lock');
                    jQuery('.drawer.cart__drawer').find('.common-offer-congrats').hide();
                    if($('.drawer.cart__drawer').find('.progress-segment.segment-1').length>0){
                      $('.drawer.cart__drawer').find('.progress-text').text(freeship + '%');
                      let remaining = ((freeShippingProgressTarget - subtotal)*100);
                      remaining = Shopify.formatMoney(remaining);
                      remaining=remaining.replace(/.00/g, '');
                      $('.drawer.cart__drawer').find('.cart-rest-price-n').text(`${remaining}`);
                    }
                    if(freeship>=100){
                      $('.drawer.cart__drawer').find('.cart-offer-block-wrapper').find('.offer-cart-msg-ship').hide();
                      if (productCount < goal1) {
                          // progressPercent = (productCount / goal3) * 100;
                          // if(progressPercent>50){
                          //   progressPercent = 40;
                          // }
                          var totalRequired = goal1 + goal3;
                          progressPercent = (goal1 / totalRequired) * 100;

                          jQuery('.cart-progress-wrapper').find('.offer-block.first-lock').removeClass('lock');
                          if(freeship>=100){
                            jQuery('.drawer.cart__drawer').find('.congrats-offer-msg-n').show();
                          }else{
                            jQuery('.drawer.cart__drawer').find('.offer-cart-msg-ship').show();
                          }
                      }
                      else if (productCount === goal1) {
                        progressPercent = (goal1 / goal3) * 100;
                        if(jQuery('.cart-progress-wrapper').find('.offer-block').length>0){
                          jQuery('.cart-progress-wrapper').find('.offer-block.first-lock').removeClass('lock');
                          jQuery('.cart-progress-wrapper').find('.offer-block.second-lock').removeClass('lock');
                        }
                        jQuery('.drawer.cart__drawer').find('.congrats-offer-msg-n').hide();
                        if(freeship>=100){
                          var remaincount = (goal3-productCount);
                          jQuery('.drawer.cart__drawer').find('.offer-info-text.strap-info-msg').find('.strap-msgcount').text(remaincount);
                        }
                        if(jQuery('.new_offer_progress').find('.cartitem-discount-v1.top').length>0){
                          jQuery('.new_offer_progress').find('.cartitem-discount-v1.top').show();
                        }
                        if(jQuery('.drawer.cart__drawer').find('.congrats-offer-buytwo-msg-n').length>0){
                          jQuery('.drawer.cart__drawer').find('.congrats-offer-buytwo-msg-n').show();
                        }
                      } 
                      else if (productCount > goal1 && productCount < goal3) {
                        progressPercent = (productCount / goal3) * 100;
                        jQuery('.cart-progress-wrapper').find('.offer-block.first-lock').removeClass('lock');
                        jQuery('.cart-progress-wrapper').find('.offer-block.second-lock').removeClass('lock');
                        jQuery('.drawer.cart__drawer').find('.offer-info-text.strap-info-msg').show();
                        if(freeship>=100){
                          var remaincount = (goal3-productCount);
                          jQuery('.drawer.cart__drawer').find('.offer-info-text.strap-info-msg').find('.strap-msgcount').text(remaincount);
                        }
                        if(jQuery('.drawer.cart__drawer').find('.congrats-offer-buytwo-msg-n').length>0){
                          jQuery('.drawer.cart__drawer').find('.congrats-offer-buytwo-msg-n').hide();
                        }
                        if(jQuery('.new_offer_progress').find('.cartitem-discount-v1.top').length>0){
                          jQuery('.new_offer_progress').find('.cartitem-discount-v1.top').show();
                        }
                      } 
                      else if (productCount >= goal3) {
                        progressPercent = 100;
                        jQuery('.cart-progress-wrapper').find('.offer-block').removeClass('lock');
                        jQuery('.drawer.cart__drawer').find('.congrats-five-offer-msg-n').show();
                        if(jQuery('.new_offer_progress').find('.cartitem-discount-v1.top').length>0){
                          jQuery('.new_offer_progress').find('.cartitem-discount-v1.top').show();
                        }
                      }
                      //console.log("set progress",progressPercent);
                      jQuery('.cart__drawer').find('.cart-offer-block-wrapper').find('.cart-progress').css('width',progressPercent+'%');
                      
                    }else{
                      $('.drawer.cart__drawer').find('.cart-offer-block-wrapper').find('.offer-cart-msg-ship').show();
                      jQuery('.cart__drawer').find('.cart-offer-block-wrapper').find('.cart-progress').css('width','0%');
                    }
                  }
                }*/
                /****************************************************
                 * NEW OFFER PROGRESSBAR END
                ****************************************************/

                // Cart drawer price snippet
                if(document.querySelectorAll(".cartoffprice")!=null){
                  var elements = document.querySelectorAll(".cartoffprice");

                  if (elements.length === 0) {
                    console.warn(".cartoffprice not found in DOM.");
                    return;
                  }

                  elements.forEach(function(el) {
                    var rawPrice = parseFloat(el.dataset.price);
                    console.log("rawPrice -->", rawPrice);

                    if (Shopify && Shopify.currency && Shopify.currency.rate) {
                      var rate = parseFloat(Shopify.currency.rate);
                      console.log("rate -->", rate);

                      var converted = (rawPrice * rate).toFixed(2);
                      console.log("converted -->", converted);

                      el.textContent = Shopify.formatMoney(converted * 100, Shopify.currency.active_format);
                    }
                  });
                }

                // Cart drawer price snippet
                if(document.querySelectorAll(".stepoffprice")!=null){
                  var elements = document.querySelectorAll(".stepoffprice");

                  if (elements.length === 0) {
                    console.warn(".stepoffprice not found in DOM.");
                    return;
                  }

                  elements.forEach(function(el) {
                    var rawPrice = parseFloat(el.dataset.price);
                    console.log("rawPrice -->", rawPrice);

                    if (Shopify && Shopify.currency && Shopify.currency.rate) {
                      var rate = parseFloat(Shopify.currency.rate);
                      console.log("rate -->", rate);

                      var converted = (rawPrice * rate).toFixed(2);
                      console.log("converted -->", converted);

                      el.textContent = Shopify.formatMoney(converted * 100, Shopify.currency.active_format);
                    }
                  });
                }
              }
            },
          });
          // End Custom

          try {
            fetch(
              "https://" +
                window.location.hostname +
                "/browsing_context_suggestions.json"
            )
              .then((res) => res.json())
              .then((r) => {
                if (r.detected_values.country.name == "United States") {
                  if (document.querySelector("#product-shoppay-placement")) {
                    document.querySelector("#afterpay-placement").style.display = "flex";
                  }
                } else if (r.detected_values.country.name == "Australia") {
                  if (document.querySelector("#product-shoppay-placement")) {
                    document.querySelector("#afterpay-placement").style.display = "flex";
                  }
                } else if (r.detected_values.country.name == "United Kingdom") {
                  if (document.querySelector("#product-shoppay-placement")) {
                    document.querySelector("#afterpay-placement").style.display = "flex";
                  }
                } else if (r.detected_values.country.name == "Canada") {
                  if (document.querySelector("#product-shoppay-placement")) {
                    document.querySelector("#afterpay-placement").style.display = "flex";
                  }
                } else if (r.detected_values.country.name == "New Zealand") {
                  if (document.querySelector("#afterpay-placement")) {
                    document.querySelector("#afterpay-placement").style.display = "flex";
                  }
                } else {
                  if (document.querySelector("#afterpay-placement")) {
                    document.querySelector("#afterpay-placement").style.display = "none";
                  }
                }
              });
          } catch (error) {
            return null;
          }

          let afterpayCurrenccy = document.querySelector(".afterpay-currency");

          afterpayCurrenccy.innerText = theme.Currency.formatMoney(
            (subtotal / 4).toFixed(2),
            theme.settings.moneyFormat
          );
          //window.Shopify.currency.active + (subtotal / 4).toFixed(2);

          // Check Visitor location and hide shopPay
          try {
            fetch(
              "https://" +
                window.location.hostname +
                "/browsing_context_suggestions.json"
            )
              .then((res) => res.json())
              .then((r) => {
                if (r.detected_values.country.name == "United States") {
                  document.querySelector("#shoppay-placement").style.display =
                    "flex";
                } else {
                  document.querySelector("#shoppay-placement").style.display =
                    "none";
                }
              });
          } catch (error) {
            return null;
          }
        }

        this.reInit();

        if (window.AOS) {
          AOS.refreshHard();
        }

        if (Shopify && Shopify.StorefrontExpressButtons) {
          Shopify.StorefrontExpressButtons.initialize();
        }
      },

      updateCartDiscounts: function (markup) {
        if (!this.discounts) {
          return;
        }
        this.discounts.innerHTML = "";
        this.discounts.append(markup);
      },

      /*============================================================================
        Quantity handling
      ==============================================================================*/
      initQtySelectors: function () {
        this.form.querySelectorAll(selectors.qtySelector).forEach((el) => {
          var selector = new theme.QtySelector(el, {
            namespace: this.namespace,
            isCart: true,
          });
        });
      },

      removeFreeProduct: function () {
        theme.cart
          .changeFreeItem("47266105983263", "0")
          .then(
            function (cart) {
              localStorage.setItem("freeProductId", "");

              if (cart.item_count > 0) {
                this.wrapper.classList.remove("is-empty");
              } else {
                this.wrapper.classList.add("is-empty");
              }

              this.buildCart();

              var pendingFreeStrap =
                '<div class="product-single__related-free-item free_prod_not_added style-1" style="display:none;">';
              pendingFreeStrap += '<div class="psrelated-item">';
              pendingFreeStrap += '<div class="psrelated-media">';
              pendingFreeStrap +=
                '<img src="https://cdn.shopify.com/s/files/1/0512/7461/2920/files/Text_input_container.png?v=1700719028">';
              pendingFreeStrap += "</div>";
              pendingFreeStrap += '<div class="psrelated-content">';
              pendingFreeStrap +=
                '<h2><span style="color:#ff4f33;">TODAY ONLY:</span> FREE IPHONE STRAP</h2>';
              pendingFreeStrap += '<div class="psrelated-review">';
              pendingFreeStrap += '<div class="psrelated-review-info">';
              pendingFreeStrap +=
                "<span>Fits all iPhone models and cases</span>";
              pendingFreeStrap += "</div>";
              pendingFreeStrap += "</div>";
              pendingFreeStrap += "</div>";
              pendingFreeStrap += '<div class="psrelated-check">';
              pendingFreeStrap +=
                '<input type="checkbox" id="free_minipad" class="shipping_protection" data-gtm-form-interact-field-id="0">';
              pendingFreeStrap +=
                '<label for="free_minipad" class="checkbox-input"> </label>';
              pendingFreeStrap += "</div>";
              pendingFreeStrap += "</div>";
              pendingFreeStrap += "</div>";

              pendingFreeStrap +=
                '<div class="product-single__related-free-item free_prod_not_added style-2" style="display:none;">';
              pendingFreeStrap += '<div class="psrelated-item">';
              pendingFreeStrap += '<div class="psrelated-media">';
              pendingFreeStrap +=
                '<img src="https://cdn.shopify.com/s/files/1/0512/7461/2920/files/Text_input_container.png?v=1700719028">';
              pendingFreeStrap += "</div>";
              pendingFreeStrap += '<div class="psrelated-content">';
              pendingFreeStrap +=
                '<h2><span style="color:#ff4f33;">TODAY ONLY:</span> FREE IPHONE STRAP</h2>';
              pendingFreeStrap += '<div class="psrelated-review">';
              pendingFreeStrap += '<div class="psrelated-review-info">';
              pendingFreeStrap +=
                "<span>Fits all iPhone models and cases</span>";
              pendingFreeStrap += "</div>";
              pendingFreeStrap += "</div>";
              pendingFreeStrap += "</div>";
              pendingFreeStrap += '<div class="psrelated-check">';
              pendingFreeStrap +=
                '<input type="checkbox" id="free__minipad" class="shipping_protection" data-gtm-form-interact-field-id="0">';
              pendingFreeStrap +=
                '<label for="free__minipad" class="checkbox---input"> </label>';
              pendingFreeStrap += "</div>";
              pendingFreeStrap += "</div>";
              pendingFreeStrap += "</div>";

              pendingFreeStrap +=
                '<div class="product-single__related-free-item free_prod_not_added style-3" style="display:none;">';
              pendingFreeStrap +=
                '<input type="checkbox" id="free__minipad_3" checked style="display:none" class="shipping_protection">';
              pendingFreeStrap += '<div class="psrelated-item">';
              pendingFreeStrap += '<div class="psrelated-media">';
              pendingFreeStrap +=
                '<img src="https://cdn.shopify.com/s/files/1/0512/7461/2920/files/Text_input_container.png?v=1700719028">';
              pendingFreeStrap += "</div>";
              pendingFreeStrap += '<div class="psrelated-content">';
              pendingFreeStrap +=
                "<h2><span>GIFT UNLOCKED:</span> FREE IPHONE STRAP</h2>";
              pendingFreeStrap += '<div class="psrelated-review">';
              pendingFreeStrap += '<div class="psrelated-review-info">';
              pendingFreeStrap +=
                "<span>Almost gone - last free straps left in stock!</span>";
              pendingFreeStrap += "</div>";
              pendingFreeStrap += "</div>";
              pendingFreeStrap += "</div>";
              pendingFreeStrap += "</div>";
              pendingFreeStrap += "</div>";

              $("#free_strp_product").html(pendingFreeStrap);

              document.dispatchEvent(
                new CustomEvent("cart:updated", {
                  detail: {
                    cart: cart,
                  },
                })
              );
            }.bind(this)
          )
          .catch(function (XMLHttpRequest) {});
      },

      cartDrawerUpsell: function () {
        var cartDrawerUpsell = "";
        cartDrawerUpsell +=
          '<div class="cart_checkbox_1" style="display: none;" product--id="8843064738079">';
        cartDrawerUpsell += '<div class="cart_inner_checkbox">';
        cartDrawerUpsell += '<div class="cart_checkbox_img">';
        cartDrawerUpsell +=
          '<img src="//prettystraps.com/cdn/shop/files/MyPrettyStrap-Packaging-Set-1-1080x1080.jpg?v=1701955709" width="100">';
        cartDrawerUpsell += "</div>";
        cartDrawerUpsell += '<div class="check_inner_titlebox">';
        cartDrawerUpsell +=
          "<p>Premium Gift Box <span class=“money”>$14.99</span></p>";
        cartDrawerUpsell += "</div>";
        cartDrawerUpsell += "</div>";
        cartDrawerUpsell += '<div class="cart_main_check">';
        cartDrawerUpsell += '<div class="psrelated-check">';
        cartDrawerUpsell +=
          '<input type="checkbox" id="cart_drawer_upsell_1" class="shipping_protection" data-gtm-form-interact-field-id="0">';
        cartDrawerUpsell +=
          '<label for="cart_drawer_upsell_1" class="checkbox-input">';
        cartDrawerUpsell += "</label>";
        cartDrawerUpsell += "</div>";
        cartDrawerUpsell += "</div>";
        cartDrawerUpsell += "</div>";
        cartDrawerUpsell +=
          '<div class="cart_checkbox_2" style="display: none;" product--id="8843064738079">';
        cartDrawerUpsell += '<div class="cart_inner_checkbox">';
        cartDrawerUpsell += '<div class="check_with_title">';
        cartDrawerUpsell += '<div class="check_inner_checkbox">';
        cartDrawerUpsell +=
          '<input type="checkbox" id="cart_drawer_upsell_2" class="shipping_protection" data-gtm-form-interact-field-id="0">';
        cartDrawerUpsell +=
          '<label for="cart_drawer_upsell_2" class="checkbox-input"></label>';
        cartDrawerUpsell += "</div>";
        cartDrawerUpsell += '<div class="check_inner_img">';
        cartDrawerUpsell +=
          '<img src="//prettystraps.com/cdn/shop/files/MyPrettyStrap-Packaging-Set-1-1080x1080.jpg?v=1701955709" width="100">';
        cartDrawerUpsell += "</div>";
        cartDrawerUpsell += '<div class="check_inner_title">';
        cartDrawerUpsell += "<h6>Premium Gift Box</h6>";
        cartDrawerUpsell += "<span>The perfect gift set for you</span>";
        cartDrawerUpsell += "</div>";
        cartDrawerUpsell += "</div>";
        cartDrawerUpsell += '<div class="check_inner_price">';
        cartDrawerUpsell +=
          '<span class="check_main_price money">$14.99</span>';
        cartDrawerUpsell +=
          '<span class="check_compare_price  hide money"></span>';
        cartDrawerUpsell += "</div>";
        cartDrawerUpsell += "</div>";
        cartDrawerUpsell += "</div>";
        $("#cart_drawer_upsell_new").html(cartDrawerUpsell);
      },

      quantityChanged: function (evt) {
        var key = evt.detail[0];
        var qty = evt.detail[1];
        var el = evt.detail[2];

        if (!key || !qty) {
          return;
        }

        // Disable qty selector so multiple clicks can't happen while loading
        if (el) {
          el.classList.add("is-loading");
        }

        theme.cart
          .changeItem(key, qty)
          .then(
            function (cart) {
              var cookieKey = "freeProductId";
              var freeProductId = localStorage.getItem(cookieKey);

              var cartUpsell5Id = localStorage.getItem("cartUpsell5");

              if (cartUpsell5Id == "47342803288351") {
                localStorage.setItem("cartUpsell5", "");
                this.cartDrawerUpsell();
              }

              if (freeProductId == "47266105983263" && cart.items.length == 1) {
                this.removeFreeProduct();
              } else {
                if (cart.item_count > 0) {
                  this.wrapper.classList.remove("is-empty");
                } else {
                  this.wrapper.classList.add("is-empty");
                }

                this.buildCart();

                document.dispatchEvent(
                  new CustomEvent("cart:updated", {
                    detail: {
                      cart: cart,
                    },
                  })
                );
              }
            }.bind(this)
          )
          .catch(function (XMLHttpRequest) {});
      },

      /*============================================================================
        Update elements of the cart
      ==============================================================================*/
      updateSubtotal: function (subtotal) {
        this.form.querySelector(selectors.subTotal).innerHTML =
          theme.Currency.formatMoney(subtotal, theme.settings.moneyFormat);
      },

      updateSavings: function (savings) {
        if (!this.savings) {
          return;
        }
        console.log("savings", savings);
        if (savings > 0) {
          var amount = theme.Currency.formatMoney(
            savings,
            theme.settings.moneyFormat
          );
          this.savings.classList.remove("hide");
          this.savings.innerHTML = theme.strings.cartSavings.replace(
            "[savings]",
            amount
          );
        } else {
          this.savings.classList.add("hide");
        }
      },

      updateCount: function (count) {
        var countEls = document.querySelectorAll(".cart-link__bubble-num");

        if (countEls.length) {
          countEls.forEach((el) => {
            el.innerText = count;
          });
        }

        // show/hide bubble(s)
        var bubbles = document.querySelectorAll(selectors.cartBubble);
        if (bubbles.length) {
          if (count > 0) {
            bubbles.forEach((b) => {
              b.classList.add("cart-link__bubble--visible");
            });
          } else {
            bubbles.forEach((b) => {
              b.classList.remove("cart-link__bubble--visible");
            });
          }
        }
      },
    });

    return CartForm;
  })();

  // Either collapsible containers all acting individually,
  // or tabs that can only have one open at a time
  theme.collapsibles = (function () {
    var selectors = {
      trigger: ".collapsible-trigger",
      module: ".collapsible-content",
      moduleInner: ".collapsible-content__inner",
      tabs: ".collapsible-trigger--tab",
    };

    var classes = {
      hide: "hide",
      open: "is-open",
      autoHeight: "collapsible--auto-height",
      tabs: "collapsible-trigger--tab",
    };

    var namespace = ".collapsible";

    var isTransitioning = false;

    function init(scope) {
      var el = scope ? scope : document;
      el.querySelectorAll(selectors.trigger).forEach((trigger) => {
        var state = trigger.classList.contains(classes.open);
        trigger.setAttribute("aria-expanded", state);

        trigger.off("click" + namespace);
        trigger.on("click" + namespace, toggle);
      });
    }

    function toggle(evt) {
      if (isTransitioning) {
        return;
      }

      isTransitioning = true;

      var el = evt.currentTarget;
      var isOpen = el.classList.contains(classes.open);
      var isTab = el.classList.contains(classes.tabs);
      var moduleId = el.getAttribute("aria-controls");
      var container = document.getElementById(moduleId);

      if (!moduleId) {
        moduleId = el.dataset.controls;
      }

      // No ID, bail
      if (!moduleId) {
        return;
      }

      // If container=null, there isn't a matching ID.
      // Check if data-id is set instead. Could be multiple.
      // Select based on being in the same parent div.
      if (!container) {
        var multipleMatches = document.querySelectorAll(
          '[data-id="' + moduleId + '"]'
        );
        if (multipleMatches.length > 0) {
          container = el.parentNode.querySelector(
            '[data-id="' + moduleId + '"]'
          );
        }
      }

      if (!container) {
        isTransitioning = false;
        return;
      }

      var height = container.querySelector(selectors.moduleInner).offsetHeight;
      var isAutoHeight = container.classList.contains(classes.autoHeight);
      var parentCollapsibleEl = container.parentNode.closest(selectors.module);
      var childHeight = height;

      if (isTab) {
        if (isOpen) {
          isTransitioning = false;
          return;
        }

        var newModule;
        document
          .querySelectorAll(
            selectors.tabs + '[data-id="' + el.dataset.id + '"]'
          )
          .forEach((el) => {
            el.classList.remove(classes.open);
            newModule = document.querySelector(
              "#" + el.getAttribute("aria-controls")
            );
            setTransitionHeight(newModule, 0, true);
          });
      }

      // If isAutoHeight, set the height to 0 just after setting the actual height
      // so the closing animation works nicely
      if (isOpen && isAutoHeight) {
        setTimeout(function () {
          height = 0;
          setTransitionHeight(container, height, isOpen, isAutoHeight);
        }, 0);
      }

      if (isOpen && !isAutoHeight) {
        height = 0;
      }

      el.setAttribute("aria-expanded", !isOpen);
      if (isOpen) {
        el.classList.remove(classes.open);
      } else {
        el.classList.add(classes.open);
      }

      setTransitionHeight(container, height, isOpen, isAutoHeight);

      // If we are in a nested collapsible element like the mobile nav,
      // also set the parent element's height
      if (parentCollapsibleEl) {
        var totalHeight = isOpen
          ? parentCollapsibleEl.offsetHeight - childHeight
          : height + parentCollapsibleEl.offsetHeight;

        setTransitionHeight(parentCollapsibleEl, totalHeight, false, false);
      }

      // If Shopify Product Reviews app installed,
      // resize container on 'Write review' click
      // that shows form
      if (window.SPR) {
        var btn = container.querySelector(".spr-summary-actions-newreview");
        if (!btn) {
          return;
        }
        btn.off("click" + namespace);
        btn.on("click" + namespace, function () {
          height = container.querySelector(selectors.moduleInner).offsetHeight;
          setTransitionHeight(container, height, isOpen, isAutoHeight);
        });
      }
    }

    function setTransitionHeight(container, height, isOpen, isAutoHeight) {
      container.classList.remove(classes.hide);
      theme.utils.prepareTransition(container, function () {
        container.style.height = height + "px";
        if (isOpen) {
          container.classList.remove(classes.open);
        } else {
          container.classList.add(classes.open);
        }
      });

      if (!isOpen && isAutoHeight) {
        var o = container;
        window.setTimeout(function () {
          o.css("height", "auto");
          isTransitioning = false;
        }, 500);
      } else {
        isTransitioning = false;
      }
    }

    return {
      init: init,
    };
  })();

  // Shopify-built select-like popovers for currency and language selection
  theme.Disclosure = (function () {
    var selectors = {
      disclosureForm: "[data-disclosure-form]",
      disclosureList: "[data-disclosure-list]",
      disclosureToggle: "[data-disclosure-toggle]",
      disclosureInput: "[data-disclosure-input]",
      disclosureOptions: "[data-disclosure-option]",
    };

    var classes = {
      listVisible: "disclosure-list--visible",
    };

    function Disclosure(disclosure) {
      this.container = disclosure;
      this._cacheSelectors();
      this._setupListeners();
    }

    Disclosure.prototype = Object.assign({}, Disclosure.prototype, {
      _cacheSelectors: function () {
        this.cache = {
          disclosureForm: this.container.closest(selectors.disclosureForm),
          disclosureList: this.container.querySelector(
            selectors.disclosureList
          ),
          disclosureToggle: this.container.querySelector(
            selectors.disclosureToggle
          ),
          disclosureInput: this.container.querySelector(
            selectors.disclosureInput
          ),
          disclosureOptions: this.container.querySelectorAll(
            selectors.disclosureOptions
          ),
        };
      },

      _setupListeners: function () {
        this.eventHandlers = this._setupEventHandlers();

        this.cache.disclosureToggle.addEventListener(
          "click",
          this.eventHandlers.toggleList
        );

        this.cache.disclosureOptions.forEach(function (disclosureOption) {
          disclosureOption.addEventListener(
            "click",
            this.eventHandlers.connectOptions
          );
        }, this);

        this.container.addEventListener(
          "keyup",
          this.eventHandlers.onDisclosureKeyUp
        );

        this.cache.disclosureList.addEventListener(
          "focusout",
          this.eventHandlers.onDisclosureListFocusOut
        );

        this.cache.disclosureToggle.addEventListener(
          "focusout",
          this.eventHandlers.onDisclosureToggleFocusOut
        );

        document.body.addEventListener("click", this.eventHandlers.onBodyClick);
      },

      _setupEventHandlers: function () {
        return {
          connectOptions: this._connectOptions.bind(this),
          toggleList: this._toggleList.bind(this),
          onBodyClick: this._onBodyClick.bind(this),
          onDisclosureKeyUp: this._onDisclosureKeyUp.bind(this),
          onDisclosureListFocusOut: this._onDisclosureListFocusOut.bind(this),
          onDisclosureToggleFocusOut:
            this._onDisclosureToggleFocusOut.bind(this),
        };
      },

      _connectOptions: function (event) {
        event.preventDefault();

        this._submitForm(event.currentTarget.dataset.value);
      },

      _onDisclosureToggleFocusOut: function (event) {
        var disclosureLostFocus =
          this.container.contains(event.relatedTarget) === false;

        if (disclosureLostFocus) {
          this._hideList();
        }
      },

      _onDisclosureListFocusOut: function (event) {
        var childInFocus = event.currentTarget.contains(event.relatedTarget);

        var isVisible = this.cache.disclosureList.classList.contains(
          classes.listVisible
        );

        if (isVisible && !childInFocus) {
          this._hideList();
        }
      },

      _onDisclosureKeyUp: function (event) {
        if (event.which !== 27) return;
        this._hideList();
        this.cache.disclosureToggle.focus();
      },

      _onBodyClick: function (event) {
        var isOption = this.container.contains(event.target);
        var isVisible = this.cache.disclosureList.classList.contains(
          classes.listVisible
        );

        if (isVisible && !isOption) {
          this._hideList();
        }
      },

      _submitForm: function (value) {
        this.cache.disclosureInput.value = value;
        this.cache.disclosureForm.submit();
      },

      _hideList: function () {
        this.cache.disclosureList.classList.remove(classes.listVisible);
        this.cache.disclosureToggle.setAttribute("aria-expanded", false);
      },

      _toggleList: function () {
        var ariaExpanded =
          this.cache.disclosureToggle.getAttribute("aria-expanded") === "true";
        this.cache.disclosureList.classList.toggle(classes.listVisible);
        this.cache.disclosureToggle.setAttribute(
          "aria-expanded",
          !ariaExpanded
        );
      },

      destroy: function () {
        this.cache.disclosureToggle.removeEventListener(
          "click",
          this.eventHandlers.toggleList
        );

        this.cache.disclosureOptions.forEach(function (disclosureOption) {
          disclosureOption.removeEventListener(
            "click",
            this.eventHandlers.connectOptions
          );
        }, this);

        this.container.removeEventListener(
          "keyup",
          this.eventHandlers.onDisclosureKeyUp
        );

        this.cache.disclosureList.removeEventListener(
          "focusout",
          this.eventHandlers.onDisclosureListFocusOut
        );

        this.cache.disclosureToggle.removeEventListener(
          "focusout",
          this.eventHandlers.onDisclosureToggleFocusOut
        );

        document.body.removeEventListener(
          "click",
          this.eventHandlers.onBodyClick
        );
      },
    });

    return Disclosure;
  })();

  theme.Drawers = (function () {
    function Drawers(id, name) {
      this.config = {
        id: id,
        close: ".js-drawer-close",
        open: ".js-drawer-open-" + name,
        openClass: "js-drawer-open",
        closingClass: "js-drawer-closing",
        activeDrawer: "drawer--is-open",
        namespace: ".drawer-" + name,
      };

      this.nodes = {
        page: document.querySelector("#MainContent"),
      };

      this.drawer = document.querySelector("#" + id);
      this.isOpen = false;

      if (!this.drawer) {
        return;
      }

      this.init();
    }

    Drawers.prototype = Object.assign({}, Drawers.prototype, {
      init: function () {
        // Setup open button(s)
        document.querySelectorAll(this.config.open).forEach((openBtn) => {
          openBtn.setAttribute("aria-expanded", "false");
          openBtn.addEventListener("click", this.open.bind(this));
        });

        this.drawer
          .querySelector(this.config.close)
          .addEventListener("click", this.close.bind(this));

        // Close modal if a drawer is opened
        document.addEventListener(
          "modalOpen",
          function () {
            this.close();
          }.bind(this)
        );
      },

      open: function (evt, returnFocusEl) {
        if (evt) {
          evt.preventDefault();
        }

        if (this.isOpen) {
          return;
        }

        // Without this the drawer opens, the click event bubbles up to $nodes.page which closes the drawer.
        if (evt && evt.stopPropagation) {
          evt.stopPropagation();
          // save the source of the click, we'll focus to this on close
          evt.currentTarget.setAttribute("aria-expanded", "true");
          this.activeSource = evt.currentTarget;
        } else if (returnFocusEl) {
          returnFocusEl.setAttribute("aria-expanded", "true");
          this.activeSource = returnFocusEl;
        }

        theme.utils.prepareTransition(
          this.drawer,
          function () {
            this.drawer.classList.add(this.config.activeDrawer);
          }.bind(this)
        );

        document.documentElement.classList.add(this.config.openClass);
        this.isOpen = true;

        theme.a11y.trapFocus({
          container: this.drawer,
          namespace: "drawer_focus",
        });

        document.dispatchEvent(new CustomEvent("drawerOpen"));
        document.dispatchEvent(new CustomEvent("drawerOpen." + this.config.id));

        this.bindEvents();
      },

      close: function (evt) {
        if (!this.isOpen) {
          return;
        }

        // Do not close if click event came from inside drawer
        if (evt) {
          if (evt.target.closest(".js-drawer-close")) {
            // Do not close if using the drawer close button
          } else if (evt.target.closest(".drawer")) {
            return;
          }
        }

        // deselect any focused form elements
        document.activeElement.blur();

        theme.utils.prepareTransition(
          this.drawer,
          function () {
            this.drawer.classList.remove(this.config.activeDrawer);
          }.bind(this)
        );

        document.documentElement.classList.remove(this.config.openClass);
        document.documentElement.classList.add(this.config.closingClass);

        window.setTimeout(
          function () {
            document.documentElement.classList.remove(this.config.closingClass);
            if (
              this.activeSource &&
              this.activeSource.getAttribute("aria-expanded")
            ) {
              this.activeSource.setAttribute("aria-expanded", "false");
              this.activeSource.focus();
            }
          }.bind(this),
          500
        );

        this.isOpen = false;

        theme.a11y.removeTrapFocus({
          container: this.drawer,
          namespace: "drawer_focus",
        });

        this.unbindEvents();
      },

      bindEvents: function () {
        // Clicking out of drawer closes it
        // window.on(
        //   "click" + this.config.namespace,
        //   function (evt) {
        //     this.close(evt);
        //     return;
        //   }.bind(this)
        // );

        // Pressing escape closes drawer
        window.on(
          "keyup" + this.config.namespace,
          function (evt) {
            if (evt.keyCode === 27) {
              if(jQuery("body").hasClass("cart_giveaway_popup_active")){
                jQuery(".cart_giveaway_popup").hide();
                jQuery("body").removeClass("cart_giveaway_popup_active");
              }else{
                this.close();
              }
            }
          }.bind(this)
        );

        theme.a11y.lockMobileScrolling(this.config.namespace, this.nodes.page);
      },

      unbindEvents: function () {
        window.off("click" + this.config.namespace);
        window.off("keyup" + this.config.namespace);

        theme.a11y.unlockMobileScrolling(
          this.config.namespace,
          this.nodes.page
        );
      },
    });

    return Drawers;
  })();

  theme.Modals = (function () {
    function Modal(id, name, options) {
      var defaults = {
        close: ".js-modal-close",
        open: ".js-modal-open-" + name,
        openClass: "modal--is-active",
        closingClass: "modal--is-closing",
        bodyOpenClass: ["modal-open"],
        bodyOpenSolidClass: "modal-open--solid",
        bodyClosingClass: "modal-closing",
        closeOffContentClick: true,
      };

      this.id = id;
      this.modal = document.getElementById(id);

      if (!this.modal) {
        return false;
      }

      this.modalContent = this.modal.querySelector(".modal__inner");

      this.config = Object.assign(defaults, options);
      this.modalIsOpen = false;
      this.focusOnOpen = this.config.focusIdOnOpen
        ? document.getElementById(this.config.focusIdOnOpen)
        : this.modal;
      this.isSolid = this.config.solid;

      this.init();
    }

    Modal.prototype.init = function () {
      document.querySelectorAll(this.config.open).forEach((btn) => {
        btn.setAttribute("aria-expanded", "false");
        btn.addEventListener("click", this.open.bind(this));
      });

      this.modal.querySelectorAll(this.config.close).forEach((btn) => {
        btn.addEventListener("click", this.close.bind(this));
      });

      // Close modal if a drawer is opened
      document.addEventListener(
        "drawerOpen",
        function () {
          this.close();
        }.bind(this)
      );
    };

    Modal.prototype.open = function (evt) {
      // Keep track if modal was opened from a click, or called by another function
      var externalCall = false;

      // don't open an opened modal
      if (this.modalIsOpen) {
        return;
      }

      // Prevent following href if link is clicked
      if (evt) {
        evt.preventDefault();
      } else {
        externalCall = true;
      }

      // Without this, the modal opens, the click event bubbles up to $nodes.page
      // which closes the modal.
      if (evt && evt.stopPropagation) {
        evt.stopPropagation();
        // save the source of the click, we'll focus to this on close
        this.activeSource = evt.currentTarget.setAttribute(
          "aria-expanded",
          "true"
        );
      }

      if (this.modalIsOpen && !externalCall) {
        this.close();
      }

      this.modal.classList.add(this.config.openClass);

      document.documentElement.classList.add(...this.config.bodyOpenClass);

      if (this.isSolid) {
        document.documentElement.classList.add(this.config.bodyOpenSolidClass);
      }

      this.modalIsOpen = true;

      theme.a11y.trapFocus({
        container: this.modal,
        elementToFocus: this.focusOnOpen,
        namespace: "modal_focus",
      });

      document.dispatchEvent(new CustomEvent("modalOpen"));
      document.dispatchEvent(new CustomEvent("modalOpen." + this.id));

      this.bindEvents();
    };

    Modal.prototype.close = function (evt) {
      // don't close a closed modal
      if (!this.modalIsOpen) {
        return;
      }

      // Do not close modal if click happens inside modal content
      if (evt) {
        if (evt.target.closest(".js-modal-close")) {
          // Do not close if using the modal close button
        } else if (evt.target.closest(".modal__inner")) {
          return;
        }
      }

      // deselect any focused form elements
      document.activeElement.blur();

      this.modal.classList.remove(this.config.openClass);
      this.modal.classList.add(this.config.closingClass);

      document.documentElement.classList.remove(...this.config.bodyOpenClass);
      document.documentElement.classList.add(this.config.bodyClosingClass);

      window.setTimeout(
        function () {
          document.documentElement.classList.remove(
            this.config.bodyClosingClass
          );
          this.modal.classList.remove(this.config.closingClass);
          if (
            this.activeSource &&
            this.activeSource.getAttribute("aria-expanded")
          ) {
            this.activeSource.setAttribute("aria-expanded", "false").focus();
          }
        }.bind(this),
        500
      ); // modal close css transition

      if (this.isSolid) {
        document.documentElement.classList.remove(
          this.config.bodyOpenSolidClass
        );
      }

      this.modalIsOpen = false;

      theme.a11y.removeTrapFocus({
        container: this.modal,
        namespace: "modal_focus",
      });

      document.dispatchEvent(new CustomEvent("modalClose." + this.id));

      this.unbindEvents();
    };

    Modal.prototype.bindEvents = function () {
      window.on(
        "keyup.modal",
        function (evt) {
          if (evt.keyCode === 27) {
            this.close();
          }
        }.bind(this)
      );

      if (this.config.closeOffContentClick) {
        // Clicking outside of the modal content also closes it
        this.modal.on("click.modal", this.close.bind(this));
      }
    };

    Modal.prototype.unbindEvents = function () {
      document.documentElement.off(".modal");

      if (this.config.closeOffContentClick) {
        this.modal.off(".modal");
      }
    };

    return Modal;
  })();

  theme.parallaxSections = {};

  theme.Parallax = (function () {
    var speed = 0.85;
    var reset = false;

    function parallax(container, args) {
      this.isInit = false;
      this.isVisible = false;
      this.container = container;
      this.image = container.querySelector(".parallax-image");
      this.namespace = args.namespace;
      this.desktopOnly = args.desktopOnly;

      if (!this.container || !this.image) {
        return;
      }

      // If set for desktop only, setup listeners for disabling
      // on mobile and re-enabling on desktop
      if (this.desktopOnly) {
        document.addEventListener(
          "matchSmall",
          function () {
            this.destroy();
          }.bind(this)
        );

        document.addEventListener(
          "unmatchSmall",
          function () {
            this.init(true);
          }.bind(this)
        );
      }

      this.init(this.desktopOnly);
    }

    parallax.prototype = Object.assign({}, parallax.prototype, {
      init: function (desktopOnly) {
        // Reset in case initialized again
        if (this.isInit) {
          this.destroy();
        }

        this.isInit = true;

        // Do not setup scroll event if on mobile
        if (desktopOnly && theme.config.bpSmall) {
          return;
        }

        // Set position on page load
        this.setSizes();
        this.scrollHandler();

        var observer = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach((entry) => {
              this.isVisible = entry.isIntersecting;
              if (this.isVisible) {
                window.on("scroll" + this.namespace, this.onScroll.bind(this));
              } else {
                window.off("scroll" + this.namespace);
              }
            });
          },
          { rootMargin: "200px 0px 200px 0px" }
        );

        observer.observe(this.container);

        window.on(
          "resize" + this.namespace,
          theme.utils.debounce(250, this.setSizes.bind(this))
        );

        document.addEventListener(
          "shopify:section:reorder",
          theme.utils.debounce(250, this.onReorder.bind(this))
        );
      },

      onScroll: function () {
        if (!this.isVisible) {
          return;
        }

        // If a scroll event finds Shopify's review app,
        // update parallax scroll positions because of page reflows
        if (window.SPR && !reset) {
          this.setSizes();
          reset = true;
        }

        requestAnimationFrame(this.scrollHandler.bind(this));
      },

      scrollHandler: function () {
        var shiftDistance = (window.scrollY - this.elTop) * speed;
        this.image.style.transform =
          "translate3d(0, " + shiftDistance + "px, 0)";
      },

      setSizes: function () {
        var rect = this.container.getBoundingClientRect();
        this.elTop = rect.top + window.scrollY;
      },

      onReorder: function () {
        this.setSizes();
        this.onScroll();
      },

      destroy: function () {
        this.image.style.transform = "none";
        window.off("scroll" + this.namespace);
        window.off("resize" + this.namespace);
      },
    });

    return parallax;
  })();

  if (typeof window.noUiSlider === "undefined") {
    throw new Error(
      "theme.PriceRange is missing vendor noUiSlider: // =require vendor/nouislider.js"
    );
  }

  theme.PriceRange = (function () {
    var defaultStep = 10;
    var selectors = {
      priceRange: ".price-range",
      priceRangeSlider: ".price-range__slider",
      priceRangeInputMin: ".price-range__input-min",
      priceRangeInputMax: ".price-range__input-max",
      priceRangeDisplayMin: ".price-range__display-min",
      priceRangeDisplayMax: ".price-range__display-max",
    };

    function PriceRange(
      container,
      { onChange, onUpdate, ...sliderOptions } = {}
    ) {
      this.container = container;
      this.onChange = onChange;
      this.onUpdate = onUpdate;
      this.sliderOptions = sliderOptions || {};

      return this.init();
    }

    PriceRange.prototype = Object.assign({}, PriceRange.prototype, {
      init: function () {
        if (!this.container.classList.contains("price-range")) {
          throw new Error(
            "You must instantiate PriceRange with a valid container"
          );
        }

        this.formEl = this.container.closest("form");
        this.sliderEl = this.container.querySelector(
          selectors.priceRangeSlider
        );
        this.inputMinEl = this.container.querySelector(
          selectors.priceRangeInputMin
        );
        this.inputMaxEl = this.container.querySelector(
          selectors.priceRangeInputMax
        );
        this.displayMinEl = this.container.querySelector(
          selectors.priceRangeDisplayMin
        );
        this.displayMaxEl = this.container.querySelector(
          selectors.priceRangeDisplayMax
        );

        this.minRange = parseFloat(this.container.dataset.min) || 0;
        this.minValue = parseFloat(this.container.dataset.minValue) || 0;
        this.maxRange = parseFloat(this.container.dataset.max) || 100;
        this.maxValue =
          parseFloat(this.container.dataset.maxValue) || this.maxRange;

        return this.createPriceRange();
      },

      createPriceRange: function () {
        if (
          this.sliderEl &&
          this.sliderEl.noUiSlider &&
          typeof this.sliderEl.noUiSlider.destroy === "function"
        ) {
          this.sliderEl.noUiSlider.destroy();
        }

        var slider = noUiSlider.create(this.sliderEl, {
          connect: true,
          step: defaultStep,
          ...this.sliderOptions,
          // Do not allow overriding these options
          start: [this.minValue, this.maxValue],
          range: {
            min: this.minRange,
            max: this.maxRange,
          },
        });

        slider.on("update", (values) => {
          this.displayMinEl.innerHTML = theme.Currency.formatMoney(
            values[0],
            theme.settings.moneyFormat
          );
          this.displayMaxEl.innerHTML = theme.Currency.formatMoney(
            values[1],
            theme.settings.moneyFormat
          );

          if (this.onUpdate) {
            this.onUpdate(values);
          }
        });

        slider.on("change", (values) => {
          this.inputMinEl.value = values[0];
          this.inputMaxEl.value = values[1];

          if (this.onChange) {
            const formData = new FormData(this.formEl);
            this.onChange(formData);
          }
        });

        return slider;
      },
    });

    return PriceRange;
  })();

  theme.AjaxProduct = (function () {
    var status = {
      loading: false,
    };

    function ProductForm(form, submit, args) {
      this.form = form;
      this.args = args;

      var submitSelector = submit ? submit : ".add-to-cart";

      if (this.form) {
        this.addToCart = form.querySelector(submitSelector);
        this.form.addEventListener("submit", this.addItemFromForm.bind(this));
      }
    }

    ProductForm.prototype = Object.assign({}, ProductForm.prototype, {
      addItemFromForm: function (evt, callback) {
        evt.preventDefault();

        if (status.loading) {
          return;
        }

        // Loading indicator on add to cart button
        this.addToCart.classList.add("btn--loading");

        status.loading = true;

        var data = theme.utils.serialize(this.form);
        var selectdId = $(".product-single__variants option:selected").val();
        var upsellPid = "";
        if ($("#product-cover-check").prop("checked")) {
          var upsell_pcolor = $("#upsell_pcolor").val().toLowerCase();
          //var upsell_psize = $('#upsell_psize').val().toLowerCase();
          var upsell_psize = $(
            'select[name="variant-popdown-upsell-select"] option:selected'
          )
            .val()
            .toLowerCase();
          if (upsell_pcolor != "" && upsell_psize != "") {
            var upsellPid = $("#" + upsell_pcolor + upsell_psize).val();
          } else if (upsell_pcolor != "") {
            var upsellPid = $("#" + upsell_pcolor).val();
          } else if (upsell_psize != "") {
            var upsellPid = $("#" + upsell_psize).val();
          }
        }

        if ($("#product-cover-check-2").prop("checked")) {
          var upsell_pcolor = $("#upsell_pcolor_2").val().toLowerCase();
          //var upsell_psize = $('#upsell_psize_2').val().toLowerCase();
          var upsell_psize = $(
            'select[name="variant-popdown-upsell-select-2"] option:selected'
          )
            .val()
            .toLowerCase();
          if (upsell_pcolor != "" && upsell_psize != "") {
            var upsellPid = $("#" + upsell_pcolor + upsell_psize).val();
          } else if (upsell_pcolor != "") {
            var upsellPid = $("#" + upsell_pcolor).val();
          } else if (upsell_psize != "") {
            var upsellPid = $("#" + upsell_psize).val();
          }
        }

        var upCoverPid = "";
        if ($("#coverUpsellId").length) {
          if ($("#coverUpsellId").val() != "") {
            var vouder = 1;
            var upcover_psize = "";
            var coverUpsellId = $("#coverUpsellId").val();
            $(".product-block-extra-cover").each(function () {
              if ($(this).css("display") == "block") {
                upcover_psize = $(
                  'select[name="variant-popdown-upsell-select-cover-' +
                    coverUpsellId +
                    "-v" +
                    vouder +
                    '"] option:selected'
                )
                  .val()
                  .toLowerCase();
              }
              vouder++;
            });

            var upcover_pcolor = $("#upsell_pcolor_cover_" + coverUpsellId)
              .val()
              .toLowerCase();
            //var upcover_psize = $('select[name="variant-popdown-upsell-select-cover-'+coverUpsellId+'"] option:selected').val().toLowerCase();
            if (upcover_pcolor != "" && upcover_psize != "") {
              var upCoverPid = $(
                "#" + upcover_pcolor + upcover_psize + "_" + coverUpsellId
              ).val();
            } else if (upcover_pcolor != "") {
              var upCoverPid = $(
                "#" + upcover_pcolor + "_" + coverUpsellId
              ).val();
            } else if (upcover_psize != "") {
              var upCoverPid = $(
                "#" + upcover_psize + "_" + coverUpsellId
              ).val();
            }
          }
        }

        if (upsellPid != "") {
          if (typeof upsellPid === "undefined") {
            var itemArr = [
              {
                id: selectdId,
                quantity: 1,
              },
            ];
          } else {
            var itemArr = [
              {
                id: selectdId,
                quantity: 1,
              },
              {
                id: upsellPid,
                quantity: 1,
              },
            ];
          }
        } else {
          var itemArr = [
            {
              id: selectdId,
              quantity: 1,
            },
          ];
        }
        if ($("#free_minipad").is(":checked")) {
          var cookieKey = "freeProductId";
          var cookieValue = "47266105983263";
          var freeProductId = localStorage.getItem(cookieKey);

          //freeProductId = '';
          if (freeProductId === null) {
            freeProductId = "";
          }
          if (freeProductId == "") {
            localStorage.setItem(cookieKey, cookieValue);
            var itemArr1 = [
              {
                id: cookieValue,
                quantity: 1,
                properties: { _freeProduct: 1 },
              },
            ];

            Array.prototype.push.apply(itemArr, itemArr1);
          }
        }
        if ($("#free__minipad").is(":checked")) {
          var cookieKey = "freeProductId";
          var cookieValue = "47266105983263";
          var freeProductId = localStorage.getItem(cookieKey);

          //freeProductId = '';
          if (freeProductId === null) {
            freeProductId = "";
          }
          if (freeProductId == "") {
            localStorage.setItem(cookieKey, cookieValue);
            var itemArr1 = [
              {
                id: cookieValue,
                quantity: 1,
                properties: { _freeProduct: 1 },
              },
            ];

            Array.prototype.push.apply(itemArr, itemArr1);
          }
        }
        if ($("#free__minipad_3").is(":checked")) {
          var cookieKey = "freeProductId";
          var cookieValue = "47266105983263";
          var freeProductId = localStorage.getItem(cookieKey);

          //freeProductId = '';
          if (freeProductId === null) {
            freeProductId = "";
          }
          if (freeProductId == "") {
            localStorage.setItem(cookieKey, cookieValue);
            var itemArr1 = [
              {
                id: cookieValue,
                quantity: 1,
                properties: { _freeProduct: 1 },
              },
            ];

            Array.prototype.push.apply(itemArr, itemArr1);
          }
        }
        if (upCoverPid != "") {
          var itemArr1 = [
            {
              id: upCoverPid,
              quantity: 1,
            },
          ];
          Array.prototype.push.apply(itemArr, itemArr1);
        }
        if(bundleActiveVersion()){
          if(jQuery('.product_bundle_selector').find('#strap_accessories').is(":checked")){
            var selectedAccessories = preparePDPBundle();
            console.log("selectedAccessories",selectedAccessories);
            if (Array.isArray(selectedAccessories) && selectedAccessories.length) {
              for(var d=0;d<selectedAccessories.length;d++){
                itemArr.push({
                  id: selectedAccessories[d],
                  quantity: 1
                });
              }
            }
          }
        }

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'atc_2'
        });
        
        fetch("/cart/add.js", {
          body: JSON.stringify({
            items: itemArr,
          }),
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "xmlhttprequest",
          },
          method: "POST",
        })
          .then((response) => response.json())
          .then(
            function (data) {
              console.log("success" + data);
              if (data.status === 422) {
                this.error(data);
              } else {
                var product = data;
                this.success(product);
              }

              if (
                $("#free_minipad").is(":checked") ||
                $("#free__minipad").is(":checked") ||
                $("#free__minipad_3").is(":checked")
              ) {
                var successFreeStrap =
                  '<div class="product-single__related-free-item free_prod_added style-3" style="display:;">';
                successFreeStrap += '<div class="psrelated-item">';
                successFreeStrap += '<div class="psrelated-media">';
                successFreeStrap +=
                  '<img src="https://cdn.shopify.com/s/files/1/0512/7461/2920/files/Text_input_container.png?v=1700719028">';
                successFreeStrap += "</div>";
                successFreeStrap += '<div class="psrelated-content">';
                successFreeStrap +=
                  "<h2><span>GIFT UNLOCKED:</span> FREE IPHONE STRAP</h2>";
                successFreeStrap += '<div class="psrelated-review">';
                successFreeStrap += '<div class="psrelated-review-info">';
                successFreeStrap +=
                  "<span>Almost gone - last free straps left in stock!</span>";
                successFreeStrap += "</div>";
                successFreeStrap += "</div>";
                successFreeStrap += "</div>";
                successFreeStrap += "</div>";
                successFreeStrap += "</div>";

                $("#free_strp_product").html(successFreeStrap);
              }
              status.loading = false;
              this.addToCart.classList.remove("btn--loading");

              // Reload page if adding product from a section on the cart page
              if (document.body.classList.contains("template-cart")) {
                window.scrollTo(0, 0);
                location.reload();
              }
            }.bind(this)
          );

        /*fetch(theme.routes.cartAdd, {
          method: 'POST',
          body: data,
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
        .then(response => response.json())
        .then(function(data) {
          if (data.status === 422) {
            this.error(data);
          } else {
            var product = data;
            this.success(product);
          }
  
          status.loading = false;
          this.addToCart.classList.remove('btn--loading');
  
          // Reload page if adding product from a section on the cart page
          if (document.body.classList.contains('template-cart')) {
            window.scrollTo(0, 0);
            location.reload();
          }
        }.bind(this));*/
      },

      success: function (product) {
        var errors = this.form.querySelector(".errors");
        if (errors) {
          errors.remove();
        }

        document.dispatchEvent(
          new CustomEvent("ajaxProduct:added", {
            detail: {
              product: product,
              addToCartBtn: this.addToCart,
            },
          })
        );

        if (this.args && this.args.scopedEventId) {
          document.dispatchEvent(
            new CustomEvent("ajaxProduct:added:" + this.args.scopedEventId, {
              detail: {
                product: product,
                addToCartBtn: this.addToCart,
              },
            })
          );
        }
      },

      error: function (error) {
        if (!error.description) {
          console.warn(error);
          return;
        }

        var errors = this.form.querySelector(".errors");
        if (errors) {
          errors.remove();
        }

        var errorDiv = document.createElement("div");
        errorDiv.classList.add("errors", "text-center");
        errorDiv.textContent = error.description;
        this.form.append(errorDiv);

        document.dispatchEvent(
          new CustomEvent("ajaxProduct:error", {
            detail: {
              errorMessage: error.description,
            },
          })
        );

        if (this.args && this.args.scopedEventId) {
          document.dispatchEvent(
            new CustomEvent("ajaxProduct:error:" + this.args.scopedEventId, {
              detail: {
                errorMessage: error.description,
              },
            })
          );
        }
      },
    });

    return ProductForm;
  })();

  theme.ProductMedia = (function () {
    var modelJsonSections = {};
    var models = {};
    var xrButtons = {};

    var selectors = {
      mediaGroup: "[data-product-single-media-group]",
      xrButton: "[data-shopify-xr]",
    };

    function init(modelViewerContainers, sectionId) {
      modelJsonSections[sectionId] = {
        loaded: false,
      };

      modelViewerContainers.forEach(function (container, index) {
        var mediaId = container.dataset.mediaId;
        var modelViewerElement = container.querySelector("model-viewer");
        var modelId = modelViewerElement.dataset.modelId;

        if (index === 0) {
          var mediaGroup = container.closest(selectors.mediaGroup);
          var xrButton = mediaGroup.querySelector(selectors.xrButton);
          xrButtons[sectionId] = {
            element: xrButton,
            defaultId: modelId,
          };
        }

        models[mediaId] = {
          modelId: modelId,
          sectionId: sectionId,
          container: container,
          element: modelViewerElement,
        };
      });

      window.Shopify.loadFeatures([
        {
          name: "shopify-xr",
          version: "1.0",
          onLoad: setupShopifyXr,
        },
        {
          name: "model-viewer-ui",
          version: "1.0",
          onLoad: setupModelViewerUi,
        },
      ]);

      theme.LibraryLoader.load("modelViewerUiStyles");
    }

    function setupShopifyXr(errors) {
      if (errors) return;

      if (!window.ShopifyXR) {
        document.addEventListener("shopify_xr_initialized", function () {
          setupShopifyXr();
        });
        return;
      }

      for (var sectionId in modelJsonSections) {
        if (modelJsonSections.hasOwnProperty(sectionId)) {
          var modelSection = modelJsonSections[sectionId];

          if (modelSection.loaded) continue;

          var modelJson = document.querySelector("#ModelJson-" + sectionId);

          window.ShopifyXR.addModels(JSON.parse(modelJson.innerHTML));
          modelSection.loaded = true;
        }
      }
      window.ShopifyXR.setupXRElements();
    }

    function setupModelViewerUi(errors) {
      if (errors) return;

      for (var key in models) {
        if (models.hasOwnProperty(key)) {
          var model = models[key];
          if (!model.modelViewerUi && Shopify) {
            model.modelViewerUi = new Shopify.ModelViewerUI(model.element);
          }
          setupModelViewerListeners(model);
        }
      }
    }

    function setupModelViewerListeners(model) {
      var xrButton = xrButtons[model.sectionId];

      model.container.addEventListener("mediaVisible", function () {
        xrButton.element.setAttribute("data-shopify-model3d-id", model.modelId);
        if (theme.config.isTouch) return;
        model.modelViewerUi.play();
      });

      model.container.addEventListener("mediaHidden", function () {
        xrButton.element.setAttribute(
          "data-shopify-model3d-id",
          xrButton.defaultId
        );
        model.modelViewerUi.pause();
      });

      model.container.addEventListener("xrLaunch", function () {
        model.modelViewerUi.pause();
      });
    }

    function removeSectionModels(sectionId) {
      for (var key in models) {
        if (models.hasOwnProperty(key)) {
          var model = models[key];
          if (model.sectionId === sectionId) {
            delete models[key];
          }
        }
      }
      delete modelJsonSections[sectionId];
    }

    return {
      init: init,
      removeSectionModels: removeSectionModels,
    };
  })();

  theme.QtySelector = (function () {
    var selectors = {
      input: ".js-qty__num",
      plus: ".js-qty__adjust--plus",
      minus: ".js-qty__adjust--minus",
    };

    function QtySelector(el, options) {
      this.wrapper = el;
      this.plus = el.querySelector(selectors.plus);
      this.minus = el.querySelector(selectors.minus);
      this.input = el.querySelector(selectors.input);
      this.minValue = this.input.getAttribute("min") || 1;

      var defaults = {
        namespace: null,
        isCart: false,
        key: this.input.dataset.id,
      };

      this.options = Object.assign({}, defaults, options);

      this.init();
    }

    QtySelector.prototype = Object.assign({}, QtySelector.prototype, {
      init: function () {
        this.plus.addEventListener(
          "click",
          function () {
            var qty = this._getQty();
            this._change(qty + 1);
          }.bind(this)
        );

        this.minus.addEventListener(
          "click",
          function () {
            var qty = this._getQty();
            this._change(qty - 1);
          }.bind(this)
        );

        this.input.addEventListener(
          "change",
          function (evt) {
            this._change(this._getQty());
          }.bind(this)
        );
      },

      _getQty: function () {
        var qty = this.input.value;
        if (parseFloat(qty) == parseInt(qty) && !isNaN(qty)) {
          // We have a valid number!
        } else {
          // Not a number. Default to 1.
          qty = 1;
        }
        return parseInt(qty);
      },

      _change: function (qty) {
        if (qty <= this.minValue) {
          qty = this.minValue;
        }

        this.input.value = qty;

        if (this.options.isCart) {
          document.dispatchEvent(
            new CustomEvent("cart:quantity" + this.options.namespace, {
              detail: [this.options.key, qty, this.wrapper],
            })
          );
        }
      },
    });

    return QtySelector;
  })();

  theme.initQuickShop = function () {
    var ids = [];
    var products = document.querySelectorAll(".grid-product");

    if (!products.length || !theme.settings.quickView) {
      return;
    }

    products.forEach((product) => {
      product.addEventListener("mouseover", productMouseover);
    });

    function productMouseover(evt) {
      var el = evt.currentTarget;
      // No quick view on mobile breakpoint
      if (!theme.config.bpSmall) {
        el.removeEventListener("mouseover", productMouseover);
        if (!el || !el.dataset.productId) {
          // Onboarding product, no real data
          return;
        }
        var productId = el.dataset.productId;
        var handle = el.dataset.productHandle;
        var btn = el.querySelector(".quick-product__btn");
        theme.preloadProductModal(handle, productId, btn);
      }
    }
  };

  theme.preloadProductModal = function (handle, productId, btn) {
    var holder = document.getElementById("QuickShopHolder-" + handle);
    var url = theme.routes.home + "/products/" + handle + "?view=modal";

    // remove double `/` in case shop might have /en or language in URL
    url = url.replace("//", "/");

    fetch(url)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        // Convert the HTML string into a document object
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, "text/html");
        var div = doc.querySelector(
          '.product-section[data-product-handle="' + handle + '"]'
        );

        if (!holder) {
          return;
        }

        holder.innerHTML = "";
        holder.append(div);

        // Setup quick view modal
        var modalId = "QuickShopModal-" + productId;
        var name = "quick-modal-" + productId;
        new theme.Modals(modalId, name);

        // Register product template inside quick view
        theme.sections.register("product", theme.Product, holder);

        // Register collapsible elements
        theme.collapsibles.init();

        // Register potential video modal links (when video has sound)
        theme.videoModal();

        if (btn) {
          btn.classList.remove("quick-product__btn--not-ready");
        }
      });
  };

  // theme.Slideshow handles all flickity based sliders
  // Child navigation is only setup to work on product images
  theme.Slideshow = (function () {
    var classes = {
      animateOut: "animate-out",
      isPaused: "is-paused",
      isActive: "is-active",
    };

    var selectors = {
      allSlides: ".slideshow__slide",
      currentSlide: ".is-selected",
      wrapper: ".slideshow-wrapper",
      pauseButton: ".slideshow__pause",
    };

    var productSelectors = {
      thumb: ".product__thumb-item:not(.hide)",
      links: ".product__thumb-item:not(.hide) a",
      arrow: ".product__thumb-arrow",
    };

    var defaults = {
      adaptiveHeight: false,
      autoPlay: false,
      avoidReflow: false, // custom by Archetype
      childNav: null, // element. Custom by Archetype instead of asNavFor
      childNavScroller: null, // element
      childVertical: false,
      dragThreshold: 7,
      fade: false,
      friction: 0.8,
      initialIndex: 0,
      pageDots: false,
      pauseAutoPlayOnHover: false,
      prevNextButtons: true,
      rightToLeft: theme.config.rtl,
      selectedAttraction: 0.14,
      setGallerySize: true,
      wrapAround: true,
    };

    function slideshow(el, args) {
      this.el = el;
      this.args = Object.assign({}, defaults, args);

      // Setup listeners as part of arguments
      this.args.on = {
        ready: this.init.bind(this),
        change: this.slideChange.bind(this),
        settle: this.afterChange.bind(this),
      };

      if (this.args.childNav) {
        this.childNavEls = this.args.childNav.querySelectorAll(
          productSelectors.thumb
        );
        this.childNavLinks = this.args.childNav.querySelectorAll(
          productSelectors.links
        );
        this.arrows = this.args.childNav.querySelectorAll(
          productSelectors.arrow
        );
        if (this.childNavLinks.length) {
          this.initChildNav();
        }
      }

      if (this.args.avoidReflow) {
        if(el!=null){
          avoidReflow(el);
        }
      }

      this.slideshow = new Flickity(el, this.args);
      slideshowThumb = this.slideshow;

      if (this.args.autoPlay) {
        var wrapper = el.closest(selectors.wrapper);
        this.pauseBtn = wrapper.querySelector(selectors.pauseButton);
        if (this.pauseBtn) {
          this.pauseBtn.addEventListener("click", this._togglePause.bind(this));
        }
      }

      // Reset dimensions on resize
      window.on(
        "resize",
        theme.utils.debounce(
          300,
          function () {
            this.resize();
          }.bind(this)
        )
      );

      // Set flickity-viewport height to first element to
      // avoid awkward page reflows while initializing.
      // Must be added in a `style` tag because element does not exist yet.
      // Slideshow element must have an ID
      function avoidReflow(el) {
        if (!el.id) return;
        var firstChild = el.firstChild;
        while (firstChild != null && firstChild.nodeType == 3) {
          // skip TextNodes
          firstChild = firstChild.nextSibling;
        }
        var style = document.createElement("style");
        style.innerHTML = `#${el.id} .flickity-viewport{height:${firstChild.offsetHeight}px}`;
        document.head.appendChild(style);
      }
    }

    slideshow.prototype = Object.assign({}, slideshow.prototype, {
      init: function (el) {
        this.currentSlide = this.el.querySelector(selectors.currentSlide);

        // Optional onInit callback
        if (this.args.callbacks && this.args.callbacks.onInit) {
          if (typeof this.args.callbacks.onInit === "function") {
            this.args.callbacks.onInit(this.currentSlide);
          }
        }

        if (window.AOS) {
          AOS.refresh();
        }
      },

      slideChange: function (index) {
        // Outgoing fade styles
        if (this.args.fade && this.currentSlide) {
          this.currentSlide.classList.add(classes.animateOut);
          this.currentSlide.addEventListener(
            "transitionend",
            function () {
              this.currentSlide.classList.remove(classes.animateOut);
            }.bind(this)
          );
        }

        // Match index with child nav
        if (this.args.childNav) {
          this.childNavGoTo(index);
        }

        // Optional onChange callback
        if (this.args.callbacks && this.args.callbacks.onChange) {
          if (typeof this.args.callbacks.onChange === "function") {
            this.args.callbacks.onChange(index);
          }
        }

        // Show/hide arrows depending on selected index
        if (this.arrows && this.arrows.length) {
          this.arrows[0].classList.toggle("hide", index === 0);
          this.arrows[1].classList.toggle(
            "hide",
            index === this.childNavLinks.length - 1
          );
        }
      },
      afterChange: function (index) {
        // Remove all fade animation classes after slide is done
        if (this.args.fade) {
          this.el.querySelectorAll(selectors.allSlides).forEach((slide) => {
            slide.classList.remove(classes.animateOut);
          });
        }

        this.currentSlide = this.el.querySelector(selectors.currentSlide);

        // Match index with child nav (in case slider height changed first)
        if (this.args.childNav) {
          this.childNavGoTo(this.slideshow.selectedIndex);
        }
      },
      destroy: function () {
        if (this.args.childNav && this.childNavLinks.length) {
          this.childNavLinks.forEach((a) => {
            a.classList.remove(classes.isActive);
          });
        }
        this.slideshow.destroy();
      },
      reposition: function () {
        this.slideshow.reposition();
      },
      reloadCells: function () {
        this.slideshow.reloadCells();
      },
      _togglePause: function () {
        if (this.pauseBtn.classList.contains(classes.isPaused)) {
          this.pauseBtn.classList.remove(classes.isPaused);
          this.slideshow.playPlayer();
        } else {
          this.pauseBtn.classList.add(classes.isPaused);
          this.slideshow.pausePlayer();
        }
      },
      resize: function () {
        this.slideshow.resize();
      },
      play: function () {
        this.slideshow.playPlayer();
      },
      pause: function () {
        this.slideshow.pausePlayer();
      },
      goToSlide: function (i) {
        this.slideshow.select(i);
      },
      setDraggable: function (enable) {
        this.slideshow.options.draggable = enable;
        this.slideshow.updateDraggable();
      },

      initChildNav: function () {
        const link = this.childNavLinks[this.args.initialIndex];
        if (link) {
          link.classList.add("is-active");
        }

        // Setup events
        this.childNavLinks.forEach((link, i) => {
          // update data-index because image-set feature may be enabled
          link.setAttribute("data-index", i);

          link.addEventListener(
            "click",
            function (evt) {
              evt.preventDefault();
              this.goToSlide(this.getChildIndex(evt.currentTarget));
            }.bind(this)
          );
          link.addEventListener(
            "focus",
            function (evt) {
              this.goToSlide(this.getChildIndex(evt.currentTarget));
            }.bind(this)
          );
          link.addEventListener(
            "keydown",
            function (evt) {
              if (evt.keyCode === 13) {
                this.goToSlide(this.getChildIndex(evt.currentTarget));
              }
            }.bind(this)
          );
        });

        // Setup optional arrows
        if (this.arrows.length) {
          this.arrows.forEach((arrow) => {
            arrow.addEventListener("click", this.arrowClick.bind(this));
          });
        }
      },

      getChildIndex: function (target) {
        return parseInt(target.dataset.index);
      },

      childNavGoTo: function (index) {
        this.childNavLinks.forEach((a) => {
          a.blur();
          a.classList.remove(classes.isActive);
        });

        var el = this.childNavLinks[index];
        if(el!=null){
          el.classList.add(classes.isActive);
        }

        if (!this.args.childNavScroller) {
          return;
        }
        if(el!=null){
          if (this.args.childVertical) {
            var elTop = el.offsetTop;
            this.args.childNavScroller.scrollTop = elTop - 100;
          } else {
            var elLeft = el.offsetLeft;
            this.args.childNavScroller.scrollLeft = elLeft - 100;
          }
        }
      },

      arrowClick: function (evt) {
        if (
          evt.currentTarget.classList.contains("product__thumb-arrow--prev")
        ) {
          this.slideshow.previous();
        } else {
          this.slideshow.next();
        }
      },
    });

    return slideshow;
  })();

  /*============================================================================
    VariantAvailability
    - Cross out sold out or unavailable variants
    - To disable, set dynamicVariantsEnable to false in theme.liquid
    - Required markup:
      - class=variant-input-wrap to wrap select or button group
      - class=variant-input to wrap button/label
  ==============================================================================*/

  theme.VariantAvailability = (function () {
    var classes = {
      disabled: "disabled",
    };

    function availability(args) {
      this.type = args.type;
      this.variantsObject = args.variantsObject;
      this.currentVariantObject = args.currentVariantObject;
      this.container = args.container;
      this.namespace = args.namespace;

      this.init();
    }

    availability.prototype = Object.assign({}, availability.prototype, {
      init: function () {
        this.container.on(
          "variantChange" + this.namespace,
          this.setAvailability.bind(this)
        );

        // Set default state based on current selected variant
        this.setAvailability(null, this.currentVariantObject);
      },

      setAvailability: function (evt, variant) {
        if (evt) {
          var variant = evt.detail.variant;
        }

        // Object to hold all options by value.
        // This will be what sets a button/dropdown as
        // sold out or unavailable (not a combo set as purchasable)
        var valuesToManage = {
          option1: [],
          option2: [],
          option3: [],
        };

        var ignoreIndex = null;
        var availableVariants = this.variantsObject.filter(function (el) {
          if (!variant || variant.id === el.id) {
            return false;
          }

          if (
            variant.option2 === el.option2 &&
            variant.option3 === el.option3
          ) {
            return true;
          }

          if (
            variant.option1 === el.option1 &&
            variant.option3 === el.option3
          ) {
            return true;
          }

          if (
            variant.option1 === el.option1 &&
            variant.option2 === el.option2
          ) {
            return true;
          }
        });

        var variantObject = {
          variant: variant,
        };

        var variants = Object.assign({}, { variant }, availableVariants);

        // Disable all options to start.
        // If coming from a variant change event, do not disable
        // options inside current index group
        this.container
          .querySelectorAll(".variant-input-wrap")
          .forEach((group) => {
            this.disableVariantGroup(group);
          });

        // Loop through each available variant to gather variant values
        for (var property in variants) {
          if (variants.hasOwnProperty(property)) {
            var item = variants[property];
            if (!item) {
              return;
            }

            var value1 = item.option1;
            var value2 = item.option2;
            var value3 = item.option3;
            var soldOut = item.available === false;

            if (value1 && ignoreIndex !== "option1") {
              valuesToManage.option1.push({
                value: value1,
                soldOut: soldOut,
              });
            }
            if (value2 && ignoreIndex !== "option2") {
              valuesToManage.option2.push({
                value: value2,
                soldOut: soldOut,
              });
            }
            if (value3 && ignoreIndex !== "option3") {
              valuesToManage.option3.push({
                value: value3,
                soldOut: soldOut,
              });
            }
          }
        }

        // Loop through all option levels and send each
        // value w/ args to function that determines to show/hide/enable/disable
        for (var [option, values] of Object.entries(valuesToManage)) {
          this.manageOptionState(option, values);
        }
      },

      manageOptionState: function (option, values) {
        var group = this.container.querySelector(
          '.variant-input-wrap[data-index="' + option + '"]'
        );

        // Loop through each option value
        values.forEach((obj) => {
          this.enableVariantOption(group, obj);
        });
      },

      enableVariantOptionByValue: function (array, index) {
        var group = this.container.querySelector(
          '.variant-input-wrap[data-index="' + index + '"]'
        );

        for (var i = 0; i < array.length; i++) {
          this.enableVariantOption(group, array[i]);
        }
      },

      enableVariantOption: function (group, obj) {
        // Selecting by value so escape it
        var value = obj.value.replace(
          /([ #;&,.+*~\':"!^$[\]()=>|\/@])/g,
          "\\$1"
        );

        if (this.type === "dropdown") {
          group.querySelector('option[value="' + value + '"]').disabled = false;
        } else {
          var buttonGroup = group.querySelector(
            '.variant-input[data-value="' + value + '"]'
          );
          if(buttonGroup!=null){
            var input = buttonGroup.querySelector("input");
            var label = buttonGroup.querySelector("label");

            // Variant exists - enable & show variant
            input.classList.remove(classes.disabled);
            label.classList.remove(classes.disabled);

            // Variant sold out - cross out option (remains selectable)
            if (obj.soldOut) {
              input.classList.add(classes.disabled);
              label.classList.add(classes.disabled);
            }
          }
        }
      },

      disableVariantGroup: function (group) {
        if (this.type === "dropdown") {
          group.querySelectorAll("option").forEach((option) => {
            option.disabled = true;
          });
        } else {
          group.querySelectorAll("input").forEach((input) => {
            input.classList.add(classes.disabled);
          });
          group.querySelectorAll("label").forEach((label) => {
            label.classList.add(classes.disabled);
          });
        }
      },
    });

    return availability;
  })();

  // Video modal will auto-initialize for any anchor link that points to YouTube
  // MP4 videos must manually be enabled with:
  //   - .product-video-trigger--mp4 (trigger button)
  //   - .product-video-mp4-sound video player element (cloned into modal)
  //     - see media.liquid for example of this
  theme.videoModal = function () {
    var youtubePlayer;

    var videoHolderId = "VideoHolder";
    var selectors = {
      youtube: 'a[href*="youtube.com/watch"], a[href*="youtu.be/"]',
      mp4Trigger: ".product-video-trigger--mp4",
      mp4Player: ".product-video-mp4-sound",
    };

    var youtubeTriggers = document.querySelectorAll(selectors.youtube);
    var mp4Triggers = document.querySelectorAll(selectors.mp4Trigger);

    if (!youtubeTriggers.length && !mp4Triggers.length) {
      return;
    }

    var videoHolderDiv = document.getElementById(videoHolderId);

    if (youtubeTriggers.length) {
      theme.LibraryLoader.load("youtubeSdk");
    }

    var modal = new theme.Modals("VideoModal", "video-modal", {
      closeOffContentClick: true,
      bodyOpenClass: ["modal-open", "video-modal-open"],
      solid: true,
    });

    youtubeTriggers.forEach((btn) => {
      btn.addEventListener("click", triggerYouTubeModal);
    });

    mp4Triggers.forEach((btn) => {
      btn.addEventListener("click", triggerMp4Modal);
    });

    document.addEventListener("modalClose.VideoModal", closeVideoModal);

    function triggerYouTubeModal(evt) {
      // If not already loaded, treat as normal link
      if (!theme.config.youTubeReady) {
        return;
      }

      evt.preventDefault();
      emptyVideoHolder();

      modal.open(evt);

      var videoId = getYoutubeVideoId(evt.currentTarget.getAttribute("href"));
      youtubePlayer = new theme.YouTube(videoHolderId, {
        videoId: videoId,
        style: "sound",
        events: {
          onReady: onYoutubeReady,
        },
      });
    }

    function triggerMp4Modal(evt) {
      emptyVideoHolder();

      var el = evt.currentTarget;
      var player = el.parentNode.querySelector(selectors.mp4Player);

      // Clone video element and place it in the modal
      var playerClone = player.cloneNode(true);
      playerClone.classList.remove("hide");

      videoHolderDiv.append(playerClone);
      modal.open(evt);

      // Play new video element
      videoHolderDiv.querySelector("video").play();
    }

    function onYoutubeReady(evt) {
      evt.target.unMute();
      evt.target.playVideo();
    }

    function getYoutubeVideoId(url) {
      var regExp =
        /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
      var match = url.match(regExp);
      return match && match[7].length == 11 ? match[7] : false;
    }

    function emptyVideoHolder() {
      videoHolderDiv.innerHTML = "";
    }

    function closeVideoModal() {
      if (youtubePlayer && typeof youtubePlayer.destroy === "function") {
        youtubePlayer.destroy();
      } else {
        emptyVideoHolder();
      }
    }
  };

  theme.announcementBar = (function () {
    var args = {
      autoPlay: 5000,
      avoidReflow: true,
      cellAlign: theme.config.rtl ? "right" : "left",
    };
    var bar;
    var flickity;

    function init() {
      bar = document.getElementById("AnnouncementSlider");
      if (!bar) {
        return;
      }

      unload();

      if (bar.dataset.blockCount === 1) {
        return;
      }

      if (theme.config.bpSmall || bar.dataset.compact === "true") {
        initSlider();
      }

      document.addEventListener("matchSmall", function () {
        unload();
        initSlider();
      });

      document.addEventListener("unmatchSmall", function () {
        unload();
        if (bar.dataset.compact === "true") {
          initSlider();
        }
      });
    }

    function initSlider() {
      flickity = new theme.Slideshow(bar, args);
    }

    // Go to slide if selected in the editor
    function onBlockSelect(id) {
      var slide = bar.querySelector("#AnnouncementSlide-" + id);
      var index = parseInt(slide.dataset.index);

      if (flickity && typeof flickity.pause === "function") {
        flickity.goToSlide(index);
        flickity.pause();
      }
    }

    function onBlockDeselect() {
      if (flickity && typeof flickity.play === "function") {
        flickity.play();
      }
    }

    function unload() {
      if (flickity && typeof flickity.destroy === "function") {
        flickity.destroy();
      }
    }

    return {
      init: init,
      onBlockSelect: onBlockSelect,
      onBlockDeselect: onBlockDeselect,
      unload: unload,
    };
  })();

  theme.customerTemplates = function () {
    checkUrlHash();
    initEventListeners();
    resetPasswordSuccess();
    customerAddressForm();

    function checkUrlHash() {
      var hash = window.location.hash;

      // Allow deep linking to recover password form
      if (hash === "#recover") {
        toggleRecoverPasswordForm();
      }
    }

    function toggleRecoverPasswordForm() {
      var passwordForm = document
        .getElementById("RecoverPasswordForm")
        .classList.toggle("hide");
      var loginForm = document
        .getElementById("CustomerLoginForm")
        .classList.toggle("hide");
    }

    function initEventListeners() {
      // Show reset password form
      var recoverForm = document.getElementById("RecoverPassword");
      if (recoverForm) {
        recoverForm.addEventListener("click", function (evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
        });
      }

      // Hide reset password form
      var hideRecoverPassword = document.getElementById(
        "HideRecoverPasswordLink"
      );
      if (hideRecoverPassword) {
        hideRecoverPassword.addEventListener("click", function (evt) {
          evt.preventDefault();
          toggleRecoverPasswordForm();
        });
      }
    }

    function resetPasswordSuccess() {
      var formState = document.querySelector(".reset-password-success");

      // check if reset password form was successfully submitted
      if (!formState) {
        return;
      }

      // show success message
      document.getElementById("ResetSuccess").classList.remove("hide");
    }

    function customerAddressForm() {
      var newAddressForm = document.getElementById("AddressNewForm");
      var addressForms = document.querySelectorAll(".js-address-form");

      if (!newAddressForm || !addressForms.length) {
        return;
      }

      // Country/province selector can take a short time to load
      setTimeout(function () {
        document.querySelectorAll(".js-address-country").forEach((el) => {
          var countryId = el.dataset.countryId;
          var provinceId = el.dataset.provinceId;
          var provinceContainerId = el.dataset.provinceContainerId;

          new Shopify.CountryProvinceSelector(countryId, provinceId, {
            hideElement: provinceContainerId,
          });
        });
      }, 1000);

      // Toggle new/edit address forms
      document.querySelectorAll(".address-new-toggle").forEach((el) => {
        el.addEventListener("click", function () {
          newAddressForm.classList.toggle("hide");
        });
      });

      document.querySelectorAll(".address-edit-toggle").forEach((el) => {
        el.addEventListener("click", function (evt) {
          var formId = evt.currentTarget.dataset.formId;
          document
            .getElementById("EditAddress_" + formId)
            .classList.toggle("hide");
        });
      });

      document.querySelectorAll(".address-delete").forEach((el) => {
        el.addEventListener("click", function (evt) {
          var formId = evt.currentTarget.dataset.formId;
          var confirmMessage = evt.currentTarget.dataset.confirmMessage;

          if (
            confirm(
              confirmMessage || "Are you sure you wish to delete this address?"
            )
          ) {
            if (Shopify) {
              Shopify.postLink("/account/addresses/" + formId, {
                parameters: { _method: "delete" },
              });
            }
          }
        });
      });
    }
  };

  theme.CartDrawer = (function () {
    var selectors = {
      drawer: "#CartDrawer",
      form: "#CartDrawerForm",
    };

    function CartDrawer() {
      this.form = document.querySelector(selectors.form);
      this.drawer = new theme.Drawers("CartDrawer", "cart");

      this.init();
    }

    CartDrawer.prototype = Object.assign({}, CartDrawer.prototype, {
      init: function () {
        this.cartForm = new theme.CartForm(this.form);
        this.cartForm.buildCart();

        document.addEventListener(
          "ajaxProduct:added",
          function (evt) {
            this.cartForm.buildCart();
            this.open();
          }.bind(this)
        );

        // Dev-friendly way to open cart
        document.addEventListener("cart:open", this.open.bind(this));
        document.addEventListener("cart:close", this.close.bind(this));
      },

      open: function () {
        this.drawer.open();
      },

      close: function () {
        this.drawer.close();
      },
    });

    return CartDrawer;
  })();

  theme.headerNav = (function () {
    var selectors = {
      wrapper: "#HeaderWrapper",
      siteHeader: "#SiteHeader",
      searchBtn: ".js-search-header",
      closeSearch: "#SearchClose",
      searchContainer: ".site-header__search-container",
      logo: "#LogoContainer img",
      megamenu: ".megamenu",
      navItems: ".site-nav__item",
      navLinks: ".site-nav__link",
      navLinksWithDropdown: ".site-nav__link--has-dropdown",
      navDropdownLinks: ".site-nav__dropdown-link--second-level",
    };

    var classes = {
      hasDropdownClass: "site-nav--has-dropdown",
      hasSubDropdownClass: "site-nav__deep-dropdown-trigger",
      dropdownActive: "is-focused",
    };

    var config = {
      namespace: ".siteNav",
      wrapperOverlayed: false,
      overlayedClass: "is-light",
      overlayEnabledClass: "header-wrapper--sticky",
      stickyEnabled: false,
      stickyActive: false,
      stickyClass: "site-header--stuck",
      stickyHeaderWrapper: "StickyHeaderWrap",
      openTransitionClass: "site-header--opening",
      lastScroll: 0,
    };

    // Elements used in resize functions, defined in init
    var wrapper;
    var siteHeader;

    function init() {
      wrapper = document.querySelector(selectors.wrapper);
      siteHeader = document.querySelector(selectors.siteHeader);

      config.stickyEnabled = siteHeader.dataset.sticky === "true";
      if (config.stickyEnabled) {
        config.wrapperOverlayed = wrapper.classList.contains(
          config.overlayedClass
        );
        stickyHeaderCheck();
      }

      theme.settings.overlayHeader = siteHeader.dataset.overlay === "true";
      // Disable overlay header if on collection template with no collection image
      if (theme.settings.overlayHeader && Shopify && Shopify.designMode) {
        if (
          document.body.classList.contains("template-collection") &&
          !document.querySelector(".collection-hero")
        ) {
          this.disableOverlayHeader();
        }
      }

      accessibleDropdowns();
      searchDrawer();

      window.on("load" + config.namespace, resizeLogo);
      window.on(
        "resize" + config.namespace,
        theme.utils.debounce(150, resizeLogo)
      );
    }

    // If the header setting to overlay the menu on the collection image
    // is enabled but the collection setting is disabled, we need to undo
    // the init of the sticky nav
    function disableOverlayHeader() {
      wrapper.classList.remove(
        config.overlayEnabledClass,
        config.overlayedClass
      );
      config.wrapperOverlayed = false;
      theme.settings.overlayHeader = false;
    }

    function stickyHeaderCheck() {
      // Disable sticky header if any mega menu is taller than window
      theme.config.stickyHeader = doesMegaMenuFit();

      if (theme.config.stickyHeader) {
        config.forceStopSticky = false;
        stickyHeader();
      } else {
        config.forceStopSticky = true;
      }
    }

    function doesMegaMenuFit() {
      var largestMegaNav = 0;
      siteHeader.querySelectorAll(selectors.megamenu).forEach((nav) => {
        var h = nav.offsetHeight;
        if (h > largestMegaNav) {
          largestMegaNav = h;
        }
      });

      // 120 ~ space of visible header when megamenu open
      if (window.innerHeight < largestMegaNav + 120) {
        return false;
      }

      return true;
    }

    function stickyHeader() {
      config.lastScroll = 0;

      var wrapWith = document.createElement("div");
      wrapWith.id = config.stickyHeaderWrapper;
      theme.utils.wrap(siteHeader, wrapWith);

      stickyHeaderHeight();

      window.on(
        "resize" + config.namespace,
        theme.utils.debounce(50, stickyHeaderHeight)
      );
      window.on(
        "scroll" + config.namespace,
        theme.utils.throttle(20, stickyHeaderScroll)
      );

      // This gets messed up in the editor, so here's a fix
      if (Shopify && Shopify.designMode) {
        setTimeout(function () {
          stickyHeaderHeight();
        }, 250);
      }
    }

    function stickyHeaderHeight() {
      if (!config.stickyEnabled) {
        return;
      }
      var h = siteHeader.offsetHeight;
      var stickyHeader = document.querySelector(
        "#" + config.stickyHeaderWrapper
      );
      stickyHeader.style.height = h + "px";
    }

    function stickyHeaderScroll() {
      if (!config.stickyEnabled) {
        return;
      }

      if (config.forceStopSticky) {
        return;
      }

      requestAnimationFrame(scrollHandler);

      config.lastScroll = window.scrollY;
    }

    function scrollHandler() {
      if (window.scrollY > 250) {
        if (config.stickyActive) {
          return;
        }

        config.stickyActive = true;

        siteHeader.classList.add(config.stickyClass);
        if (config.wrapperOverlayed) {
          wrapper.classList.remove(config.overlayedClass);
        }

        // Add open transition class after element is set to fixed
        // so CSS animation is applied correctly
        setTimeout(function () {
          siteHeader.classList.add(config.openTransitionClass);
        }, 100);
      } else {
        if (!config.stickyActive) {
          return;
        }

        config.stickyActive = false;

        siteHeader.classList.remove(config.openTransitionClass);
        siteHeader.classList.remove(config.stickyClass);
        if (config.wrapperOverlayed) {
          wrapper.classList.add(config.overlayedClass);
        }
      }
    }

    function accessibleDropdowns() {
      var hasActiveDropdown = false;
      var hasActiveSubDropdown = false;
      var closeOnClickActive = false;

      // Touch devices open dropdown on first click, navigate to link on second
      if (theme.config.isTouch) {
        document
          .querySelectorAll(selectors.navLinksWithDropdown)
          .forEach((el) => {
            el.on("touchend" + config.namespace, function (evt) {
              var parent = evt.currentTarget.parentNode;
              if (!parent.classList.contains(classes.dropdownActive)) {
                evt.preventDefault();
                closeDropdowns();
                openFirstLevelDropdown(evt.currentTarget);
              } else {
                window.location.replace(evt.currentTarget.getAttribute("href"));
              }
            });
          });
      }

      // Open/hide top level dropdowns
      document.querySelectorAll(selectors.navLinks).forEach((el) => {
        el.on("focusin" + config.namespace, accessibleMouseEvent);
        el.on("mouseover" + config.namespace, accessibleMouseEvent);
        el.on("mouseleave" + config.namespace, closeDropdowns);
      });

      document.querySelectorAll(selectors.navDropdownLinks).forEach((el) => {
        if (theme.config.isTouch) {
          el.on("touchend" + config.namespace, function (evt) {
            var parent = evt.currentTarget.parentNode;

            // Open third level menu or go to link based on active state
            if (parent.classList.contains(classes.hasSubDropdownClass)) {
              if (!parent.classList.contains(classes.dropdownActive)) {
                evt.preventDefault();
                closeThirdLevelDropdown();
                openSecondLevelDropdown(evt.currentTarget);
              } else {
                window.location.replace(evt.currentTarget.getAttribute("href"));
              }
            } else {
              // No third level nav, go to link
              window.location.replace(evt.currentTarget.getAttribute("href"));
            }
          });
        }

        // Open/hide sub level dropdowns
        el.on("focusin" + config.namespace, function (evt) {
          closeThirdLevelDropdown();
          openSecondLevelDropdown(evt.currentTarget, true);
        });
      });

      // Clicking outside of the megamenu should close it
      if (theme.config.isTouch) {
        document.body.on("touchend" + config.namespace, function () {
          closeDropdowns();
        });

        // Exception to above: clicking anywhere on the megamenu content will NOT close it
        siteHeader.querySelectorAll(selectors.megamenu).forEach((el) => {
          el.on("touchend" + config.namespace, function (evt) {
            evt.stopImmediatePropagation();
          });
        });
      }

      function accessibleMouseEvent(evt) {
        if (hasActiveDropdown) {
          closeSecondLevelDropdown();
        }

        if (hasActiveSubDropdown) {
          closeThirdLevelDropdown();
        }

        openFirstLevelDropdown(evt.currentTarget);
      }

      // Private dropdown functions
      function openFirstLevelDropdown(el) {
        var parent = el.parentNode;
        if (parent.classList.contains(classes.hasDropdownClass)) {
          parent.classList.add(classes.dropdownActive);
          hasActiveDropdown = true;
        }

        if (!theme.config.isTouch) {
          if (!closeOnClickActive) {
            var eventType = theme.config.isTouch ? "touchend" : "click";
            closeOnClickActive = true;
            document.documentElement.on(
              eventType + config.namespace,
              function () {
                closeDropdowns();
                document.documentElement.off(eventType + config.namespace);
                closeOnClickActive = false;
              }.bind(this)
            );
          }
        }
      }

      function openSecondLevelDropdown(el, skipCheck) {
        var parent = el.parentNode;
        if (
          parent.classList.contains(classes.hasSubDropdownClass) ||
          skipCheck
        ) {
          parent.classList.add(classes.dropdownActive);
          hasActiveSubDropdown = true;
        }
      }

      function closeDropdowns() {
        closeSecondLevelDropdown();
        closeThirdLevelDropdown();
      }

      function closeSecondLevelDropdown() {
        document.querySelectorAll(selectors.navItems).forEach((el) => {
          el.classList.remove(classes.dropdownActive);
        });
      }

      function closeThirdLevelDropdown() {
        document.querySelectorAll(selectors.navDropdownLinks).forEach((el) => {
          el.parentNode.classList.remove(classes.dropdownActive);
        });
      }
    }

    function searchDrawer() {
      document.querySelectorAll(selectors.searchBtn).forEach((btn) => {
        btn.addEventListener("click", openSearchDrawer);
      });

      document
        .querySelector(selectors.closeSearch)
        .addEventListener("click", closeSearchDrawer);
    }

    function openSearchDrawer(evt) {
      evt.preventDefault();
      evt.stopImmediatePropagation();
      var container = document.querySelector(selectors.searchContainer);
      theme.utils.prepareTransition(
        container,
        function () {
          container.classList.add("is-active");
        }.bind(this)
      );

      document.documentElement.classList.add(
        "js-drawer-open",
        "js-drawer-open--search"
      );

      setTimeout(function () {
        theme.a11y.trapFocus({
          container: container,
          namespace: "header_search",
          elementToFocus: container.querySelector(".site-header__search-input"),
        });
      }, 100);

      // If sticky is enabled, scroll to top on mobile when close to it
      // so you don't get an invisible search box
      if (
        theme.config.bpSmall &&
        config.stickyEnabled &&
        config.lastScroll < 300
      ) {
        window.scrollTo(0, 0);
      }

      // Bind events
      theme.a11y.lockMobileScrolling(config.namespace);

      bindSearchEvents();
    }

    function closeSearchDrawer(evt) {
      // Do not close if click event came from inside drawer
      if (evt) {
        // evt.path is non-standard, so have fallback
        var path = evt.path || (evt.composedPath && evt.composedPath());
        for (var i = 0; i < path.length; i++) {
          if (path[i].classList) {
            if (path[i].classList.contains("site-header__search-btn")) {
              break;
            }

            if (path[i].classList.contains("site-header__search-container")) {
              return;
            }
          }
        }
      }

      // deselect any focused form elements
      document.activeElement.blur();

      document.documentElement.classList.add("js-drawer-closing");
      document.documentElement.classList.remove(
        "js-drawer-open",
        "js-drawer-open--search"
      );

      window.setTimeout(
        function () {
          document.documentElement.classList.remove("js-drawer-closing");
        }.bind(this),
        500
      );

      var container = document.querySelector(selectors.searchContainer);
      theme.utils.prepareTransition(
        container,
        function () {
          container.classList.remove("is-active");
        }.bind(this)
      );

      theme.a11y.removeTrapFocus({
        container: container,
        namespace: "header_search",
      });

      theme.a11y.unlockMobileScrolling(config.namespace);

      unbindSearchEvents();
    }

    function bindSearchEvents() {
      window.on(
        "keyup" + config.namespace,
        function (evt) {
          if (evt.keyCode === 27) {
            closeSearchDrawer();
          }
        }.bind(this)
      );

      // Clicking out of container closes it
      document.documentElement.on(
        "click" + config.namespace,
        function (evt) {
          closeSearchDrawer(evt);
        }.bind(this)
      );
    }

    function unbindSearchEvents() {
      window.off("keyup" + config.namespace);
      document.documentElement.off("click" + config.namespace);
    }

    function resizeLogo(evt) {
      document.querySelectorAll(selectors.logo).forEach((logo) => {
        var logoWidthOnScreen = logo.clientWidth;
        var containerWidth = logo.closest(".header-item").clientWidth;

        // If image exceeds container, let's make it smaller
        if (logoWidthOnScreen > containerWidth) {
          logo.style.maxWidth = containerWidth;
        } else {
          logo.removeAttribute("style");
        }
      });
    }
    return {
      init: init,
      disableOverlayHeader: disableOverlayHeader,
    };
  })();

  window.onpageshow = function (evt) {
    // Removes unload class when returning to page via history
    if (evt.persisted) {
      document.body.classList.remove("unloading");
      document.querySelectorAll(".cart__checkout").forEach((el) => {
        el.classList.remove("btn--loading");
      });
    }
  };

  theme.predictiveSearch = (function () {
    var currentString = "";
    var isLoading = false;
    var searchTimeout;
    var namespace = ".predictive";

    var selectors = {
      form: "#HeaderSearchForm",
      input: 'input[type="search"]',
      wrapper: "#PredictiveWrapper",
      resultDiv: "#PredictiveResults",

      searchButton: "[data-predictive-search-button]",
    };

    var cache = {};
    var config = {
      imageSize: "square",
    };

    var classes = {
      isActive: "predicitive-active",
    };

    var keys = {
      up_arrow: 38,
      down_arrow: 40,
      tab: 9,
    };

    function init() {
      // Only some languages support predictive search
      if (document.getElementById("shopify-features")) {
        var supportedShopifyFeatures = JSON.parse(
          document.getElementById("shopify-features").innerHTML
        );
        if (!supportedShopifyFeatures.predictiveSearch) {
          return;
        }
      }

      cache.wrapper = document.querySelector(selectors.wrapper);

      if (!cache.wrapper) {
        return;
      }

      config.imageSize = cache.wrapper.dataset.imageSize;

      cache.form = document.querySelector(selectors.form);
      cache.form.setAttribute("autocomplete", "off");
      cache.form.on("submit" + namespace, submitSearch);

      cache.input = cache.form.querySelector(selectors.input);
      cache.input.on("keyup" + namespace, handleKeyup);

      cache.submit = cache.wrapper.querySelector(selectors.searchButton);
      cache.submit.on("click" + namespace, triggerSearch);

      cache.results = document.querySelector(selectors.resultDiv);
    }

    function reset() {
      cache.wrapper.classList.add("hide");
      cache.results.innerHTML = "";
      clearTimeout(searchTimeout);
    }

    function triggerSearch() {
      cache.form.submit();
    }

    // Append * wildcard to search
    function submitSearch(evt) {
      evt.preventDefault ? evt.preventDefault() : (evt.returnValue = false);

      var obj = {};
      var formData = new FormData(evt.target);
      for (var key of formData.keys()) {
        obj[key] = formData.get(key);
      }

      if (obj.q) {
        obj.q += "*";
      }

      var params = paramUrl(obj);

      window.location.href = `${theme.routes.search}?${params}`;
      return false;
    }

    function handleKeyup(evt) {
      if (evt.keyCode === keys.up_arrow) {
        return;
      }

      if (evt.keyCode === keys.down_arrow) {
        return;
      }

      if (evt.keyCode === keys.tab) {
        return;
      }

      search();
    }

    function search() {
      var keyword = cache.input.value;

      if (keyword === "") {
        reset();
        return;
      }

      var q = _normalizeQuery(keyword);

      clearTimeout(searchTimeout);
      searchTimeout = setTimeout(
        function () {
          predictQuery(q);
        }.bind(this),
        500
      );
    }

    function predictQuery(q) {
      if (isLoading) {
        return;
      }

      // Do not re-search the same thing
      if (currentString === q) {
        return;
      }

      currentString = q;
      isLoading = true;

      var searchObj = {
        q: q,
        "resources[type]": theme.settings.predictiveSearchType,
        "resources[limit]": 4,
        "resources[options][unavailable_products]": "last",
        "resources[options][fields]":
          "title,product_type,variants.title,vendor",
      };

      var params = paramUrl(searchObj);

      fetch("/search/suggest.json?" + params)
        .then((response) => response.json())
        .then((suggestions) => {
          isLoading = false;
          var data = {};
          var resultCount = 0;

          cache.wrapper.classList.remove("hide");
          var resultTypes = Object.entries(suggestions.resources.results);

          Object.keys(resultTypes).forEach(function (i) {
            var obj = resultTypes[i];
            var type = obj[0];
            var results = obj[1];
            resultCount += results.length;

            switch (type) {
              case "products":
                data[type] = buildProducts(results);
                break;
              case "collections":
                data[type] = buildCollections(results);
                break;
              case "pages":
                data[type] = buildPages(results);
                break;
              case "articles":
                data[type] = buildArticles(results);
                break;
            }
          });

          if (resultCount === 0) {
            reset();
            return;
          }

          // Build and append result markup
          var output = buildOutput(data);
          cache.results.innerHTML = "";
          cache.results.innerHTML = output;
        });
    }

    function buildProducts(results) {
      var output = "";
      var products = [];

      results.forEach((product) => {
        var new_product = {
          title: product.title,
          url: product.url,
          image_responsive_url: theme.Images.lazyloadImagePath(product.image),
          image_aspect_ratio: product.featured_image.aspect_ratio,
        };

        products.push(new_product);
      });

      if (products.length) {
        var markup = theme.buildProductGridItem(
          products,
          "small--one-half medium-up--one-quarter",
          4,
          config.imageSize
        );

        output = `
          <div data-type-products>
            <div class="grid grid--uniform">
              ${markup}
            </div>
          </div>
        `;
      }

      return output;
    }

    function buildCollections(collections) {
      var output = "";

      if (collections.length) {
        var markup = theme.buildCollectionItem(collections);

        output = `
          <div data-type-collections>
            <p class="h6 predictive__label">${theme.strings.searchCollections}</p>
            <ul class="no-bullets">
              ${markup}
            </ul>
          </div>
        `;
      }

      return output;
    }

    function buildPages(pages) {
      var output = "";

      if (pages.length) {
        var markup = theme.buildPageItem(pages);

        output = `
          <div data-type-pages>
            <p class="h6 predictive__label">${theme.strings.searchPages}</p>
            <ul class="no-bullets">
              ${markup}
            </ul>
          </div>
        `;
      }

      return output;
    }

    // Overwrite full sized image returned form API
    // with lazyloading-friendly path
    function buildArticles(articles) {
      var output = "";

      articles.forEach((article) => {
        if (article.image) {
          article.image = theme.Images.getSizedImageUrl(
            article.image,
            "200x200_crop_center"
          );
        }
      });

      if (articles.length) {
        var markup = theme.buildArticleItem(articles, config.imageSize);

        output = `
          <div data-type-articles>
            <p class="h6 predictive__label">${theme.strings.searchArticles}</p>
            <div class="grid grid--uniform">
              ${markup}
            </div>
          </div>
        `;
      }

      return output;
    }

    // Combine all search result markup and print to page
    function buildOutput(data) {
      var output = "";

      if (data.products && data.products !== "") {
        output += data.products;
      }

      if (data.collections && data.collections !== "") {
        output += data.collections;
      }

      if (data.pages && data.pages !== "") {
        output += data.pages;
      }

      if (data.articles && data.articles !== "") {
        output += data.articles;
      }

      return output;
    }

    function _normalizeQuery(string) {
      if (typeof string !== "string") {
        return null;
      }

      return string.trim().replace(/\ /g, "-").toLowerCase();
    }

    function paramUrl(obj) {
      return Object.keys(obj)
        .map(function (key) {
          return key + "=" + encodeURIComponent(obj[key]);
        })
        .join("&");
    }

    return {
      init: init,
    };
  })();

  theme.buildProductGridItem = function (items, gridWidth, rowOf, imageSize) {
    var output = "";

    items.forEach((product) => {
      var image = theme.buildProductImage(product, imageSize);
      var markup = `
        <div class="grid__item grid-product ${gridWidth} aos-animate" data-aos="row-of-${rowOf}">
          <div class="grid-product__content">
            <a href="${product.url}" class="grid-product__link">
              <div class="grid-product__image-mask">
                ${image}
              </div>
              <div class="grid-product__meta">
                <div class="grid-product__title">${product.title}</div>
              </div>
            </a>
          </div>
        </div>
      `;

      output += markup;
    });

    return output;
  };

  theme.buildProductImage = function (product, imageSize) {
    var size = imageSize ? imageSize : theme.settings.productImageSize;
    var output = "";

    if (size === "natural") {
      output = `
        <div class="image-wrap" style="height: 0; padding-bottom: ${product.image_aspect_ratio}%;">
          <img class="grid-product__image lazyload"
            data-src="${product.image_responsive_url}"
            data-widths="[180, 360, 540, 720, 900]"
            data-aspectratio="${product.image_aspect_ratio}"
            data-sizes="auto"
            alt="${product.title}">
        </div>`;
    } else {
      var classes = "lazyload";
      if (!theme.settings.productImageCover) {
        classes += " grid__image-contain";
      }
      output = `
        <div class="grid__image-ratio grid__image-ratio--${size}">
          <img class="${classes}"
              data-src="${product.image_responsive_url}"
              data-widths="[360, 540, 720, 900, 1080]"
              data-aspectratio="${product.aspect_ratio}"
              data-sizes="auto"
              alt="${product.title}">
        </div>
      `;
    }

    return output;
  };

  theme.buildCollectionItem = function (items) {
    var output = "";

    items.forEach((collection) => {
      var markup = `
        <li>
          <a href="${collection.url}">
            ${collection.title}
          </a>
        </li>
      `;

      output += markup;
    });

    return output;
  };

  theme.buildPageItem = function (items) {
    var output = "";

    items.forEach((page) => {
      var markup = `
        <li>
          <a href="${page.url}">
            ${page.title}
          </a>
        </li>
      `;

      output += markup;
    });

    return output;
  };

  theme.buildArticleItem = function (items, imageSize) {
    var output = "";

    items.forEach((article) => {
      var image = theme.buildPredictiveImage(article);
      var markup = `
        <div class="grid__item grid-product small--one-half medium-up--one-quarter" data-aos="row-of-4">
          <a href="${article.url}" class="grid-product__link grid-product__link--inline">
            <div class="grid-product__image-mask">
              <div
                class="grid__image-ratio grid__image-ratio--object grid__image-ratio--${imageSize}">
                <div class="predictive__image-wrap">
                  ${image}
                </div>
              </div>
            </div>
            <div class="grid-product__meta">
              ${article.title}
            </div>
          </a>
        </div>
      `;

      output += markup;
    });

    return output;
  };

  theme.buildPredictiveImage = function (obj) {
    var imageMarkup = "";
    if (obj.image) {
      imageMarkup = `<img class="lazyload"
            data-src="${obj.image}"
            data-widths="[360, 540, 720]"
            data-sizes="auto">`;
    }
    return imageMarkup;
  };

  theme.Maps = (function () {
    var config = {
      zoom: 14,
    };
    var apiStatus = null;
    var mapsToLoad = [];

    var errors = {};

    var selectors = {
      section: '[data-section-type="map"]',
      map: "[data-map]",
      mapOverlay: ".map-section__overlay",
    };

    // Global function called by Google on auth errors.
    // Show an auto error message on all map instances.
    window.gm_authFailure = function () {
      if (!Shopify.designMode) {
        return;
      }

      document.querySelectorAll(selectors.section).forEach((section) => {
        section.classList.add("map-section--load-error");
      });

      document.querySelectorAll(selectors.map).forEach((map) => {
        map.parentNode.removeChild(map);
      });

      window.mapError(theme.strings.authError);
    };

    window.mapError = function (error) {
      var message = document.createElement("div");
      message.classList.add("map-section__error", "errors", "text-center");
      message.innerHTML = error;
      document.querySelectorAll(selectors.mapOverlay).forEach((overlay) => {
        overlay.parentNode.prepend(message);
      });
      document.querySelectorAll(".map-section__link").forEach((link) => {
        link.classList.add("hide");
      });
    };

    function Map(container) {
      this.container = container;
      this.sectionId = this.container.getAttribute("data-section-id");
      this.namespace = ".map-" + this.sectionId;
      this.map = container.querySelector(selectors.map);
      this.key = this.map.dataset.apiKey;

      errors = {
        addressNoResults: theme.strings.addressNoResults,
        addressQueryLimit: theme.strings.addressQueryLimit,
        addressError: theme.strings.addressError,
        authError: theme.strings.authError,
      };

      if (!this.key) {
        return;
      }

      theme.initWhenVisible({
        element: this.container,
        callback: this.prepMapApi.bind(this),
        threshold: 20,
      });
    }

    // API has loaded, load all Map instances in queue
    function initAllMaps() {
      mapsToLoad.forEach((instance) => {
        instance.createMap();
      });
    }

    function geolocate(map) {
      var geocoder = new google.maps.Geocoder();

      if (!map) {
        return;
      }

      var address = map.dataset.addressSetting;

      var deferred = new Promise((resolve, reject) => {
        geocoder.geocode({ address: address }, function (results, status) {
          if (status !== google.maps.GeocoderStatus.OK) {
            reject(status);
          }
          resolve(results);
        });
      });

      return deferred;
    }

    Map.prototype = Object.assign({}, Map.prototype, {
      prepMapApi: function () {
        if (apiStatus === "loaded") {
          this.createMap();
        } else {
          mapsToLoad.push(this);

          if (apiStatus !== "loading") {
            apiStatus = "loading";
            if (
              typeof window.google === "undefined" ||
              typeof window.google.maps === "undefined"
            ) {
              var script = document.createElement("script");
              script.onload = function () {
                apiStatus = "loaded";
                initAllMaps();
              };
              script.src =
                "https://maps.googleapis.com/maps/api/js?key=" + this.key;
              document.head.appendChild(script);
            }
          }
        }
      },

      createMap: function () {
        var mapDiv = this.map;

        return geolocate(mapDiv)
          .then(
            function (results) {
              var mapOptions = {
                zoom: config.zoom,
                backgroundColor: "none",
                center: results[0].geometry.location,
                draggable: false,
                clickableIcons: false,
                scrollwheel: false,
                disableDoubleClickZoom: true,
                disableDefaultUI: true,
              };

              var map = (this.map = new google.maps.Map(mapDiv, mapOptions));
              var center = (this.center = map.getCenter());

              var marker = new google.maps.Marker({
                map: map,
                position: map.getCenter(),
              });

              google.maps.event.addDomListener(
                window,
                "resize",
                theme.utils.debounce(250, function () {
                  google.maps.event.trigger(map, "resize");
                  map.setCenter(center);
                  mapDiv.removeAttribute("style");
                })
              );

              if (Shopify.designMode) {
                if (window.AOS) {
                  AOS.refreshHard();
                }
              }
            }.bind(this)
          )
          .catch(function (status) {
            var errorMessage;

            switch (status) {
              case "ZERO_RESULTS":
                errorMessage = errors.addressNoResults;
                break;
              case "OVER_QUERY_LIMIT":
                errorMessage = errors.addressQueryLimit;
                break;
              case "REQUEST_DENIED":
                errorMessage = errors.authError;
                break;
              default:
                errorMessage = errors.addressError;
                break;
            }

            // Show errors only to merchant in the editor.
            if (Shopify.designMode) {
              window.mapError(errorMessage);
            }
          });
      },

      onUnload: function () {
        if (this.map.length === 0) {
          return;
        }
        // Causes a harmless JS error when a section without an active map is reloaded
        if (google && google.maps && google.maps.event) {
          google.maps.event.clearListeners(this.map, "resize");
        }
      },
    });

    return Map;
  })();

  theme.NewsletterPopup = (function () {
    function NewsletterPopup(container) {
      this.container = container;
      var sectionId = this.container.getAttribute("data-section-id");
      this.cookieName = "newsletter-" + sectionId;

      if (!container) {
        return;
      }

      // Prevent popup on Shopify robot challenge page
      if (window.location.pathname === "/challenge") {
        return;
      }

      // Prevent popup on password page
      if (window.location.pathname === "/password") {
        return;
      }

      this.data = {
        secondsBeforeShow: container.dataset.delaySeconds,
        daysBeforeReappear: container.dataset.delayDays,
        cookie: Cookies.get(this.cookieName),
        testMode: container.dataset.testMode,
      };

      this.modal = new theme.Modals(
        "NewsletterPopup-" + sectionId,
        "newsletter-popup-modal"
      );

      // Set cookie if optional button is clicked
      var btn = container.querySelector(".popup-cta a");
      if (btn) {
        btn.addEventListener(
          "click",
          function () {
            this.closePopup(true);
          }.bind(this)
        );
      }

      // Open modal if errors or success message exist
      if (
        container.querySelector(".errors") ||
        container.querySelector(".note--success")
      ) {
        this.modal.open();
      }

      // Set cookie as opened if success message
      if (container.querySelector(".note--success")) {
        this.closePopup(true);
        return;
      }

      document.addEventListener(
        "modalClose." + container.id,
        this.closePopup.bind(this)
      );

      if (!this.data.cookie || this.data.testMode === "true") {
        this.initPopupDelay();
      }
    }

    NewsletterPopup.prototype = Object.assign({}, NewsletterPopup.prototype, {
      initPopupDelay: function () {
        if (Shopify && Shopify.designMode) {
          return;
        }
        setTimeout(
          function () {
            this.modal.open();
          }.bind(this),
          this.data.secondsBeforeShow * 1000
        );
      },

      closePopup: function (success) {
        // Remove a cookie in case it was set in test mode
        if (this.data.testMode === "true") {
          Cookies.remove(this.cookieName, { path: "/" });
          return;
        }

        var expiry = success ? 200 : this.data.daysBeforeReappear;
        Cookies.set(this.cookieName, "opened", { path: "/", expires: expiry });
      },

      onLoad: function () {
        this.modal.open();
      },

      onSelect: function () {
        this.modal.open();
      },

      onDeselect: function () {
        this.modal.close();
      },
    });

    return NewsletterPopup;
  })();

  theme.PasswordHeader = (function () {
    function PasswordHeader() {
      this.init();
    }

    PasswordHeader.prototype = Object.assign({}, PasswordHeader.prototype, {
      init: function () {
        if (!document.querySelector("#LoginModal")) {
          return;
        }

        var passwordModal = new theme.Modals("LoginModal", "login-modal", {
          focusIdOnOpen: "password",
          solid: true,
        });

        // Open modal if errors exist
        if (document.querySelectorAll(".errors").length) {
          passwordModal.open();
        }
      },
    });

    return PasswordHeader;
  })();

  theme.Photoswipe = (function () {
    var selectors = {
      trigger: ".js-photoswipe__zoom",
      images: ".photoswipe__image",
      slideshowTrack: ".flickity-viewport ",
      activeImage: ".is-selected",
    };

    function Photoswipe(container, sectionId) {
      this.container = container;
      this.sectionId = sectionId;
      this.namespace = ".photoswipe-" + this.sectionId;
      this.gallery;
      this.images;
      this.items;
      this.inSlideshow = false;

      if (!container || container.dataset.zoom === "false") {
        return;
      }

      if (container.dataset.hasSlideshow === "true") {
        this.inSlideshow = true;
      }

      this.init();
    }

    Photoswipe.prototype = Object.assign({}, Photoswipe.prototype, {
      init: function () {
        this.container
          .querySelectorAll(selectors.trigger)
          .forEach((trigger) => {
            trigger.on("click" + this.namespace, this.triggerClick.bind(this));
          });
      },

      triggerClick: function (evt) {
        this.items = this.getImageData();

        var image = this.inSlideshow
          ? this.container.querySelector(selectors.activeImage)
          : evt.currentTarget;

        var index = this.inSlideshow
          ? this.getChildIndex(image)
          : image.dataset.index;

        this.initGallery(this.items, index);
      },

      // Because of image set feature, need to get index based on location in parent
      getChildIndex: function (el) {
        var i = 0;
        while ((el = el.previousSibling) != null) {
          i++;
        }

        // 1-based index required
        return i + 1;
      },

      getImageData: function () {
        this.images = this.inSlideshow
          ? this.container.querySelectorAll(
              selectors.slideshowTrack + selectors.images
            )
          : this.container.querySelectorAll(selectors.images);

        var items = [];
        var options = {};

        this.images.forEach((el) => {
          var item = {
            msrc: el.currentSrc || el.src,
            src: el.getAttribute("data-photoswipe-src"),
            w: el.getAttribute("data-photoswipe-width"),
            h: el.getAttribute("data-photoswipe-height"),
            el: el,
            initialZoomLevel: 0.5,
          };

          items.push(item);
        });

        return items;
      },

      initGallery: function (items, index) {
        var pswpElement = document.querySelectorAll(".pswp")[0];

        var options = {
          allowPanToNext: false,
          captionEl: false,
          closeOnScroll: false,
          counterEl: false,
          history: false,
          index: index - 1,
          pinchToClose: false,
          preloaderEl: false,
          scaleMode: "zoom",
          shareEl: false,
          tapToToggleControls: false,
          getThumbBoundsFn: function (index) {
            var pageYScroll =
              window.pageYOffset || document.documentElement.scrollTop;
            var thumbnail = items[index].el;
            var rect = thumbnail.getBoundingClientRect();
            return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
          },
        };

        this.gallery = new PhotoSwipe(
          pswpElement,
          PhotoSwipeUI_Default,
          items,
          options
        );
        this.gallery.listen("afterChange", this.afterChange.bind(this));
        this.gallery.init();

        this.preventiOS15Scrolling();
      },

      afterChange: function () {
        var index = this.gallery.getCurrentIndex();
        this.container.dispatchEvent(
          new CustomEvent("photoswipe:afterChange", {
            detail: {
              index: index,
            },
          })
        );
      },

      syncHeight: function () {
        document.documentElement.style.setProperty(
          "--window-inner-height",
          `${window.innerHeight}px`
        );
      },

      // Fix poached from https://gist.github.com/dimsemenov/0b8c255c0d87f2989e8ab876073534ea
      preventiOS15Scrolling: function () {
        let initialScrollPos;

        if (!/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) return;

        this.syncHeight();

        // Store scroll position to restore it later
        initialScrollPos = window.scrollY;

        // Add class to root element when PhotoSwipe opens
        document.documentElement.classList.add("pswp-open-in-ios");

        window.addEventListener("resize", this.syncHeight);

        this.gallery.listen("destroy", () => {
          document.documentElement.classList.remove("pswp-open-in-ios");
          window.scrollTo(0, initialScrollPos);
        });
      },
    });

    return Photoswipe;
  })();

  theme.Recommendations = (function () {
    var selectors = {
      placeholder: ".product-recommendations-placeholder",
      sectionClass: " .product-recommendations",
      productResults: ".grid-product",
    };

    function Recommendations(container) {
      this.container = container;
      this.sectionId = container.getAttribute("data-section-id");
      this.url = container.dataset.url;

      selectors.recommendations = "Recommendations-" + this.sectionId;

      theme.initWhenVisible({
        element: container,
        callback: this.init.bind(this),
        threshold: 500,
      });
    }

    Recommendations.prototype = Object.assign({}, Recommendations.prototype, {
      init: function () {
        var section = document.getElementById(selectors.recommendations);

        if (!section || section.dataset.enable === "false") {
          return;
        }

        var id = section.dataset.productId;
        var limit = section.dataset.limit;

        var url =
          this.url +
          "?section_id=product-recommendations&limit=" +
          limit +
          "&product_id=" +
          id;

        // When section his hidden and shown, make sure it starts empty
        if (Shopify.designMode) {
          var wrapper = section.querySelector(selectors.sectionClass);
          if (wrapper) {
            wrapper.innerHTML = "";
          }
        }

        fetch(url)
          .then(function (response) {
            return response.text();
          })
          .then(
            function (html) {
              // Convert the HTML string into a document object
              var parser = new DOMParser();
              var doc = parser.parseFromString(html, "text/html");
              var div = doc.querySelector(selectors.sectionClass);
              var placeholder = section.querySelector(selectors.placeholder);
              if (!placeholder) {
                return;
              }

              placeholder.innerHTML = "";

              if (!div) {
                this.container.classList.add("hide");
                if (AOS) {
                  AOS.refreshHard();
                }
                return;
              }

              placeholder.appendChild(div);

              theme.reinitProductGridItem(section);

              document.dispatchEvent(
                new CustomEvent("recommendations:loaded", {
                  detail: {
                    section: section,
                  },
                })
              );

              // If no results, hide the entire section
              var results = div.querySelectorAll(selectors.productResults);
              if (results.length === 0) {
                this.container.classList.add("hide");
              }
            }.bind(this)
          );
      },
    });

    return Recommendations;
  })();

  theme.SlideshowSection = (function () {
    var selectors = {
      parallaxContainer: ".parallax-container",
    };

    function SlideshowSection(container) {
      this.container = container;
      var sectionId = container.getAttribute("data-section-id");
      this.slideshow = container.querySelector("#Slideshow-" + sectionId);
      this.namespace = "." + sectionId;

      this.initialIndex = 0;

      if (!this.slideshow) {
        return;
      }

      // Get shopify-created div that section markup lives in,
      // then get index of it inside its parent
      var sectionEl = container.parentElement;
      var sectionIndex = [].indexOf.call(
        sectionEl.parentElement.children,
        sectionEl
      );

      if (sectionIndex === 0) {
        this.init();
      } else {
        theme.initWhenVisible({
          element: this.container,
          callback: this.init.bind(this),
        });
      }
    }

    SlideshowSection.prototype = Object.assign({}, SlideshowSection.prototype, {
      init: function () {
        var slides = this.slideshow.querySelectorAll(".slideshow__slide");

        if (this.container.hasAttribute("data-immediate-load")) {
          this.slideshow.classList.remove("loading", "loading--delayed");
          this.slideshow.classList.add("loaded");
        } else {
          // Wait for image to load before marking as done
          theme.loadImageSection(this.slideshow);
        }

        if (slides.length > 1) {
          var sliderArgs = {
            prevNextButtons: this.slideshow.hasAttribute("data-arrows"),
            pageDots: this.slideshow.hasAttribute("data-dots"),
            fade: true,
            setGallerySize: false,
            initialIndex: this.initialIndex,
            autoPlay:
              this.slideshow.dataset.autoplay === "true"
                ? parseInt(this.slideshow.dataset.speed)
                : false,
          };

          this.flickity = new theme.Slideshow(this.slideshow, sliderArgs);
        } else {
          // Add loaded class to first slide
          slides[0].classList.add("is-selected");
        }

        if (this.container.hasAttribute("data-parallax")) {
          // Create new parallax for each slideshow image
          this.container.querySelectorAll(selectors.parallaxContainer).forEach(
            function (el, i) {
              new theme.Parallax(el, {
                namespace: this.namespace + "-parallax-" + i,
              });
            }.bind(this)
          );
        }
      },

      forceReload: function () {
        this.onUnload();
        this.init();
      },

      onUnload: function () {
        if (this.flickity && typeof this.flickity.destroy === "function") {
          this.flickity.destroy();
        }
      },

      onDeselect: function () {
        if (this.flickity && typeof this.flickity.play === "function") {
          this.flickity.play();
        }
      },

      onBlockSelect: function (evt) {
        var slide = this.slideshow.querySelector(
          ".slideshow__slide--" + evt.detail.blockId
        );
        var index = parseInt(slide.dataset.index);

        if (this.flickity && typeof this.flickity.pause === "function") {
          this.flickity.goToSlide(index);
          this.flickity.pause();
        } else {
          // If section reloads, slideshow might not have been setup yet, wait a second and try again
          this.initialIndex = index;
          setTimeout(
            function () {
              if (this.flickity && typeof this.flickity.pause === "function") {
                this.flickity.pause();
              }
            }.bind(this),
            1000
          );
        }
      },

      onBlockDeselect: function () {
        if (this.flickity && typeof this.flickity.play === "function") {
          if (this.flickity.args.autoPlay) {
            this.flickity.play();
          }
        }
      },
    });

    return SlideshowSection;
  })();

  theme.StoreAvailability = (function () {
    var selectors = {
      drawerOpenBtn: ".js-drawer-open-availability",
      modalOpenBtn: ".js-modal-open-availability",
      productTitle: "[data-availability-product-title]",
    };

    function StoreAvailability(container) {
      this.container = container;
      this.baseUrl = container.dataset.baseUrl;
      this.productTitle = container.dataset.productName;
    }

    StoreAvailability.prototype = Object.assign(
      {},
      StoreAvailability.prototype,
      {
        updateContent: function (variantId) {
          var variantSectionUrl =
            this.baseUrl +
            "/variants/" +
            variantId +
            "/?section_id=store-availability";

          var self = this;

          fetch(variantSectionUrl)
            .then(function (response) {
              return response.text();
            })
            .then(function (html) {
              if (html.trim() === "") {
                this.container.innerHTML = "";
                return;
              }

              self.container.innerHTML = html;
              self.container.innerHTML =
                self.container.firstElementChild.innerHTML;

              // Setup drawer if have open button
              if (self.container.querySelector(selectors.drawerOpenBtn)) {
                self.drawer = new theme.Drawers(
                  "StoreAvailabilityDrawer",
                  "availability"
                );
              }

              // Setup modal if have open button
              if (self.container.querySelector(selectors.modalOpenBtn)) {
                self.modal = new theme.Modals(
                  "StoreAvailabilityModal",
                  "availability"
                );
              }

              var title = self.container.querySelector(selectors.productTitle);
              if (title) {
                title.textContent = self.productTitle;
              }
            });
        },
      }
    );

    return StoreAvailability;
  })();

  theme.VideoSection = (function () {
    var selectors = {
      videoParent: ".video-parent-section",
    };

    function videoSection(container) {
      this.container = container;
      this.sectionId = container.getAttribute("data-section-id");
      this.namespace = ".video-" + this.sectionId;
      this.videoObject;

      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 500,
      });
    }

    videoSection.prototype = Object.assign({}, videoSection.prototype, {
      init: function () {
        var dataDiv = this.container.querySelector(".video-div");
        if (!dataDiv) {
          return;
        }
        var type = dataDiv.dataset.type;

        switch (type) {
          case "youtube":
            var videoId = dataDiv.dataset.videoId;
            this.initYoutubeVideo(videoId);
            break;
          case "vimeo":
            var videoId = dataDiv.dataset.videoId;
            this.initVimeoVideo(videoId);
            break;
          case "mp4":
            this.initMp4Video();
            break;
        }
      },

      initYoutubeVideo: function (videoId) {
        this.videoObject = new theme.YouTube("YouTubeVideo-" + this.sectionId, {
          videoId: videoId,
          videoParent: selectors.videoParent,
        });
      },

      initVimeoVideo: function (videoId) {
        this.videoObject = new theme.VimeoPlayer(
          "Vimeo-" + this.sectionId,
          videoId,
          {
            videoParent: selectors.videoParent,
          }
        );
      },

      initMp4Video: function () {
        var mp4Video = "Mp4Video-" + this.sectionId;
        var mp4Div = document.getElementById(mp4Video);
        var parent = mp4Div.closest(selectors.videoParent);

        if (mp4Div) {
          parent.classList.add("loaded");

          var playPromise = document.querySelector("#" + mp4Video).play();

          // Edge does not return a promise (video still plays)
          if (playPromise !== undefined) {
            playPromise
              .then(function () {
                // playback normal
              })
              .catch(function () {
                mp4Div.setAttribute("controls", "");
                parent.classList.add("video-interactable");
              });
          }
        }
      },

      onUnload: function (evt) {
        var sectionId = evt.target.id.replace("shopify-section-", "");
        if (
          this.videoObject &&
          typeof this.videoObject.destroy === "function"
        ) {
          this.videoObject.destroy();
        }
      },
    });

    return videoSection;
  })();

  theme.BackgroundImage = (function () {
    var selectors = {
      parallaxContainer: ".parallax-container",
    };

    function backgroundImage(container) {
      this.container = container;
      if (!container) {
        return;
      }

      var sectionId = container.getAttribute("data-section-id");
      this.namespace = "." + sectionId;

      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
      });
    }

    backgroundImage.prototype = Object.assign({}, backgroundImage.prototype, {
      init: function () {
        if (this.container.dataset && this.container.dataset.parallax) {
          var parallaxContainer = this.container.querySelector(
            selectors.parallaxContainer
          );
          var args = {
            namespace: this.namespace + "-parallax",
            desktopOnly: true,
          };

          theme.parallaxSections[this.namespace] = new theme.Parallax(
            parallaxContainer,
            args
          );
        }
      },

      onUnload: function (evt) {
        if (!this.container) {
          return;
        }
        if (
          theme.parallaxSections[this.namespace] &&
          typeof theme.parallaxSections[this.namespace].destroy === "function"
        ) {
          theme.parallaxSections[this.namespace].destroy();
        }
        delete theme.parallaxSections[this.namespace];
      },
    });

    return backgroundImage;
  })();

  theme.Blog = (function () {
    function Blog(container) {
      this.tagFilters();
    }

    Blog.prototype = Object.assign({}, Blog.prototype, {
      tagFilters: function () {
        var filterBy = document.getElementById("BlogTagFilter");

        if (!filterBy) {
          return;
        }

        filterBy.addEventListener("change", function () {
          location.href = filterBy.value;
        });
      },
    });

    return Blog;
  })();

  theme.CollectionHeader = (function () {
    var hasLoadedBefore = false;

    function CollectionHeader(container) {
      this.namespace = ".collection-header";

      var heroImageContainer = container.querySelector(".collection-hero");
      if (heroImageContainer) {
        if (hasLoadedBefore) {
          this.checkIfNeedReload();
        }
        theme.loadImageSection(heroImageContainer);

        if (container.dataset && container.dataset.parallax) {
          var parallaxContainer = container.querySelector(
            ".parallax-container"
          );
          var args = {
            namespace: this.namespace + "-parallax",
          };
          theme.parallaxSections[this.namespace] = new theme.Parallax(
            parallaxContainer,
            args
          );
        }
      } else if (theme.settings.overlayHeader) {
        theme.headerNav.disableOverlayHeader();
      }

      hasLoadedBefore = true;
    }

    CollectionHeader.prototype = Object.assign({}, CollectionHeader.prototype, {
      // A liquid variable in the header needs a full page refresh
      // if the collection header hero image setting is enabled
      // and the header is set to sticky. Only necessary in the editor.
      checkIfNeedReload: function () {
        if (!Shopify.designMode) {
          return;
        }

        if (theme.settings.overlayHeader) {
          var header = document.querySelector(".header-wrapper");
          if (!header.classList.contains("header-wrapper--overlay")) {
            location.reload();
          }
        }
      },

      onUnload: function () {
        if (theme.parallaxSections[this.namespace]) {
          theme.parallaxSections[this.namespace].destroy();
          delete theme.parallaxSections[this.namespace];
        }
      },
    });

    return CollectionHeader;
  })();

  theme.CollectionSidebar = (function () {
    var drawerStyle = false;
    var selectors = {
      sidebar: "#CollectionSidebar",
    };

    function CollectionSidebar(container) {
      this.container = container.querySelector(selectors.sidebar);
    }

    CollectionSidebar.prototype = Object.assign(
      {},
      CollectionSidebar.prototype,
      {
        init: function () {
          // Do not load when no sidebar exists
          if (!this.container) {
            return;
          }

          this.onUnload();

          drawerStyle = this.container.dataset.style === "drawer";
          theme.FilterDrawer = new theme.Drawers(
            "FilterDrawer",
            "collection-filters",
            true
          );
        },

        forceReload: function () {
          this.init();
        },

        onSelect: function () {
          console.log("1")
          if (theme.FilterDrawer) {
            if (!drawerStyle) {
              theme.FilterDrawer.close();
              return;
            }

            if (drawerStyle || theme.config.bpSmall) {
              theme.FilterDrawer.open();
            }
          }
        },

        onDeselect: function () {
          console.log("2")
          if (theme.FilterDrawer) {
            theme.FilterDrawer.close();
          }
        },

        onUnload: function () {
          console.log("3")
          if (theme.FilterDrawer) {
            theme.FilterDrawer.close();
          }
        },
      }
    );

    return CollectionSidebar;
  })();

  theme.Collection = (function () {
    var isAnimating = false;

    var selectors = {
      sortSelect: "#SortBy",

      colorSwatchImage: ".grid-product__color-image",
      colorSwatch: ".color-swatch--with-image",

      collectionGrid: ".collection-grid__wrapper",
      trigger: ".collapsible-trigger",
      sidebar: "#CollectionSidebar",
      filterSidebar: ".collapsible-content--sidebar",
      activeTagList: ".tag-list--active-tags",
      tags: ".tag-list input",
      activeTags: ".tag-list a",
      activeTagsClose: ".tag-list a",
      applyFilter: ".tag-list-apply",
      tagsForm: ".filter-form",
      filters: ".collection-filter",
      priceRange: ".price-range",
    };

    var classes = {
      activeTag: "tag--active",
      removeTagParent: "tag--remove",
      filterSidebar: "collapsible-content--sidebar",
      isOpen: "is-open",
    };

    function Collection(container) {
      this.container = container;
      this.sectionId = container.getAttribute("data-section-id");
      this.namespace = ".collection-" + this.sectionId;
      this.sidebar = new theme.CollectionSidebar(container);
      this.ajaxRenderer = new theme.AjaxRenderer({
        sections: [
          {
            sectionId: this.sectionId,
            nodeId: "CollectionAjaxContent",
          },
        ],
        onReplace: this.onReplaceAjaxContent.bind(this),
        preserveParams: ["sort_by", "q", "options[prefix]", "type"],
      });

      this.init();
    }

    Collection.prototype = Object.assign({}, Collection.prototype, {
      init: function () {
        this.initSort();
        this.colorSwatchHovering();
        this.initFilters();
        this.initPriceRange();
        this.sidebar.init();
      },

      initSort: function () {
        this.sortSelect = document.querySelector(selectors.sortSelect);

        if (this.sortSelect) {
          this.defaultSort = this.getDefaultSortValue();
          this.sortSelect.on(
            "change" + this.namespace,
            this.onSortChange.bind(this)
          );
          this.initParams();
        }
      },

      initParams: function () {
        this.queryParams = {};

        if (location.search.length) {
          var aKeyValue;
          var aCouples = location.search.substr(1).split("&");
          for (var i = 0; i < aCouples.length; i++) {
            aKeyValue = aCouples[i].split("=");
            if (aKeyValue.length > 1) {
              this.queryParams[decodeURIComponent(aKeyValue[0])] =
                decodeURIComponent(aKeyValue[1]);
            }
          }
        }
      },

      getSortValue: function () {
        return this.sortSelect.value || this.defaultSort;
      },

      getDefaultSortValue: function () {
        return this.sortSelect.getAttribute("data-default-sortby");
      },

      onSortChange: function () {
        this.queryParams.sort_by = this.getSortValue();

        if (this.queryParams.page) {
          delete this.queryParams.page;
        }

        window.location.search = decodeURIComponent(
          new URLSearchParams(Object.entries(this.queryParams))
        );
      },

      colorSwatchHovering: function () {
        var colorImages = this.container.querySelectorAll(
          selectors.colorSwatchImage
        );
        if (!colorImages.length) {
          return;
        }

        this.container
          .querySelectorAll(selectors.colorSwatch)
          .forEach((swatch) => {
            swatch.addEventListener("mouseenter", function () {
              var id = swatch.dataset.variantId;
              var image = swatch.dataset.variantImage;
              var el = document.querySelector(
                ".grid-product__color-image--" + id
              );
              el.style.backgroundImage = "url(" + image + ")";
              el.classList.add("is-active");
            });
            swatch.addEventListener("mouseleave", function () {
              var id = swatch.dataset.variantId;
              document
                .querySelector(".grid-product__color-image--" + id)
                .classList.remove("is-active");
            });
          });
      },

      /*====================
        Collection filters
      ====================*/
      initFilters: function () {
        console.log("123")
        var tags = document.querySelectorAll(selectors.tags);

        if (!tags.length) {
          return;
        }

        this.bindBackButton();

        // Set mobile top value for filters if sticky header enabled
        if (theme.config.stickyHeader) {
          this.setFilterStickyPosition();

          window.on(
            "resize",
            theme.utils.debounce(500, this.setFilterStickyPosition)
          );
        }

        
          if($('body').hasClass('convert_filter')){
            document.querySelectorAll(selectors.activeTagsClose).forEach((tag) => {
              tag.addEventListener("click", this.tagFilterClick.bind(this));
            });
            document.querySelectorAll(selectors.applyFilter).forEach((tag) => {
              tag.addEventListener("click", this.applyFilterClick.bind(this));
            });
            document.querySelectorAll(selectors.tagsForm).forEach((form) => {
              form.addEventListener("input", this.onFormSelect.bind(this));
            });
          }
          else{
            document.querySelectorAll(selectors.activeTags).forEach((tag) => {
              tag.addEventListener("click", this.tagClick.bind(this));
            });
            
            document.querySelectorAll(selectors.tagsForm).forEach((form) => {
              form.addEventListener("input", this.onFormSubmit.bind(this));
            });
          }
        
      },

      initPriceRange: function () {
        const priceRangeEls = document.querySelectorAll(selectors.priceRange);
        priceRangeEls.forEach(
          (el) =>
            new theme.PriceRange(el, {
              // onChange passes in formData
              onChange: this.renderFromFormData.bind(this),
            })
        );
      },

      tagFilterClick: function (evt) {
        $('html').addClass('js-drawer-open');
        $('html').addClass('lock-scroll');
        $('#FilterDrawer').addClass('drawer--is-open');
        var el = evt.target;
        evt.preventDefault();
        const parent = el.closest("li");
        parent.remove();
        
        return false;
      },

      onFormSelect: function (evt) {
        var el = evt.target;
        
        const parent = el.closest("li");

        var tagCount = parent.getAttribute('data-count');
        var oldCount = $('.tag-list-tcount').attr('data-fitlerProduct');
        var newCount = 0;
        if (parent.classList.contains(classes.activeTag)) {
          parent.classList.remove(classes.activeTag);
          newCount = eval(oldCount) - eval(tagCount);
        } else {
          parent.classList.add(classes.activeTag);
          newCount = eval(tagCount) + eval(oldCount);
        }

        $('.tag-list-apply').hide();
        $('.tag-list-tcount').hide();
        if(newCount > 0){
          $('.tag-list-apply').show();
          $('.tag-list-tcount').show();
        }
        $('.tag-list-tcount').attr('data-fitlerProduct', newCount);
        $('.tag-list-tcount').html('( '+newCount+' )');

        evt.preventDefault();
      },
      
      applyFilterClick: function (evt) {
        console.log("4")
        var el = evt.target;

        if (theme.FilterDrawer) {
          theme.FilterDrawer.close();
        }

        // Do not ajax-load collection links
        if (el.classList.contains("no-ajax")) {
          return;
        }
        
        evt.preventDefault();
        const parent = el.closest("li");
        const formEl = el.closest("form");
        const formData = new FormData(formEl);
        this.updateScroll(true);
        this.startLoading();
        this.renderFromFormData(formData);
      },

      tagClick: function (evt) {
        console.log("5")
        console.log("niii")
        var el = evt.currentTarget;

        if (theme.FilterDrawer) {
          theme.FilterDrawer.close();
        }

        // Do not ajax-load collection links
        if (el.classList.contains("no-ajax")) {
          return;
        }

        evt.preventDefault();

        if (isAnimating) {
          return;
        }

        isAnimating = true;

        const parent = el.parentNode;
        const newUrl = new URL(el.href);

        this.renderActiveTag(parent, el);
        this.updateScroll(true);
        this.startLoading();
        this.renderCollectionPage(newUrl.searchParams);
      },

      onFormSubmit: function (evt) {
        console.log("6")
        var el = evt.target;

        if (theme.FilterDrawer) {
          theme.FilterDrawer.close();
        }

        // Do not ajax-load collection links
        if (el.classList.contains("no-ajax")) {
          return;
        }

        evt.preventDefault();
        if (isAnimating) {
          return;
        }

        isAnimating = true;

        const parent = el.closest("li");
        const formEl = el.closest("form");
        const formData = new FormData(formEl);

        this.renderActiveTag(parent, el);
        this.updateScroll(true);
        this.startLoading();
        this.renderFromFormData(formData);
      },

      fetchOpenCollasibleFilters: function () {
        return Array.from(
          document.querySelectorAll(
            `${selectors.sidebar} ${selectors.trigger}.${classes.isOpen}`
          )
        ).map((trigger) => trigger.dataset.collapsibleId);
      },

      renderActiveTag: function (parent, el) {
        const textEl = parent.querySelector(".tag__text");

        if (parent.classList.contains(classes.activeTag)) {
          parent.classList.remove(classes.activeTag);
        } else {
          parent.classList.add(classes.activeTag);

          // If adding a tag, show new tag right away.
          // Otherwise, remove it before ajax finishes
          if (el.closest("li").classList.contains(classes.removeTagParent)) {
            parent.remove();
          } else {
            // Append new tag in both drawer and sidebar
            document
              .querySelectorAll(selectors.activeTagList)
              .forEach((list) => {
                const newTag = document.createElement("li");
                const newTagLink = document.createElement("a");
                newTag.classList.add("tag", "tag--remove");
                newTagLink.classList.add("btn", "btn--small");
                newTagLink.innerText = textEl.innerText;
                newTag.appendChild(newTagLink);

                list.appendChild(newTag);
              });
          }
        }
      },

      renderFromFormData: function (formData) {
        const searchParams = new URLSearchParams(formData);
        this.renderCollectionPage(searchParams);
      },

      onReplaceAjaxContent: function (newDom, section) {
        const openCollapsibleIds = this.fetchOpenCollasibleFilters();

        openCollapsibleIds.forEach((selector) => {
          newDom
            .querySelectorAll(`[data-collapsible-id=${selector}]`)
            .forEach(this.openCollapsible);
        });

        var newContentEl = newDom.getElementById(section.nodeId);
        if (!newContentEl) {
          return;
        }

        document.getElementById(section.nodeId).innerHTML =
          newContentEl.innerHTML;
      },

      openCollapsible: function (el) {
        if (el.classList.contains(classes.filterSidebar)) {
          el.style.height = "auto";
        }

        el.classList.add(classes.isOpen);
      },

      renderCollectionPage: function (searchParams, updateURLHash = true) {
        // If on vendor page, make sure to pass the q param
        if (window.location.href.indexOf("collections/vendors") > -1) {
          const queryString = window.location.search;
          const urlParams = new URLSearchParams(queryString);
          const vendor = urlParams.get("q");
          if (vendor) {
            searchParams.append("q", vendor);
          }
        }
        
        var testUrl = window.location.href;

        var tempPart = '';
        if (testUrl.indexOf('?convert_action') !== -1 || testUrl.indexOf('&convert_action') !== -1) {
          var urlParts = testUrl.split('?');
          var queryString = urlParts[1];
          var params = queryString.split('&');

          // Loop through each parameter to check if "convert_action" exists
          var convertActionExists = false;
          $.each(params, function(index, param) {
              var paramParts = param.split('=');
              if (paramParts[0] === 'convert_action') {
                searchParams.append("convert_action", paramParts[1]);
              }
              if (paramParts[0] === 'convert_e') {
                searchParams.append("convert_e", paramParts[1]);
              }
              if (paramParts[0] === 'convert_v') {
                searchParams.append("convert_v", paramParts[1]);
                if(paramParts[1] == '1004235035'){
                  $('.collaction-filter-styles').addClass('collaction-filter-v6');
                }
              }
          });
        }

          
        this.ajaxRenderer
          .renderPage(window.location.pathname, searchParams, updateURLHash, tempPart)
          .then(() => {
            theme.sections.reinit("collection-grid");
            this.updateScroll(false);
            this.initPriceRange();
            theme.reinitProductGridItem();

            isAnimating = false;
          });
      },

      bindBackButton: function () {
        // Ajax page on back button
        window.off("popstate" + this.namespace);
        window.on(
          "popstate" + this.namespace,
          function (state) {
            if (state) {
              const newUrl = new URL(window.location.href);
              this.renderCollectionPage(newUrl.searchParams, false);
            }
          }.bind(this)
        );
      },

      updateScroll: function (animate) {
        var scrollToElement = document.querySelector("[data-scroll-to]");
        var scrollTo = scrollToElement && scrollToElement.offsetTop;

        if (theme.config.bpSmall) {
          // 60 is ~ height of sticky filters on desktop
          scrollTo -= 60;
        } else {
          scrollTo += 1;
        }

        if (theme.config.stickyHeader) {
          var headerHeight =
            document.querySelector(".site-header").offsetHeight;
          scrollTo = scrollTo - headerHeight;
        }

        if (animate) {
          window.scrollTo({ top: scrollTo, behavior: "smooth" });
        } else {
          window.scrollTo({ top: scrollTo });
        }
      },

      setFilterStickyPosition: function () {
        var headerHeight = document.querySelector(".site-header").offsetHeight;
        document.querySelector(selectors.filters).style.top =
          headerHeight + 10 + "px";

        // Also update top position of sticky sidebar
        var stickySidebar = document.querySelector(".grid__item--sidebar");
        if (stickySidebar) {
          stickySidebar.style.top = headerHeight + 10 + "px";
        }
      },

      forceReload: function () {
        this.init();
      },

      startLoading: function () {
        document
          .querySelector(selectors.collectionGrid)
          .classList.add("unload");
      },
    });

    return Collection;
  })();

  theme.FooterSection = (function () {
    var selectors = {
      locale: "[data-disclosure-locale]",
      currency: "[data-disclosure-currency]",
    };

    function FooterSection(container) {
      this.container = container;
      this.localeDisclosure = null;
      this.currencyDisclosure = null;

      this.init();
    }

    FooterSection.prototype = Object.assign({}, FooterSection.prototype, {
      init: function () {
        var localeEl = this.container.querySelector(selectors.locale);
        var currencyEl = this.container.querySelector(selectors.currency);

        if (localeEl) {
          this.localeDisclosure = new theme.Disclosure(localeEl);
        }

        if (currencyEl) {
          this.currencyDisclosure = new theme.Disclosure(currencyEl);
        }

        // Change email icon to submit text
        var newsletterInput = document.querySelector(
          ".footer__newsletter-input"
        );
        if (newsletterInput) {
          newsletterInput.addEventListener("keyup", function () {
            newsletterInput.classList.add("footer__newsletter-input--active");
          });
        }

        // Re-hook up collapsible box triggers
        theme.collapsibles.init(this.container);
      },

      onUnload: function () {
        if (this.localeDisclosure) {
          this.localeDisclosure.destroy();
        }

        if (this.currencyDisclosure) {
          this.currencyDisclosure.destroy();
        }
      },
    });

    return FooterSection;
  })();

  theme.HeaderSection = (function () {
    var selectors = {
      locale: "[data-disclosure-locale]",
      currency: "[data-disclosure-currency]",
    };

    function HeaderSection(container) {
      this.container = container;
      this.sectionId = this.container.getAttribute("data-section-id");

      this.init();
    }

    HeaderSection.prototype = Object.assign({}, HeaderSection.prototype, {
      init: function () {
        // Reload any slideshow if header is reloaded to make sure
        // sticky header works as expected
        // (can be anywhere in sections.instance array)
        if (Shopify && Shopify.designMode) {
          theme.sections.reinit("slideshow-section");

          // Set a timer to resize the header in case the logo changes size
          setTimeout(function () {
            window.dispatchEvent(new Event("resize"));
          }, 500);
        }

        this.initDrawers();
        this.initDisclosures();
        theme.headerNav.init();
        theme.announcementBar.init();
      },

      initDisclosures: function () {
        var localeEl = this.container.querySelector(selectors.locale);
        var currencyEl = this.container.querySelector(selectors.currency);

        if (localeEl) {
          this.localeDisclosure = new theme.Disclosure(localeEl);
        }

        if (currencyEl) {
          this.currencyDisclosure = new theme.Disclosure(currencyEl);
        }
      },

      initDrawers: function () {
        theme.NavDrawer = new theme.Drawers("NavDrawer", "nav");
        if (theme.settings.cartType === "drawer") {
          if (!document.body.classList.contains("template-cart")) {
            new theme.CartDrawer();
          }
        }

        theme.collapsibles.init(document.getElementById("NavDrawer"));
      },

      onBlockSelect: function (evt) {
        theme.announcementBar.onBlockSelect(evt.detail.blockId);
      },

      onBlockDeselect: function () {
        theme.announcementBar.onBlockDeselect();
      },

      onUnload: function () {
        theme.NavDrawer.close();
        theme.announcementBar.unload();

        if (this.localeDisclosure) {
          this.localeDisclosure.destroy();
        }

        if (this.currencyDisclosure) {
          this.currencyDisclosure.destroy();
        }
      },
    });

    return HeaderSection;
  })();

  theme.Product = (function () {
    var videoObjects = {};

    var classes = {
      onSale: "on-sale",
      disabled: "disabled",
      isModal: "is-modal",
      loading: "loading",
      loaded: "loaded",
      hidden: "hide",
      interactable: "video-interactable",
      visuallyHide: "visually-invisible",
    };

    var selectors = {
      productVideo: ".product__video",
      videoParent: ".product__video-wrapper",
      slide: ".product-main-slide",
      currentSlide: ".is-selected",
      startingSlide: ".starting-slide",
      variantType: ".variant-wrapper",
      blocks: "[data-product-blocks]",
      blocksHolder: "[data-blocks-holder]",
    };

    function Product(container) {
      this.container = container;
      var sectionId = (this.sectionId =
        container.getAttribute("data-section-id"));
      var productId = (this.productId =
        container.getAttribute("data-product-id"));

      this.inModal = container.dataset.modal === "true";
      this.modal;

      this.settings = {
        enableHistoryState: container.dataset.history || false,
        namespace: ".product-" + sectionId,
        inventory: false,
        inventoryThreshold: 10,
        modalInit: false,
        hasImages: true,
        imageSetName: null,
        imageSetIndex: null,
        currentImageSet: null,
        imageSize: "620x",
        currentSlideIndex: 0,
        videoLooping: container.dataset.videoLooping,
      };

      // Overwrite some settings when loaded in modal
      if (this.inModal) {
        this.settings.enableHistoryState = false;
        this.settings.namespace = ".product-" + sectionId + "-modal";
        this.modal = document.getElementById("QuickShopModal-" + productId);
      }

      this.selectors = {
        variantsJson: "[data-variant-json]",
        currentVariantJson: "[data-current-variant-json]",
        form: ".product-single__form",

        media: "[data-product-media-type-model]",
        closeMedia: ".product-single__close-media",
        photoThumbs: "[data-product-thumb]",
        thumbSlider: "[data-product-thumbs]",
        thumbSlider1: ".product__thumbs-video",
        thumbSlider2: ".product__limited_thumbs",
        thumbSliderColor: ".product__color_thumbs",
        thumbScroller: ".product__thumbs--scroller",
        thumbScroller1: ".product__thumbs--scroller-video",
        thumbScroller2: ".product__thumbs-limited--scroller",
        thumbScrollerColor: ".product__thumbs-color--scroller",
        mainSlider: "[data-product-photos]",
        mainSlider1: ".product-slideshow-video",
        mainSlider2: ".limited-edition-gallery",
        mainSliderColor: ".color-gallery",
        imageContainer: "[data-product-images]",
        productImageMain: "[data-product-image-main]",

        priceWrapper: "[data-product-price-wrap]",
        price: "[data-product-price]",
        comparePrice: "[data-compare-price]",
        mprice: "[data-product-m-price]",
        mcomparePrice: "[data-compare-m-price]",
        savePrice: "[data-save-price]",
        priceA11y: "[data-a11y-price]",
        comparePriceA11y: "[data-compare-price-a11y]",
        unitWrapper: "[data-unit-price-wrapper]",
        unitPrice: "[data-unit-price]",
        unitPriceBaseUnit: "[data-unit-base]",
        sku: "[data-sku]",
        inventory: "[data-product-inventory]",
        incomingInventory: "[data-incoming-inventory]",
        colorLabel: "[data-variant-color-label]",

        addToCart: "[data-add-to-cart]",
        addToCartText: "[data-add-to-cart-text]",

        originalSelectorId: "[data-product-select]",
        singleOptionSelector: "[data-variant-input]",
        variantColorSwatch: ".variant__input--color-swatch",

        availabilityContainer: "[data-store-availability-holder]",
      };

      this.cacheElements();

      if(this.cache.mainSlider!=null){
        this.firstProductImage = this.cache.mainSlider.querySelector("img");

        if (!this.firstProductImage) {
          this.settings.hasImages = false;
        }

        this.firstProductImage = this.cache.mainSlider1.querySelector("img");

        if (!this.firstProductImage) {
          this.settings.hasImages = false;
        }
        
        var dataSetEl = this.cache.mainSlider.querySelector("[data-set-name]");
        if (dataSetEl) {
          this.settings.imageSetName = dataSetEl.dataset.setName;
        }
      }

      if(this.cache.mainSlider1!=null){
        var dataSetEl = this.cache.mainSlider1.querySelector("[data-set-name]");
        if (dataSetEl) {
          this.settings.imageSetName = dataSetEl.dataset.setName;
        }
      }
      
      this.init();
    }

    Product.prototype = Object.assign({}, Product.prototype, {
      init: function () {
        if (this.inModal) {
          this.container.classList.add(classes.isModal);
          document.addEventListener(
            "modalOpen.QuickShopModal-" + this.productId,
            this.openModalProduct.bind(this)
          );
          document.addEventListener(
            "modalClose.QuickShopModal-" + this.productId,
            this.closeModalProduct.bind(this)
          );
        }

        if (!this.inModal) {
          this.formSetup();
          this.productSetup();
          this.videoSetup();
          this.initProductSlider();
          this.customMediaListners();
          this.addIdToRecentlyViewed();
        }
      },

      cacheElements: function () {
        this.cache = {
          form: this.container.querySelector(this.selectors.form),
          mainSlider: this.container.querySelector(this.selectors.mainSlider),
          mainSlider1: this.container.querySelector(this.selectors.mainSlider1),
          mainSlider2: this.container.querySelector(this.selectors.mainSlider2),
          mainSliderColor: this.container.querySelector(this.selectors.mainSliderColor),
          thumbSlider: this.container.querySelector(this.selectors.thumbSlider),
          thumbSlider1: this.container.querySelector(this.selectors.thumbSlider1),
          thumbSlider2: this.container.querySelector(this.selectors.thumbSlider2),
          thumbSliderColor: this.container.querySelector(this.selectors.thumbSliderColor),
          thumbScroller: this.container.querySelector(
            this.selectors.thumbScroller
          ),
          thumbScroller1: this.container.querySelector(
            this.selectors.thumbScroller1
          ),
          thumbScroller2: this.container.querySelector(
            this.selectors.thumbScroller2
          ),
          thumbScrollerColor: this.container.querySelector(
            this.selectors.thumbScrollerColor
          ),
          productImageMain: this.container.querySelector(
            this.selectors.productImageMain
          ),

          // Price-related
          priceWrapper: this.container.querySelector(
            this.selectors.priceWrapper
          ),
          comparePriceA11y: this.container.querySelector(
            this.selectors.comparePriceA11y
          ),
          comparePrice: this.container.querySelector(
            this.selectors.comparePrice
          ),
          mcomparePrice: this.container.querySelector(
            this.selectors.mcomparePrice
          ),
          price: this.container.querySelector(this.selectors.price),
          mprice: this.container.querySelector(this.selectors.mprice),
          savePrice: this.container.querySelector(this.selectors.savePrice),
          priceA11y: this.container.querySelector(this.selectors.priceA11y),
        };
      },

      formSetup: function () {
        this.initQtySelector();
        this.initAjaxProductForm();
        this.availabilitySetup();
        this.initVariants();

        // We know the current variant now so setup image sets
        if (this.settings.imageSetName) {
          this.updateImageSet();
        }
      },

      availabilitySetup: function () {
        var container = this.container.querySelector(
          this.selectors.availabilityContainer
        );
        if (container) {
          this.storeAvailability = new theme.StoreAvailability(container);
        }
      },

      productSetup: function () {
        this.setImageSizes();
        this.initImageZoom();
        this.initModelViewerLibraries();
        this.initShopifyXrLaunch();

        if (window.SPR) {
          SPR.initDomEls();
          SPR.loadBadges();
        }
      },

      setImageSizes: function () {
        if (!this.settings.hasImages) {
          return;
        }

        // Get srcset image src, works on most modern browsers
        // otherwise defaults to settings.imageSize
        if(this.firstProductImage!=null){
          var currentImage = this.firstProductImage.currentSrc;

          if (currentImage) {
            this.settings.imageSize = theme.Images.imageSize(currentImage);
          }
        }
      },

      addIdToRecentlyViewed: function () {
        var handle = this.container.getAttribute("data-product-handle");
        var url = this.container.getAttribute("data-product-url");
        var aspectRatio = this.container.getAttribute("data-aspect-ratio");
        var featuredImage = this.container.getAttribute("data-img-url");

        // Remove current product if already in set of recent
        if (theme.recentlyViewed.recent.hasOwnProperty(handle)) {
          delete theme.recentlyViewed.recent[handle];
        }

        // Add it back to the end
        theme.recentlyViewed.recent[handle] = {
          url: url,
          aspectRatio: aspectRatio,
          featuredImage: featuredImage,
        };

        if (theme.config.hasLocalStorage) {
          window.localStorage.setItem(
            "theme-recent",
            JSON.stringify(theme.recentlyViewed.recent)
          );
        }
      },

      initVariants: function () {
        var variantJson = this.container.querySelector(
          this.selectors.variantsJson
        );

        if (!variantJson) {
          return;
        }

        this.variantsObject = JSON.parse(variantJson.innerHTML);

        var options = {
          container: this.container,
          enableHistoryState: this.settings.enableHistoryState,
          singleOptionSelector: this.selectors.singleOptionSelector,
          originalSelectorId: this.selectors.originalSelectorId,
          variants: this.variantsObject,
        };

        var swatches = this.container.querySelectorAll(
          this.selectors.variantColorSwatch
        );
        if (swatches.length) {
          swatches.forEach((swatch) => {
            swatch.addEventListener(
              "change",
              function (evt) {
                var color = swatch.dataset.colorName;
                var index = swatch.dataset.colorIndex;
                this.updateColorName(color, index);
              }.bind(this)
            );
          });
        }

        this.variants = new theme.Variants(options);

        // Product availability on page load
        if (this.storeAvailability) {
          var variant_id = this.variants.currentVariant
            ? this.variants.currentVariant.id
            : this.variants.variants[0].id;

          this.storeAvailability.updateContent(variant_id);
          this.container.on(
            "variantChange" + this.settings.namespace,
            this.updateAvailability.bind(this)
          );
        }

        this.container.on(
          "variantChange" + this.settings.namespace,
          this.updateCartButton.bind(this)
        );
        this.container.on(
          "variantImageChange" + this.settings.namespace,
          this.updateVariantImage.bind(this)
        );
        this.container.on(
          "variantPriceChange" + this.settings.namespace,
          this.updatePrice.bind(this)
        );
        this.container.on(
          "variantUnitPriceChange" + this.settings.namespace,
          this.updateUnitPrice.bind(this)
        );

        if (this.container.querySelector(this.selectors.sku)) {
          this.container.on(
            "variantSKUChange" + this.settings.namespace,
            this.updateSku.bind(this)
          );
        }

        var inventoryEl = this.container.querySelector(
          this.selectors.inventory
        );
        if (inventoryEl) {
          this.settings.inventory = true;
          this.settings.inventoryThreshold = inventoryEl.dataset.threshold;
          this.container.on(
            "variantChange" + this.settings.namespace,
            this.updateInventory.bind(this)
          );
        }

        // Update individual variant availability on each selection
        if (theme.settings.dynamicVariantsEnable) {
          var currentVariantJson = this.container.querySelector(
            this.selectors.currentVariantJson
          );

          if (currentVariantJson) {
            var variantType = this.container.querySelector(
              selectors.variantType
            );

            if (variantType) {
              new theme.VariantAvailability({
                container: this.container,
                namespace: this.settings.namespace,
                type: variantType.dataset.type,
                variantsObject: this.variantsObject,
                currentVariantObject: JSON.parse(currentVariantJson.innerHTML),
              });
            }
          }
        }

        // image set names variant change listeners
        if (this.settings.imageSetName) {
          var variantWrapper = this.container.querySelector(
            '.variant-input-wrap[data-handle="' +
              this.settings.imageSetName +
              '"]'
          );
          if (variantWrapper) {
            this.settings.imageSetIndex = variantWrapper.dataset.index;
            this.container.on(
              "variantChange" + this.settings.namespace,
              this.updateImageSet.bind(this)
            );
          } else {
            this.settings.imageSetName = null;
          }
        }
      },

      initQtySelector: function () {
        this.container.querySelectorAll(".js-qty__wrapper").forEach((el) => {
          new theme.QtySelector(el, {
            namespace: ".product",
          });
        });
      },

      initAjaxProductForm: function () {
        if (theme.settings.cartType === "drawer") {
          new theme.AjaxProduct(this.cache.form);
        }
      },

      /*============================================================================
        Variant change methods
      ==============================================================================*/
      updateColorName: function (color, index) {
        // Updates on radio button change, not variant.js
        this.container.querySelector(
          this.selectors.colorLabel + `[data-index="${index}"`
        ).textContent = color;
      },

      updateCartButton: function (evt) {
        var variant = evt.detail.variant;
        var cartBtn = this.container.querySelector(this.selectors.addToCart);
        var cartBtnText = this.container.querySelector(
          this.selectors.addToCartText
        );

        if (variant) {
          if (variant.available) {
            // Available, enable the submit button and change text
            cartBtn.classList.remove(classes.disabled);
            cartBtn.disabled = false;
            var defaultText = cartBtnText.dataset.defaultText;
            cartBtnText.textContent = defaultText;
          } else {
            // Sold out, disable the submit button and change text
            cartBtn.classList.add(classes.disabled);
            cartBtn.disabled = true;
            cartBtnText.textContent = theme.strings.soldOut;
          }
        } else {
          // The variant doesn't exist, disable submit button
          cartBtn.classList.add(classes.disabled);
          cartBtn.disabled = true;
          cartBtnText.textContent = theme.strings.unavailable;
        }
      },

      updatePrice: function (evt) {
        var variant = evt.detail.variant;
        //console.log("datatt",this.cache);
        if (variant) {
          // Regular price
          if(this.cache.price!=null){
            this.cache.price.innerHTML = theme.Currency.formatMoney(
              variant.price,
              theme.settings.moneyFormat
            );
          }
          if(this.cache.mprice!=null){
            this.cache.mprice.innerHTML = theme.Currency.formatMoney(
              variant.price,
              theme.settings.moneyFormat
            );
          }

          // Sale price, if necessary
          if (variant.compare_at_price > variant.price) {
            if(this.cache.comparePrice!=null){
              this.cache.comparePrice.innerHTML = theme.Currency.formatMoney(
                variant.compare_at_price,
                theme.settings.moneyFormat
              );
              this.cache.mcomparePrice.innerHTML = theme.Currency.formatMoney(
                variant.compare_at_price,
                theme.settings.moneyFormat
              );
            }
            if(this.cache.priceWrapper!=null){
              this.cache.priceWrapper.classList.remove(classes.hidden);
            }
            if(this.cache.price!=null){
              this.cache.price.classList.add(classes.onSale);
            }
            if(this.cache.comparePriceA11y!=null){
              this.cache.comparePriceA11y.setAttribute("aria-hidden", "false");
            }
            if(this.cache.priceA11y!=null){
              this.cache.priceA11y.setAttribute("aria-hidden", "false");
            }
            var savings = variant.compare_at_price - variant.price;

            if (theme.settings.saveType == "percent") {
              savings =
                Math.round((savings * 100) / variant.compare_at_price) + "%";
            } else {
              savings = theme.Currency.formatMoney(
                savings,
                theme.settings.moneyFormat
              );
            }
            if(this.cache.savePrice!=null){
              this.cache.savePrice.classList.remove(classes.hidden);
              this.cache.savePrice.innerHTML = theme.strings.savePrice.replace(
                "[saved_amount]",
                savings
              );
            }
          } else {
            if (this.cache.priceWrapper) {
              this.cache.priceWrapper.classList.add(classes.hidden);
            }
            if(this.cache.savePrice!=null){
              this.cache.savePrice.classList.add(classes.hidden);
            }
            if(this.cache.price!=null){
              this.cache.price.classList.remove(classes.onSale);
            }
            if(this.cache.mprice!=null){
              this.cache.mprice.classList.remove(classes.onSale);
            }
            if (this.cache.comparePriceA11y) {
              this.cache.comparePriceA11y.setAttribute("aria-hidden", "true");
            }
            if(this.cache.priceA11y){
              this.cache.priceA11y.setAttribute("aria-hidden", "true");
            }
          }
        }
      },

      updateUnitPrice: function (evt) {
        var variant = evt.detail.variant;

        if (variant && variant.unit_price) {
          this.container.querySelector(this.selectors.unitPrice).innerHTML =
            theme.Currency.formatMoney(
              variant.unit_price,
              theme.settings.moneyFormat
            );
          this.container.querySelector(
            this.selectors.unitPriceBaseUnit
          ).innerHTML = theme.Currency.getBaseUnit(variant);
          this.container
            .querySelector(this.selectors.unitWrapper)
            .classList.remove(classes.hidden);
        } else {
          this.container
            .querySelector(this.selectors.unitWrapper)
            .classList.add(classes.hidden);
        }
      },

      imageSetArguments: function (variant) {
        var variant = variant
          ? variant
          : this.variants
          ? this.variants.currentVariant
          : null;
        if (!variant) return;

        var setValue = (this.settings.currentImageSet = this.getImageSetName(
          variant[this.settings.imageSetIndex]
        ));
        var set = this.settings.imageSetName + "_" + setValue;

        // Always start on index 0
        this.settings.currentSlideIndex = 0;

        // Return object that adds cellSelector to mainSliderArgs
        return {
          cellSelector: '[data-group="' + set + '"]',
          imageSet: set,
          initialIndex: this.settings.currentSlideIndex,
        };
      },

      updateImageSet: function (evt) {
        // If called directly, use current variant
        var variant = evt
          ? evt.detail.variant
          : this.variants
          ? this.variants.currentVariant
          : null;
        if (!variant) {
          return;
        }

        var setValue = this.getImageSetName(
          variant[this.settings.imageSetIndex]
        );

        // Already on the current image group
        if (this.settings.currentImageSet === setValue) {
          return;
        }

        this.initProductSlider(variant);
      },

      // Show/hide thumbnails based on current image set
      updateImageSetThumbs: function (set) {
        this.cache.thumbSlider
          .querySelectorAll(".product__thumb-item")
          .forEach((thumb) => {
            thumb.classList.toggle(classes.hidden, thumb.dataset.group !== set);
          });
      },

      getImageSetName: function (string) {
        return string
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, "-")
          .replace(/-$/, "")
          .replace(/^-/, "");
      },

      updateSku: function (evt) {
        var variant = evt.detail.variant;
        var newSku = "";

        if (variant) {
          if (variant.sku) {
            newSku = variant.sku;
          }

          this.container.querySelector(this.selectors.sku).textContent = newSku;
        }
      },

      updateInventory: function (evt) {
        var variant = evt.detail.variant;

        // Hide stock if no inventory management or policy is continue
        if (
          !variant ||
          !variant.inventory_management ||
          variant.inventory_policy === "continue"
        ) {
          this.toggleInventoryQuantity(variant, false);
          this.toggleIncomingInventory(false);
          return;
        }

        if (
          variant.inventory_management === "shopify" &&
          window.inventories &&
          window.inventories[this.productId]
        ) {
          var variantInventoryObject =
            window.inventories[this.productId][variant.id];

          // Hide stock if policy is continue
          if (variantInventoryObject.policy === "continue") {
            this.toggleInventoryQuantity(variant, false);
            this.toggleIncomingInventory(false);
            return;
          }

          var quantity = variantInventoryObject.quantity;
          var showInventory = true;
          var showIncomingInventory = false;

          if (quantity <= 0 || quantity > this.settings.inventoryThreshold) {
            showInventory = false;
          }

          this.toggleInventoryQuantity(variant, showInventory, quantity);

          // Only show incoming inventory when:
          // - inventory notice itself is hidden
          // - have incoming inventory
          // - current quantity is below theme setting threshold
          if (
            !showInventory &&
            variantInventoryObject.incoming === "true" &&
            quantity <= this.settings.inventoryThreshold
          ) {
            showIncomingInventory = true;
          }

          this.toggleIncomingInventory(
            showIncomingInventory,
            variant.available,
            variantInventoryObject.next_incoming_date
          );
        }
      },

      updateAvailability: function (evt) {
        var variant = evt.detail.variant;
        if (!variant) {
          return;
        }

        this.storeAvailability.updateContent(variant.id);
      },

      toggleInventoryQuantity: function (variant, show, qty) {
        if (!this.settings.inventory) {
          show = false;
        }

        var el = this.container.querySelector(this.selectors.inventory);
        var salesPoint = el.closest(".product-block");

        if (parseInt(qty) <= parseInt(this.settings.inventoryThreshold)) {
          el.parentNode.classList.add("inventory--low");
          el.textContent = theme.strings.stockLabel.replace("[count]", qty);
        } else {
          el.parentNode.classList.remove("inventory--low");
          el.textContent = theme.strings.inStockLabel;
        }

        if (variant && variant.available) {
          el.parentNode.classList.remove(classes.hidden);
          if (salesPoint) {
            salesPoint.classList.remove(classes.hidden);
          }
        } else {
          el.parentNode.classList.add(classes.hidden);
          if (salesPoint) {
            salesPoint.classList.add(classes.hidden);
          }
        }
      },

      toggleIncomingInventory: function (show, available, date) {
        var el = this.container.querySelector(this.selectors.incomingInventory);
        var salesPoint = el.closest(".product-block");

        if (!el) {
          return;
        }

        var textEl = el.querySelector(".js-incoming-text");

        if (show) {
          var string = available
            ? theme.strings.willNotShipUntil.replace("[date]", date)
            : theme.strings.willBeInStockAfter.replace("[date]", date);

          if (!date) {
            string = theme.strings.waitingForStock;
          }

          el.classList.remove(classes.hidden);
          if (salesPoint) {
            salesPoint.classList.remove(classes.hidden);
          }
          textEl.textContent = string;
        } else {
          el.classList.add(classes.hidden);
        }
      },

      /*============================================================================
        Product videos
      ==============================================================================*/
      videoSetup: function () {
        if(this.cache.mainSlider!=null){
          var productVideos = this.cache.mainSlider.querySelectorAll(
            selectors.productVideo
          );

          if (!productVideos.length) {
            return false;
          }

          productVideos.forEach((vid) => {
            var type = vid.dataset.videoType;
            if (type === "youtube") {
              this.initYoutubeVideo(vid);
            } else if (type === "mp4") {
              this.initMp4Video(vid);
            }
          });
        }

        if(this.cache.mainSlider1!=null){
          var productVideos1 = this.cache.mainSlider1.querySelectorAll(
            selectors.productVideo
          );

          if (!productVideos1.length) {
            return false;
          }

          productVideos1.forEach((vid) => {
            var type = vid.dataset.videoType;
            if (type === "youtube") {
              this.initYoutubeVideo(vid);
            } else if (type === "mp4") {
              this.initMp4Video(vid);
            }
          });
        }

        // Limited edition gallery start
        if(this.cache.mainSlider2!=null){
          var productVideos2 = this.cache.mainSlider2.querySelectorAll(
            selectors.productVideo
          );

          if (!productVideos2.length) {
            return false;
          }

          productVideos2.forEach((vid) => {
            var type = vid.dataset.videoType;
            if (type === "youtube") {
              this.initYoutubeVideo(vid);
            } else if (type === "mp4") {
              this.initMp4Video(vid);
            }
          }); 
        }
        // Limited edition gallery end

        // Color Variant Wise gallery start
        if(jQuery('body').hasClass('color-variant-wise-gallery')){
          if(this.cache.mainSliderColor!=null){
            var productVideosColor = this.cache.mainSliderColor.querySelectorAll(
              selectors.productVideo
            );

            if (!productVideosColor.length) {
              return false;
            }

            productVideosColor.forEach((vid) => {
              var type = vid.dataset.videoType;
              if (type === "youtube") {
                this.initYoutubeVideo(vid);
              } else if (type === "mp4") {
                this.initMp4Video(vid);
              }
            }); 
          }
        }
        // Color Variant Wise gallery end
      },

      initYoutubeVideo: function (div) {
        videoObjects[div.id] = new theme.YouTube(div.id, {
          videoId: div.dataset.youtubeId,
          videoParent: selectors.videoParent,
          autoplay: false, // will handle this in callback
          style: div.dataset.videoStyle,
          loop: div.dataset.videoLoop,
          events: {
            onReady: this.youtubePlayerReady.bind(this),
            onStateChange: this.youtubePlayerStateChange.bind(this),
          },
        });
      },

      // Comes from YouTube SDK
      // Get iframe ID with evt.target.getIframe().id
      // Then access product video players with videoObjects[id]
      youtubePlayerReady: function (evt) {
        var iframeId = evt.target.getIframe().id;

        if (!videoObjects[iframeId]) {
          // No youtube player data
          return;
        }

        var obj = videoObjects[iframeId];
        var player = obj.videoPlayer;

        if (obj.options.style !== "sound") {
          player.mute();
        }

        obj.parent.classList.remove("loading");
        obj.parent.classList.add("loaded");

        // If we have an element, it is in the visible/first slide,
        // and is muted, play it
        if (this._isFirstSlide(iframeId) && obj.options.style !== "sound") {
          player.playVideo();
        }
      },

      _isFirstSlide: function (id) {
        return this.cache.mainSlider.querySelector(
          selectors.startingSlide + " " + "#" + id
        );
      },

      _isFirstSlide1: function (id) {
        return this.cache.mainSlider1.querySelector(
          selectors.startingSlide + " " + "#" + id
        );
      },
      
      youtubePlayerStateChange: function (evt) {
        var iframeId = evt.target.getIframe().id;
        var obj = videoObjects[iframeId];

        switch (evt.data) {
          case -1: // unstarted
            // Handle low power state on iOS by checking if
            // video is reset to unplayed after attempting to buffer
            if (obj.attemptedToPlay) {
              obj.parent.classList.add("video-interactable");
            }
            break;
          case 0: // ended
            if (obj && obj.options.loop === "true") {
              obj.videoPlayer.playVideo();
            }
            break;
          case 3: // buffering
            obj.attemptedToPlay = true;
            break;
        }
      },

      initMp4Video: function (div) {
        videoObjects[div.id] = {
          id: div.id,
          type: "mp4",
        };

        if (this._isFirstSlide(div.id)) {
          this.playMp4Video(div.id);
        }
      },

      stopVideos: function () {
        for (var [id, vid] of Object.entries(videoObjects)) {
          if (vid.videoPlayer) {
            if (typeof vid.videoPlayer.stopVideo === "function") {
              vid.videoPlayer.stopVideo(); // YouTube player
            }
          } else if (vid.type === "mp4") {
            this.stopMp4Video(vid.id); // MP4 player
          }
        }
      },

      _getVideoType: function (video) {
        return video.getAttribute("data-video-type");
      },

      _getVideoDivId: function (video) {
        return video.id;
      },

      playMp4Video: function (id) {
        var player = this.container.querySelector("#" + id);
        var playPromise = player.play();

        if (playPromise !== undefined) {
          playPromise
            .then(function () {
              // Playing as expected
            })
            .catch(function (error) {
              // Likely low power mode on iOS, show controls
              player.setAttribute("controls", "");
              player
                .closest(selectors.videoParent)
                .setAttribute("data-video-style", "unmuted");
            });
        }
      },

      stopMp4Video: function (id) {
        var player = this.container.querySelector("#" + id);
        if (player && typeof player.pause === "function") {
          player.pause();
        }
      },

      /*============================================================================
        Product images
      ==============================================================================*/
      initImageZoom: function () {
        var container = this.container.querySelector(
          this.selectors.imageContainer
        );
        if (!container) {
          return;
        }
        var imageZoom = new theme.Photoswipe(container, this.sectionId);
        container.addEventListener(
          "photoswipe:afterChange",
          function (evt) {
            if (this.flickity) {
              this.flickity.goToSlide(evt.detail.index);
            }
          }.bind(this)
        );

        var imageZoom1 = new theme.Photoswipe(container, this.sectionId);
        container.addEventListener(
          "photoswipe:afterChange",
          function (evt) {
            if (this.flickityvideo) {
              this.flickityvideo.goToSlide(evt.detail.index);
            }
          }.bind(this)
        );
      },

      getThumbIndex: function (target) {
        if(target!=null){
          return target.dataset.index;
        }
      },

      updateVariantImage: function (evt) {
        var getVersion = jQuery('.page-content--product').find('[name="Version"]:checked').val();
        //console.log("getVersion",getVersion);
        if(jQuery('.page-content--product').find('.version-variant').find('.variant__label-info span').length){
          jQuery('.page-content--product').find('.version-variant').find('.variant__label-info span').text(getVersion);
        }
        if(getVersion!="Limited Edition"){
          var variant = evt.detail.variant;
          var sizedImgUrl = theme.Images.getSizedImageUrl(
            variant.featured_media.preview_image.src,
            this.settings.imageSize
          );

          /*var newImage = this.container.querySelector(
            '[data-product-thumbs] .product__thumb[data-id="' + variant.featured_media.id + '"]'
          );*/
          //var imageIndex = this.getThumbIndex(newImage);
          //console.log("imageIndex",imageIndex,variant.featured_media.id);
          var imageIndex = jQuery('[data-product-photos]').find('.product-main-slide.media_'+variant.featured_media.id).attr('data-index');
          //console.log("mmm imageIndex",imageIndex);
          if(typeof imageIndex === "undefined") {
            var newImage = this.container.querySelector(
              '.product__thumb[data-id="' + variant.featured_media.id + '"]'
            );
            var imageIndex = this.getThumbIndex(newImage);
          }
          console.log("imageIndex",imageIndex);
          // If there is no index, slider is not initalized
          if (typeof imageIndex === "undefined") {
            return;
          }

          // Go to that variant image's slide
          if (this.flickity) {
            //this.flickity.resize();
            this.flickity.goToSlide(imageIndex);
          }

          if (this.flickityvideo) {
            this.flickityvideo.goToSlide(imageIndex);
          }
        }
      },

      initProductSlider: function (variant) {
        // Stop if only a single image, but add active class to first slide
        if(this.cache.mainSlider!=null){
          if (
            this.cache.mainSlider.querySelectorAll(selectors.slide).length <= 1
          ) {
            var slide = this.cache.mainSlider.querySelector(selectors.slide);
            if (slide) {
              slide.classList.add("is-selected");
            }
            return;
          }
        }

        if(this.cache.mainSlider1!=null){
          if (
            this.cache.mainSlider1.querySelectorAll(selectors.slide).length <= 1
          ) {
            var slide = this.cache.mainSlider1.querySelector(selectors.slide);
            if (slide) {
              slide.classList.add("is-selected");
            }
            return;
          }
        }
        
        // Destroy slider in preparation of new initialization
        if (this.flickity && typeof this.flickity.destroy === "function") {
          this.flickity.destroy();
        }

        // If variant argument exists, slideshow is reinitializing because of the
        // image set feature enabled and switching to a new group.
        // currentSlideIndex
        if(this.cache.mainSlider!=null){
          if (!variant) {
            var activeSlide = this.cache.mainSlider.querySelector(
              selectors.startingSlide
            );
            this.settings.currentSlideIndex = this._slideIndex(activeSlide);
          }
        }

        var getVersion = jQuery('.page-content--product').find('[name="Version"]:checked').val();
        var cellSelector = '.product-main-slide'; // default
        var cellColorSelector = '.product-main-slide:not(.ignore-slide)'; // default

        /*if(getVersion != "" && getVersion != undefined){
          getVersion = getVersion.toLowerCase();
          
          if(getVersion == 'limited edition'){
            cellSelector = '.product-main-slide.limited_edition';
          } else {
            cellSelector = '.product-main-slide:not(.limited_edition)';
          }
        }*/

        mainSliderArgs = {
          adaptiveHeight: true,
          avoidReflow: true,
          initialIndex: this.settings.currentSlideIndex,
          childNav: this.cache.thumbSlider,
          childNavScroller: this.cache.thumbScroller,
          //childVertical: this.cache.thumbSlider.dataset.position === 'beside',
          pageDots: true, // mobile only with CSS
          wrapAround: true,
          cellSelector:cellSelector,
          cellAlign: 'left',
          contain: true,
          callbacks: {
            onInit: this.onSliderInit.bind(this),
            onChange: this.onSlideChange.bind(this),
          },
        };

        var mainSliderArgs1 = {
          adaptiveHeight: true,
          avoidReflow: true,
          initialIndex: this.settings.currentSlideIndex,
          childNav: this.cache.thumbSlider1,
          childNavScroller: this.cache.thumbScroller1,
          //childVertical: this.cache.thumbSlider.dataset.position === 'beside',
          pageDots: true, // mobile only with CSS
          wrapAround: true,
          callbacks: {
            onInit: this.onSliderInit.bind(this),
            onChange: this.onSlideChange.bind(this),
          },
        };

        mainSliderArgs2 = {
          adaptiveHeight: true,
          avoidReflow: true,
          initialIndex: this.settings.currentSlideIndex,
          childNav: this.cache.thumbSlider2,
          childNavScroller: this.cache.thumbScroller2,
          //childVertical: this.cache.thumbSlider.dataset.position === 'beside',
          pageDots: true, // mobile only with CSS
          wrapAround: true,
          cellAlign: 'left',
          contain: true,
          callbacks: {
            onInit: this.onSliderInit.bind(this),
            onChange: this.onSlideChange.bind(this),
          },
        };

        mainSliderArgsColor = {
          adaptiveHeight: true,
          avoidReflow: true,
          initialIndex: this.settings.currentSlideIndex,
          childNav: this.cache.thumbSliderColor,
          childNavScroller: this.cache.thumbScrollerColor,
          //childVertical: this.cache.thumbSlider.dataset.position === 'beside',
          pageDots: true, // mobile only with CSS
          wrapAround: true,
          cellSelector:cellColorSelector,
          cellAlign: 'left',
          contain: true,
          callbacks: {
            onInit: this.onSliderInit.bind(this),
            onChange: this.onSlideChange.bind(this),
          },
        };

        // Override default settings if image set feature enabled
        if (this.settings.imageSetName) {
          var imageSetArgs = this.imageSetArguments(variant);
          mainSliderArgs = Object.assign({}, mainSliderArgs, imageSetArgs);
          this.updateImageSetThumbs(mainSliderArgs.imageSet);
        }

        this.flickity = new theme.Slideshow(
          this.cache.mainSlider,
          mainSliderArgs
        );

        this.flickityvideo = new theme.Slideshow(
          this.cache.mainSlider1,
          mainSliderArgs1
        );
        
        this.flickitylimted = new theme.Slideshow(
          this.cache.mainSlider2,
          mainSliderArgs2
        );

        if(this.cache.mainSliderColor!=null){
          if(jQuery('body').hasClass('gallery_redesign_vone') || jQuery('body').hasClass('gallery_redesign_two_vone')){
            navSliderCacheColor = this.cache.thumbSliderColor;
            navArgsColor = {
              contain: true,
              cellAlign: 'left',
              pageDots: false,
              wrapAround: false,
              cellSelector: '.product__thumb-item:not(.ignore-slide)'
            };
            if (this.cache.thumbSliderColor) {
              this.flickitynavcolor = new theme.Slideshow(
                this.cache.thumbSliderColor,
                navArgsColor
              );
              navSliderinitColor = this.flickitynavcolor;
            }
          }

          mainSliderCacheColor = this.cache.mainSliderColor;
          this.flickitycolor = new theme.Slideshow(
            this.cache.mainSliderColor,
            mainSliderArgsColor
          );
          mainSliderInitColor = this.flickitycolor;
        }

        jQuery('.product-slideshow-video').hide();
        mainThumb = this.flickityvideo;
        mainLimited = this.flickitylimted;
        //console.log("mainLimited",mainLimited);
        mainSliderInit= this.flickity;
        
      },

      onSliderInit: function (slide) {
        // If slider is initialized with image set feature active,
        // initialize any videos/media when they are first slide
        if (this.settings.imageSetName) {
          this.prepMediaOnSlide(slide);
        }
      },

      onSlideChange: function (index) {
        console.log("hiiiiiii",index);
        if (!this.flickity) return;
        //console.log("change sliderrrr");
        if(this.cache.mainSlider!=null){
          var prevSlide = this.cache.mainSlider.querySelector(
            '[data-product-photos] .product-main-slide[data-index="' +
              this.settings.currentSlideIndex +
              '"]'
          );

          // If imageSetName exists, use a more specific selector
          var nextSlide = this.settings.imageSetName
            ? this.cache.mainSlider.querySelectorAll(
                "[data-product-photos] .flickity-slider .product-main-slide"
              )[index]
            : this.cache.mainSlider.querySelector(
                '[data-product-photos] .product-main-slide[data-index="' + index + '"]'
              );
          if(prevSlide!=null){
            prevSlide.setAttribute("tabindex", "-1");
            this.stopMediaOnSlide(prevSlide);
          }
          if(nextSlide!=null){
            nextSlide.setAttribute("tabindex", 0);
            this.prepMediaOnSlide(nextSlide);
          }
        }
        // Pause any existing slide video/media

        // Prep next slide video/media
        if(this.cache.mainSlider1!=null){
          var prevSlide = this.cache.mainSlider1.querySelector(
            '.product-slideshow-video .product-main-slide[data-index="' +
              this.settings.currentSlideIndex +
              '"]'
          );

          if(prevSlide!=null){
            prevSlide.setAttribute("tabindex", "-1");
            // Pause any existing slide video/media
            this.stopMediaOnSlide(prevSlide);
          }
        }

        
        // If imageSetName exists, use a more specific selector
        if(this.cache.mainSliderColor!=null){
          //console.log("color index",index);
          var nextSlide = this.settings.imageSetName
            ? this.cache.mainSliderColor.querySelectorAll(
                ".color-variant-wise .flickity-slider .product-main-slide"
              )[index]
            : this.cache.mainSliderColor.querySelector(
                '.color-variant-wise .product-main-slide[data-index="' + index + '"]'
              );
              
          if(nextSlide!=null){
            nextSlide.setAttribute("tabindex", 0);
            // Prep next slide video/media
            this.prepMediaOnSlide(nextSlide);
            setTimeout(function(){
              galleryColorVideoAutoplay();
            },100);
          }
        }

        //color thumb active slide
        if (document.querySelector('.color-variant-wise-gallery .product__color_thumbs') != null) {

          var navSliderObj = document.querySelector('.color-variant-wise-gallery .product__color_thumbs');

          // Get only visible thumbs (ignore filtered ones)
          var visibleThumbs = navSliderObj.querySelectorAll('.product__thumb-item:not(.ignore-slide)');

          if (visibleThumbs.length > 0 && typeof index === 'number') {

            // 🔥 Remove active from all
            visibleThumbs.forEach(function (el) {
              el.classList.remove('is-selected'); // change if your active class is different
              el.setAttribute("tabindex", -1);
            });

            // 🔥 Add active to correct index
            var nextSlide = visibleThumbs[index];

            if (nextSlide) {
              nextSlide.classList.add('is-selected'); // change if needed
              nextSlide.setAttribute("tabindex", 0);
              // Prep next slide video/media
              this.prepMediaOnSlide(nextSlide);
            }
          }
        }
        
        // Update current slider index
        this.settings.currentSlideIndex = index;
      },

      stopMediaOnSlide(slide) {
        // Stop existing video
        var video = slide.querySelector(selectors.productVideo);
        if (video) {
          var videoType = this._getVideoType(video);
          var videoId = this._getVideoDivId(video);
          if (videoType === "youtube") {
            if (videoObjects[videoId].videoPlayer) {
              videoObjects[videoId].videoPlayer.stopVideo();
              return;
            }
          } else if (videoType === "mp4") {
            this.stopMp4Video(videoId);
            return;
          }
        }

        // Stop existing media
        var currentMedia = slide.querySelector(this.selectors.media);
        if (currentMedia) {
          currentMedia.dispatchEvent(
            new CustomEvent("mediaHidden", {
              bubbles: true,
              cancelable: true,
            })
          );
        }
      },

      prepMediaOnSlide(slide) {
        var video = slide.querySelector(selectors.productVideo);
        if (video) {
          //this.flickity.reposition();
          var videoType = this._getVideoType(video);
          var videoId = this._getVideoDivId(video);
          if (videoType === "youtube") {
            if (
              videoObjects[videoId].videoPlayer &&
              videoObjects[videoId].options.style !== "sound"
            ) {
              videoObjects[videoId].videoPlayer.playVideo();
              return;
            }
          } else if (videoType === "mp4") {
            this.playMp4Video(videoId);
          }
        }

        var nextMedia = slide.querySelector(this.selectors.media);
        if (nextMedia) {
          nextMedia.dispatchEvent(
            new CustomEvent("mediaVisible", {
              bubbles: true,
              cancelable: true,
            })
          );
          slide
            .querySelector(".shopify-model-viewer-ui__button")
            .setAttribute("tabindex", 0);
          slide
            .querySelector(".product-single__close-media")
            .setAttribute("tabindex", 0);
        }
      },

      _slideIndex: function (el) {
        if(el!=null){
          return el.getAttribute("data-index");
        }
      },

      /*============================================================================
        Products when in quick view modal
      ==============================================================================*/
      openModalProduct: function () {
        var initialized = false;

        if (!this.settings.modalInit) {
          this.blocksHolder = this.container.querySelector(
            selectors.blocksHolder
          );
          var url = this.blocksHolder.dataset.url;

          fetch(url)
            .then(function (response) {
              return response.text();
            })
            .then(
              function (html) {
                var parser = new DOMParser();
                var doc = parser.parseFromString(html, "text/html");
                var blocks = doc.querySelector(selectors.blocks);

                // Because the same product could be opened in quick view
                // on the page we load the form elements from, we need to
                // update any `id`, `for`, and `form` attributes
                blocks.querySelectorAll("[id]").forEach((el) => {
                  // Update input `id`
                  var val = el.getAttribute("id");
                  el.setAttribute("id", val + "-modal");

                  // Update related label if it exists
                  var label = blocks.querySelector(`[for="${val}"]`);
                  if (label) {
                    label.setAttribute("for", val + "-modal");
                  }

                  // Update any collapsible elements
                  var collapsibleTrigger = blocks.querySelector(
                    `[aria-controls="${val}"]`
                  );
                  if (collapsibleTrigger) {
                    collapsibleTrigger.setAttribute(
                      "aria-controls",
                      val + "-modal"
                    );
                  }
                });

                // Update any elements with `form` attribute.
                // Form element already has `-modal` appended
                var form = blocks.querySelector(this.selectors.form);
                var formId = form.getAttribute("id");
                blocks.querySelectorAll("[form]").forEach((el) => {
                  el.setAttribute("form", formId);
                });

                this.blocksHolder.innerHTML = "";
                this.blocksHolder.append(blocks);
                this.blocksHolder.classList.add("product-form-holder--loaded");

                this.cacheElements();

                this.formSetup();
                this.updateModalProductInventory();

                if (Shopify && Shopify.PaymentButton) {
                  Shopify.PaymentButton.init();
                }

                // Re-hook up collapsible box triggers
                theme.collapsibles.init(this.container);

                document.dispatchEvent(
                  new CustomEvent("quickview:loaded", {
                    detail: {
                      productId: this.sectionId,
                    },
                  })
                );
              }.bind(this)
            );

          this.productSetup();
          this.videoSetup();

          // Enable product slider in quick view
          // 1. with image sets enabled, make sure we have this.variants before initializing
          // 2. initialize normally, form data not required
          if (this.settings.imageSetName) {
            if (this.variants) {
              this.initProductSlider();
            } else {
              document.addEventListener(
                "quickview:loaded",
                function (evt) {
                  if (evt.detail.productId === this.sectionId) {
                    this.initProductSlider();
                  }
                }.bind(this)
              );
            }
          } else {
            this.initProductSlider();
          }
          this.customMediaListners();
          this.addIdToRecentlyViewed();
          this.settings.modalInit = true;
        } else {
          initialized = true;
        }

        AOS.refreshHard();

        document.dispatchEvent(
          new CustomEvent("quickview:open", {
            detail: {
              initialized: initialized,
              productId: this.sectionId,
            },
          })
        );
      },

      // Recommended products load via JS and don't add variant inventory to the
      // global variable that we later check. This function scrapes a data div
      // to get that info and manually add the values.
      updateModalProductInventory: function () {
        window.inventories = window.inventories || {};
        this.container
          .querySelectorAll(".js-product-inventory-data")
          .forEach((el) => {
            var productId = el.dataset.productId;
            window.inventories[productId] = {};

            el.querySelectorAll(".js-variant-inventory-data").forEach((el) => {
              window.inventories[productId][el.dataset.id] = {
                quantity: el.dataset.quantity,
                policy: el.dataset.policy,
                incoming: el.dataset.incoming,
                next_incoming_date: el.dataset.date,
              };
            });
          });
      },

      closeModalProduct: function () {
        this.stopVideos();
      },

      /*============================================================================
        Product media (3D)
      ==============================================================================*/
      initModelViewerLibraries: function () {
        var modelViewerElements = this.container.querySelectorAll(
          this.selectors.media
        );
        if (modelViewerElements.length < 1) return;

        theme.ProductMedia.init(modelViewerElements, this.sectionId);
      },

      initShopifyXrLaunch: function () {
        document.addEventListener(
          "shopify_xr_launch",
          function () {
            var currentMedia = this.container.querySelector(
              this.selectors.productMediaWrapper +
                ":not(." +
                self.classes.hidden +
                ")"
            );
            currentMedia.dispatchEvent(
              new CustomEvent("xrLaunch", {
                bubbles: true,
                cancelable: true,
              })
            );
          }.bind(this)
        );
      },

      customMediaListners: function () {
        document.querySelectorAll(this.selectors.closeMedia).forEach((el) => {
          el.addEventListener(
            "click",
            function () {
              var slide = this.cache.mainSlider.querySelector(
                selectors.currentSlide
              );
              var media = slide.querySelector(this.selectors.media);
              if (media) {
                media.dispatchEvent(
                  new CustomEvent("mediaHidden", {
                    bubbles: true,
                    cancelable: true,
                  })
                );
              }

              var slide = this.cache.mainSlider1.querySelector(
                selectors.currentSlide
              );
              
              var media = slide.querySelector(this.selectors.media);
              if (media) {
                media.dispatchEvent(
                  new CustomEvent("mediaHidden", {
                    bubbles: true,
                    cancelable: true,
                  })
                );
              }
            }.bind(this)
          );
        });

        var modelViewers = this.container.querySelectorAll("model-viewer");
        if (modelViewers.length) {
          modelViewers.forEach((el) => {
            el.addEventListener(
              "shopify_model_viewer_ui_toggle_play",
              function (evt) {
                this.mediaLoaded(evt);
              }.bind(this)
            );

            el.addEventListener(
              "shopify_model_viewer_ui_toggle_pause",
              function (evt) {
                this.mediaUnloaded(evt);
              }.bind(this)
            );
          });
        }
      },

      mediaLoaded: function (evt) {
        this.container
          .querySelectorAll(this.selectors.closeMedia)
          .forEach((el) => {
            el.classList.remove(classes.hidden);
          });

        if (this.flickity) {
          this.flickity.setDraggable(false);
        }
      },

      mediaUnloaded: function (evt) {
        this.container
          .querySelectorAll(this.selectors.closeMedia)
          .forEach((el) => {
            el.classList.add(classes.hidden);
          });

        if (this.flickity) {
          this.flickity.setDraggable(true);
        }
      },

      onUnload: function () {
        theme.ProductMedia.removeSectionModels(this.sectionId);

        if (this.flickity && typeof this.flickity.destroy === "function") {
          this.flickity.destroy();
        }
      },
    });

    return Product;
  })();

  theme.RecentlyViewed = (function () {
    var init = false;

    function RecentlyViewed(container) {
      if (!container) {
        return;
      }

      this.container = container;
      this.sectionId = this.container.getAttribute("data-section-id");
      this.namespace = ".recently-viewed" + this.sectionId;
      this.gridItemWidth = this.container.getAttribute("data-grid-item-class");
      this.rowOf = this.container.getAttribute("data-row-of");

      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 600,
      });
    }

    RecentlyViewed.prototype = Object.assign({}, RecentlyViewed.prototype, {
      init: function () {
        if (init) {
          return;
        }

        init = true;

        if (
          Object.keys(theme.recentlyViewed.recent).length === 0 &&
          theme.recentlyViewed.recent.constructor === Object
        ) {
          // No previous history on page load, so bail
          this.container.classList.add("hide");
          return;
        }

        this.outputContainer = document.getElementById(
          "RecentlyViewed-" + this.sectionId
        );
        this.handle = this.container.getAttribute("data-product-handle");

        // Request new product info via JS API
        var promises = [];
        Object.keys(theme.recentlyViewed.recent).forEach(
          function (handle) {
            if (handle !== "undefined") {
              promises.push(this.getProductInfo(handle));
            }
          }.bind(this)
        );

        Promise.all(promises).then(
          function (result) {
            this.setupOutput(result);
            this.captureProductDetails(result);
          }.bind(this)
        );
      },

      getProductInfo: function (handle) {
        return new Promise(function (resolve, reject) {
          if (theme.recentlyViewed.productInfo.hasOwnProperty(handle)) {
            resolve(theme.recentlyViewed.productInfo[handle]);
          } else {
            fetch("/products/" + handle + ".js")
              .then(function (response) {
                return response.text();
              })
              .then(function (product) {
                resolve(product);
              });
          }
        });
      },

      setupOutput: function (products) {
        var allProducts = [];
        var data = {};
        var limit = this.container.getAttribute("data-recent-count");

        var i = 0;

        Object.keys(products).forEach(
          function (key) {
            if (!products[key]) {
              return;
            }
            var product = JSON.parse(products[key]);

            // Ignore current product
            if (product.handle === this.handle) {
              return;
            }

            // Ignore undefined key
            if (typeof product.handle == "undefined") {
              return;
            }

            i++;

            // New or formatted properties
            product.url = theme.recentlyViewed.recent[product.handle]
              ? theme.recentlyViewed.recent[product.handle].url
              : product.url;
            product.image_responsive_url =
              theme.recentlyViewed.recent[product.handle].featuredImage;
            product.image_aspect_ratio =
              theme.recentlyViewed.recent[product.handle].aspectRatio;

            // Unit pricing checks first variant
            var firstVariant = product.variants[0];
            if (firstVariant && firstVariant.unit_price) {
              var baseUnit = "";

              if (firstVariant.unit_price_measurement) {
                if (firstVariant.unit_price_measurement.reference_value != 1) {
                  baseUnit +=
                    firstVariant.unit_price_measurement.reference_value + " ";
                }
                baseUnit += firstVariant.unit_price_measurement.reference_unit;
              }

              product.unit_price = theme.Currency.formatMoney(
                firstVariant.unit_price
              );
              if (baseUnit != "") {
                product.unit_price += "/" + baseUnit;
              }
            }

            allProducts.unshift(product);
          }.bind(this)
        );

        if (allProducts.length === 0) {
          this.container.classList.add("hide");
          return;
        }

        var productMarkup = theme.buildProductGridItem(
          allProducts.slice(0, limit),
          this.gridItemWidth,
          this.rowOf
        );

        this.outputContainer.innerHTML = productMarkup;

        if (AOS) {
          AOS.refreshHard();
        }
      },

      captureProductDetails: function (products) {
        for (var i = 0; i < products.length; i++) {
          var product = products[i];
          theme.recentlyViewed.productInfo[product.handle] = product;
        }

        // Add data to session storage to reduce API requests later
        if (theme.config.hasSessionStorage) {
          sessionStorage.setItem(
            "recent-products",
            JSON.stringify(theme.recentlyViewed.productInfo)
          );
        }
      },

      onUnload: function () {
        init = false;
      },
    });

    return RecentlyViewed;
  })();

  theme.Testimonials = (function () {
    var defaults = {
      adaptiveHeight: true,
      avoidReflow: true,
      pageDots: true,
      prevNextButtons: false,
    };

    function Testimonials(container) {
      this.container = container;
      this.timeout;
      var sectionId = container.getAttribute("data-section-id");
      this.slideshow = container.querySelector("#Testimonials-" + sectionId);
      this.namespace = ".testimonial-" + sectionId;

      if (!this.slideshow) {
        return;
      }

      theme.initWhenVisible({
        element: this.container,
        callback: this.init.bind(this),
        threshold: 600,
      });
    }

    Testimonials.prototype = Object.assign({}, Testimonials.prototype, {
      init: function () {
        // Do not wrap when only a few blocks
        if (this.slideshow.dataset.count <= 3) {
          defaults.wrapAround = false;
        }

        this.flickity = new theme.Slideshow(this.slideshow, defaults);

        // Autoscroll to next slide on load to indicate more blocks
        if (this.slideshow.dataset.count > 2) {
          this.timeout = setTimeout(
            function () {
              this.flickity.goToSlide(1);
            }.bind(this),
            1000
          );
        }
      },

      onUnload: function () {
        if (this.flickity && typeof this.flickity.destroy === "function") {
          this.flickity.destroy();
        }
      },

      onDeselect: function () {
        if (this.flickity && typeof this.flickity.play === "function") {
          this.flickity.play();
        }
      },

      onBlockSelect: function (evt) {
        var slide = this.slideshow.querySelector(
          ".testimonials-slide--" + evt.detail.blockId
        );
        var index = parseInt(slide.dataset.index);

        clearTimeout(this.timeout);

        if (this.flickity && typeof this.flickity.pause === "function") {
          this.flickity.goToSlide(index);
          this.flickity.pause();
        }
      },

      onBlockDeselect: function () {
        if (this.flickity && typeof this.flickity.play === "function") {
          this.flickity.play();
        }
      },
    });

    return Testimonials;
  })();

  theme.isStorageSupported = function (type) {
    // Return false if we are in an iframe without access to sessionStorage
    if (window.self !== window.top) {
      return false;
    }

    var testKey = "test";
    var storage;
    if (type === "session") {
      storage = window.sessionStorage;
    }
    if (type === "local") {
      storage = window.localStorage;
    }

    try {
      storage.setItem(testKey, "1");
      storage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  };

  theme.reinitProductGridItem = function (scope) {
    if (AOS) {
      AOS.refreshHard();
    }

    theme.initQuickShop();

    // Refresh reviews app
    if (window.SPR) {
      SPR.initDomEls();
      SPR.loadBadges();
    }

    // Re-hook up collapsible box triggers
    theme.collapsibles.init();
  };

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/
  theme.config.hasSessionStorage = theme.isStorageSupported("session");
  theme.config.hasLocalStorage = theme.isStorageSupported("local");
  AOS.init({
    easing: "ease-out-quad",
    once: true,
    offset: 60,
    disableMutationObserver: true,
  });

  if (theme.config.hasLocalStorage) {
    theme.recentlyViewed.localStorage =
      window.localStorage.getItem("theme-recent");

    if (theme.recentlyViewed.localStorage) {
      theme.recentlyViewed.recent = JSON.parse(
        theme.recentlyViewed.localStorage
      );
    }
  }

  theme.recentlyViewed.productInfo =
    theme.config.hasSessionStorage && sessionStorage["recent-products"]
      ? JSON.parse(sessionStorage["recent-products"])
      : {};

  // Trigger events when going between breakpoints
  theme.config.bpSmall = matchMedia(theme.config.mediaQuerySmall).matches;
  matchMedia(theme.config.mediaQuerySmall).addListener(function (mql) {
    if (mql.matches) {
      theme.config.bpSmall = true;
      document.dispatchEvent(new CustomEvent("matchSmall"));
    } else {
      theme.config.bpSmall = false;
      document.dispatchEvent(new CustomEvent("unmatchSmall"));
    }
  });

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  // Load generic JS. Also reinitializes when sections are
  // added, edited, or removed in Shopify's editor
  theme.initGlobals = function () {
    theme.collapsibles.init();
    theme.videoModal();
  };

  DOMready(function () {
    theme.sections = new theme.Sections();

    theme.sections.register("slideshow-section", theme.SlideshowSection);
    theme.sections.register("header", theme.HeaderSection);
    theme.sections.register("product", theme.Product);
    theme.sections.register("blog", theme.Blog);
    theme.sections.register("password-header", theme.PasswordHeader);
    theme.sections.register("photoswipe", theme.Photoswipe);
    theme.sections.register("product-recommendations", theme.Recommendations);
    theme.sections.register("background-image", theme.BackgroundImage);
    theme.sections.register("testimonials", theme.Testimonials);
    theme.sections.register("video-section", theme.VideoSection);
    theme.sections.register("map", theme.Maps);
    theme.sections.register("footer-section", theme.FooterSection);
    theme.sections.register("store-availability", theme.StoreAvailability);
    theme.sections.register("recently-viewed", theme.RecentlyViewed);
    theme.sections.register("newsletter-popup", theme.NewsletterPopup);
    theme.sections.register("collection-header", theme.CollectionHeader);
    
    //theme.sections.register("collection-grid", theme.Collection);
    var setIntFilter = setInterval(function(){
      if($('body').hasClass('convert_filter') && customFilter == ''){
          console.log("innn")
          //theme.Collection.init();
          customFilter = 1;
          theme.sections.register("collection-grid", theme.Collection);
          clearInterval(setIntFilter);
      }
      else{
        theme.sections.register("collection-grid", theme.Collection);
        clearInterval(setIntFilter);
      }
    },500)
    

    theme.initGlobals();
    theme.initQuickShop();
    theme.rteInit();

    if (document.body.classList.contains("template-cart")) {
      var cartPageForm = document.getElementById("CartPageForm");
      if (cartPageForm) {
        new theme.CartForm(cartPageForm);
      }
    }

    if (theme.settings.predictiveSearch) {
      theme.predictiveSearch.init();
    }

    if (theme.settings.isCustomerTemplate) {
      theme.customerTemplates();
    }

    document.dispatchEvent(new CustomEvent("page:loaded"));
  });
})();

$(document).on("change", "select.select_variants", function () {
  let currentOPrice = $("option:selected", this).attr("variant_price");
  let currentImage = $("option:selected", this).attr("variant_image");

  let currentCPrice = $("option:selected", this).attr("variant_price-compare");
  $(this)
    .closest(".custom--upsell-item-details")
    .find(".upsell-original--price")
    .html(currentOPrice);
  $(this)
    .closest(".custom--upsell-item-details")
    .find(".upsell-compare--price")
    .html(currentCPrice);
  $(this)
    .closest(".custom--upsell-item-details")
    .prev(".custom--upsell-item-img")
    .find("img")
    .attr("src", currentImage);
});

$(document).on("change", "select.custom_select_variants", function () {
  let currentOPrice = $("option:selected", this).attr("variant_price");
  let currentImage = $("option:selected", this).attr("variant_image");

  let currentCPrice = $("option:selected", this).attr("variant_price-compare");
  $(this)
    .closest(".complete-look__product-details")
    .find(".complete-look__product-price")
    .html(currentOPrice);
  $(this)
    .closest(".complete-look__product-details")
    .find(".the-cart-drawer-compare-at-price")
    .html(currentCPrice);
  $(this).closest(".complete-look__wrap").find("img").attr("src", currentImage);
});

$(document).on("click", ".upsell-add-button", function (e) {
  e.preventDefault();
  var $el = $(this),
    data_id = $el
      .closest(".upsell-item-form")
      .find("select option:selected")
      .val(),
    qty = 1;
  // $el.find('.custom--loader').show();

  // If it has a data-line, update the cart.
  // Otherwise, just update the input's number
  if (data_id) {
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        quantity: qty,
        id: data_id,
      },
      dataType: "json",
      success: function (data) {
        document.dispatchEvent(new CustomEvent("cart:build"));
        setTimeout(function(){
          initUpsellSwiper();
        },500);
      },
      error: function (XMLHttpRequest, textStatus) {
        alert(textStatus);
      },
    });
    setTimeout(function () {
      // $('.custom--loader').hide();
    }, 500);
  }
});


/* :::::::::::::::::::::::::::::: CART DRAWER UPSELL CONVERT FOR INIT SLIDER START JS ::::::::::::::::::::::::::::::::::*/

function initUpsellSwiper() {
  console.log("call slider");
  const container = jQuery('.main-upsells--container .custom--upsell-inner.swiper');

  if (container.length === 0) return;

  // Destroy existing swiper first
  if (upsellSwiper) {
    upsellSwiper.destroy(true, true);
    upsellSwiper = null;
  }

  // Step 1: Restore any previously masked slides
  container.find('.swiper-slide-hidden-temp').each(function () {
    jQuery(this)
      .addClass('swiper-slide')
      .removeClass('swiper-slide-hidden-temp')
      .css('display', ''); // reset inline display
  });

  // Step 2: Temporarily strip swiper-slide class from .hide slides
  container.find('.swiper-slide.hide').each(function () {
    jQuery(this)
      .removeClass('swiper-slide')
      .addClass('swiper-slide-hidden-temp')
      .css('display', 'none'); // keep hidden visually
  });

  // Count only active slides
  const visibleSlides = container.find('.swiper-slide').length;
  console.log("Visible slides:", visibleSlides);

  if (visibleSlides > 1) {
    upsellSwiper = new Swiper(container[0], {
      slidesPerView: 1,
      spaceBetween: 8,
      navigation: {
        nextEl: ".main-upsells--container .slider-nav-next",
        prevEl: ".main-upsells--container .slider-nav-prev",
      },
      pagination: {
        el: ".main-upsells--container .swiper-pagination",
        type: "progressbar",
      },
      observer: true,
      observeParents: true,
    });
  }
}


/* :::::::::::::::::::::::::::::: CART DRAWER UPSELL CONVERT FOR INIT SLIDER START JS ::::::::::::::::::::::::::::::::::*/

$(document).on("click", ".complete-look__cta", function (e) {
  e.preventDefault();
  var $el = $(this),
    data_id = $el
      .closest(".complete-look__product-details")
      .find(".upsell-item-form")
      .find("select option:selected")
      .val(),
    qty = 1;
  // $el.find('.custom--loader').show();

  // If it has a data-line, update the cart.
  // Otherwise, just update the input's number
  if (data_id) {
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        quantity: qty,
        id: data_id,
      },
      dataType: "json",
      success: function (data) {
        document.dispatchEvent(new CustomEvent("cart:build"));
      },
      error: function (XMLHttpRequest, textStatus) {
        alert(textStatus);
      },
    });
    setTimeout(function () {
      // $('.custom--loader').hide();
    }, 500);
  }
});

$(document).ready(function () {
  $.ajax({
    url: "/cart",
    dataType: "json",
    error: function (items) {
      console.error(items[0]);
      loadingBarTrigger("done");
    },
    success: function (cart) {
      $(".custom--upsell-item").removeClass("hide");
      // Custom
      let upsell_1ID = $(".upsell_1_id").attr("product--id");
      let upsell_2ID = $(".upsell_2_id").attr("product--id");
      let upsell_3ID = $(".upsell_3_id").attr("product--id");
      let upsell_4ID = $(".upsell_4_id").attr("product--id");
      let mainCartItems = cart.items;
      let found_package_in_cart = false;
      let line_item_id = null;
      for (var i = 0; i < mainCartItems.length; i++) {
        console.log(mainCartItems[i],upsell_1ID,upsell_2ID);
        line_item_id = mainCartItems[i].product_id;
        if (
          line_item_id == upsell_1ID ||
          line_item_id == upsell_2ID ||
          line_item_id == upsell_3ID ||
          line_item_id == upsell_4ID
        ) {
          $(".custom--upsell-item[product--id=" + line_item_id + "]").addClass(
            "hide"
          );
        }
        if (
          line_item_id == upsell_1ID &&
          line_item_id == upsell_2ID &&
          line_item_id == upsell_3ID
        ) {
          $(".custom--section--upsells").addClass("hide");
        }
      }
      // end Custom
    },
  });

  document.addEventListener("cart:build", function (evt) {
    $.ajax({
      url: "/cart",
      dataType: "json",
      error: function (items) {
        console.error(items[0]);
        loadingBarTrigger("done");
      },
      success: function (cart) {
        // Custom
        let upsell_1ID = $(".upsell_1_id").attr("product--id");
        let upsell_2ID = $(".upsell_2_id").attr("product--id");
        let upsell_3ID = $(".upsell_3_id").attr("product--id");
        let upsell_4ID = $(".upsell_4_id").attr("product--id");
        let mainCartItems = cart.items;
        let found_package_in_cart = false;
        let line_item_id = null;
        for (var i = 0; i < mainCartItems.length; i++) {
          // console.log(mainCartItems[i]);
          line_item_id = mainCartItems[i].product_id;
          if (
            line_item_id == upsell_1ID ||
            line_item_id == upsell_2ID ||
            line_item_id == upsell_3ID ||
            line_item_id == upsell_4ID
          ) {
            $(
              ".custom--upsell-item[product--id=" + line_item_id + "]"
            ).addClass("hide");
          } else {
            $(
              ".custom--upsell-item[product--id=" + line_item_id + "]"
            ).removeClass("hide");
          }
        }
        // end Custom
      },
    });
  });
});

// Product Page Shoppay and Afterpay Placement

fetch(
  "https://" + window.location.hostname + "/browsing_context_suggestions.json"
)
  .then((res) => res.json())
  .then((r) => {
    if (r.detected_values.country.name == "United States") {
      if (document.querySelector("#product-afterpay-placement")) {
        document.querySelector("#product-afterpay-placement").style.display =
        "flex";
      }
      if (document.querySelector("#product-afterpay-placement-2")) {
        document.querySelector("#product-afterpay-placement-2").style.display =
        "flex";
      }
      if (document.querySelector("#product-afterpay-placement-3")) {
        document.querySelector("#product-afterpay-placement-3").style.display =
        "flex";
      }
    } else if (r.detected_values.country.name == "Australia") {
      if (document.querySelector("#product-afterpay-placement")) {
        document.querySelector("#product-afterpay-placement").style.display =
        "flex";
      }
      if (document.querySelector("#product-afterpay-placement-2")) {
        document.querySelector("#product-afterpay-placement-2").style.display =
        "flex";
      }
      if (document.querySelector("#product-afterpay-placement-3")) {
        document.querySelector("#product-afterpay-placement-3").style.display =
        "flex";
      }
    } else if (r.detected_values.country.name == "United Kingdom") {
      if (document.querySelector("#product-afterpay-placement")) {
        document.querySelector("#product-afterpay-placement").style.display =
        "flex";
      }
      if (document.querySelector("#product-afterpay-placement-2")) {
        document.querySelector("#product-afterpay-placement-2").style.display =
        "flex";
      }
      if (document.querySelector("#product-afterpay-placement-3")) {
        document.querySelector("#product-afterpay-placement-3").style.display =
        "flex";
      }
    } else if (r.detected_values.country.name == "Canada") {
      if (document.querySelector("#product-afterpay-placement")) {
        document.querySelector("#product-afterpay-placement").style.display =
        "flex";
      }
      if (document.querySelector("#product-afterpay-placement-2")) {
        document.querySelector("#product-afterpay-placement-2").style.display =
        "flex";
      }
      if (document.querySelector("#product-afterpay-placement-3")) {
        document.querySelector("#product-afterpay-placement-3").style.display =
        "flex";
      }
    } else if (r.detected_values.country.name == "New Zealand") {
      if (document.querySelector("#product-afterpay-placement")) {
        document.querySelector("#product-afterpay-placement").style.display =
        "flex";
      }
      if (document.querySelector("#product-afterpay-placement-2")) {
        document.querySelector("#product-afterpay-placement-2").style.display =
        "flex";
      }
      if (document.querySelector("#product-afterpay-placement-3")) {
        document.querySelector("#product-afterpay-placement-3").style.display =
        "flex";
      }
    } else {
      if (document.querySelector("#product-afterpay-placement")) {
        document.querySelector("#product-afterpay-placement").style.display =
        "none";
      }
      if (document.querySelector("#product-afterpay-placement-2")) {
        document.querySelector("#product-afterpay-placement-2").style.display =
        "none";
      }
      if (document.querySelector("#product-afterpay-placement-3")) {
        document.querySelector("#product-afterpay-placement-3").style.display =
        "none";
      }
    }

    if (r.detected_values.country.name == "United States") {
      setTimeout(function () {
        window._shipScout = window._shipScout || [];
        _shipScout.push(function (response) {
          //apply any exchange rates to currency if necessary
          var thresholdCents =
            window.Shopify && Shopify.currency && Shopify.currency.rate
              ? response.freeShippingThresholdCents * Shopify.currency.rate
              : response.freeShippingThresholdCents;
          var flatrateCents =
            window.Shopify && Shopify.currency && Shopify.currency.rate
              ? response.shippingPriceCents * Shopify.currency.rate
              : response.shippingPriceCents;
          //format currency
          var currencyFormat = ShipScoutGetCurrency();

          //get threshold amount with currency symbol
          var thresholdAmount = ShipScoutFormatMoney(
            thresholdCents,
            currencyFormat
          );

          //get flat rate amount with currency symbol
          var flatrateAmount = ShipScoutFormatMoney(
            flatrateCents,
            currencyFormat
          );
          if (response.freeShippingThresholdCents === 0) {
            //el.innerHTML = "FREE!";
          } else {
            var paragraphs = document.getElementsByClassName("ann-price");
            paragraphs.forEach(function (paragraph, index) {
              var oldHtml = paragraph.innerHTML;
              paragraph.innerHTML = oldHtml.replace("$45.00", thresholdAmount);
            });
            var collapsibleArr =
              document.getElementsByClassName("product-tab-text");
            collapsibleArr.forEach(function (collapsibleSingle, index) {
              var oldcollapsibleSingleHtml = collapsibleSingle.innerHTML;
              collapsibleSingle.innerHTML = oldcollapsibleSingleHtml.replace(
                "£50",
                thresholdAmount
              );
            });
          }
        });
      }, 2000);
    }
  });

/* _shipScout start */
/*fetch('https://'+window.location.hostname+'/browsing_context_suggestions.json')
            .then(res=>res.json())
            .then(r=> {
                console.log("1111====>"+r.detected_values.country.name);
                if(r.detected_values.country.name == 'United States'){
                  setTimeout(function() {
                    window._shipScout = window._shipScout || [];
                    _shipScout.push(function (response) {
                        console.log("_shipScout===>"+response);
                      //apply any exchange rates to currency if necessary
                      var thresholdCents = (window.Shopify && Shopify.currency && Shopify.currency.rate) ? response.freeShippingThresholdCents * Shopify.currency.rate : response.freeShippingThresholdCents;
                      var flatrateCents = (window.Shopify && Shopify.currency && Shopify.currency.rate) ? response.shippingPriceCents * Shopify.currency.rate : response.shippingPriceCents;
                      //format currency
                      var currencyFormat = ShipScoutGetCurrency();
                      
                      //get threshold amount with currency symbol
                      var thresholdAmount = ShipScoutFormatMoney(thresholdCents, currencyFormat);
                    
                      //get flat rate amount with currency symbol
                      var flatrateAmount = ShipScoutFormatMoney(flatrateCents, currencyFormat);
                      console.log("_shipScout__thresholdAmount===>"+thresholdAmount);
                      if(response.freeShippingThresholdCents === 0) {
                          //el.innerHTML = "FREE!";
                      } else {
                        var paragraphs = document.getElementsByClassName("ann-price");
                        paragraphs.forEach(function(paragraph, index) {
                          var oldHtml = paragraph.innerHTML;
                          paragraph.innerHTML = oldHtml.replace('$45.00', thresholdAmount);
                        });
                        // var collapsibleArr = document.getElementsByClassName("product-tab-text");
                        // collapsibleArr.forEach(function(collapsibleSingle, index) {
                        //   var oldcollapsibleSingleHtml = collapsibleSingle.innerHTML;
                        //   collapsibleSingle.innerHTML = oldcollapsibleSingleHtml.replace('£50', thresholdAmount);
                        // });
                      }
                    });
                  }, 2000);
                }
            });*/
/* _shipScout end */

fetch(
  "https://" + window.location.hostname + "/browsing_context_suggestions.json"
)
  .then((res) => res.json())
  .then((r) => {
    if (r.detected_values.country.name == "United States") {
      if (document.querySelector("#product-shoppay-placement")) {
        document.querySelector("#product-shoppay-placement").style.display = "flex";
      }
    } else {
      if (document.querySelector("#product-shoppay-placement")) {
        document.querySelector("#product-shoppay-placement").style.display = "none";
      }
    }
  });

// product template (3 variant js)
$(document).ready(function () {
  $(".variant__input--color-swatch").on("change", function () {
    var selectColorVal = this.value;
    var selectColorImg = $(this).attr("data-img");

    $(".apex-custom-product-box-1 .variant-input-wrap-color")
      .find("label")
      .removeClass("active");
    $(".apex-custom-product-box-2 .variant-input-wrap-color")
      .find("label")
      .removeClass("active");
    if (
      $(".apex-custom-product-box-2 .variant-input-wrap-color").find(
        '[data-value="' + selectColorVal + '"]'
      )
    ) {
      $(".apex-custom-product-box-2 .variant-input-wrap-color")
        .find('[data-value="' + selectColorVal + '"]')
        .find("label")
        .addClass("active");
      $(".apex-custom-product-box-2")
        .find(".variant__label")
        .find("[data-variant-color-label]")
        .text(selectColorVal);
    }
    if (
      $(".apex-custom-product-box-1 .variant-input-wrap-color").find(
        '[data-value="' + selectColorVal + '"]'
      )
    ) {
      $(".apex-custom-product-box-1 .variant-input-wrap-color")
        .find('[data-value="' + selectColorVal + '"]')
        .find("label")
        .addClass("active");
      $(".apex-custom-product-box-1")
        .find(".variant__label")
        .find("[data-variant-color-label]")
        .text(selectColorVal);
    }

    $(".apex-custom-product-box-3")
      .find(".variant-popdown-color")
      .find(".variant-popdown-select")
      .find(".vpopdown-img")
      .find("img")
      .attr("src", selectColorImg);
    $(".apex-custom-product-box-3")
      .find(".variant-popdown-color")
      .find(".variant-popdown-select")
      .find(".varianttitle-color")
      .text(selectColorVal);

    //Color wise variant image show start
    if(jQuery('body').hasClass('color-variant-wise-gallery')){
      colorWiseGallery(selectColorVal);
    }
    stickyProductInfoset();
    bundleProductInfoset();
    //Color wise variant image show end
  });

  if ($('input[name="Color"]:checked').val() != "") {
    var selectColorVal = $('input[name="Color"]:checked').val();
    var selectColorImg = $('input[name="Color"]:checked').attr("data-img");

    $(".apex-custom-product-box-1 .variant-input-wrap-color")
      .find("label")
      .removeClass("active");
    $(".apex-custom-product-box-2 .variant-input-wrap-color")
      .find("label")
      .removeClass("active");
    if (
      $(".apex-custom-product-box-2 .variant-input-wrap-color").find(
        '[data-value="' + selectColorVal + '"]'
      )
    ) {
      $(".apex-custom-product-box-2 .variant-input-wrap-color")
        .find('[data-value="' + selectColorVal + '"]')
        .find("label")
        .addClass("active");
      $(".apex-custom-product-box-2")
        .find(".variant__label")
        .find("[data-variant-color-label]")
        .text(selectColorVal);
    }
    if (
      $(".apex-custom-product-box-1 .variant-input-wrap-color").find(
        '[data-value="' + selectColorVal + '"]'
      )
    ) {
      $(".apex-custom-product-box-1 .variant-input-wrap-color")
        .find('[data-value="' + selectColorVal + '"]')
        .find("label")
        .addClass("active");
      $(".apex-custom-product-box-1")
        .find(".variant__label")
        .find("[data-variant-color-label]")
        .text(selectColorVal);
    }

    $(".apex-custom-product-box-3")
      .find(".variant-popdown-color")
      .find(".variant-popdown-select")
      .find(".vpopdown-img")
      .find("img")
      .attr("src", selectColorImg);
    $(".apex-custom-product-box-3")
      .find(".variant-popdown-color")
      .find(".variant-popdown-select")
      .find(".varianttitle-color")
      .text(selectColorVal);

      //console.log("selectColorVal",selectColorVal);
  }

  /*SIZE*/
  $(".variant__input--other-swatch").on("change", function () {
    var selectSizeVal = this.value;
    $(".apex-custom-product-box-1 .variant-input-wrap-size")
      .find("label")
      .removeClass("active");
    $(".apex-custom-product-box-2 .variant-input-wrap-size")
      .find("label")
      .removeClass("active");
    if (
      $(".apex-custom-product-box-2 .variant-input-wrap-size").find(
        '[data-value="' + selectSizeVal + '"]'
      )
    ) {
      $(".apex-custom-product-box-2 .variant-input-wrap-size")
        .find('[data-value="' + selectSizeVal + '"]')
        .find("label")
        .addClass("active");
    }
    if (
      $(".apex-custom-product-box-1 .variant-input-wrap-size").find(
        '[data-value="' + selectSizeVal + '"]'
      )
    ) {
      $(".apex-custom-product-box-1 .variant-input-wrap-size")
        .find('[data-value="' + selectSizeVal + '"]')
        .find("label")
        .addClass("active");
    }

    $(".apex-custom-product-box-3")
      .find(".variant-popdown-size")
      .find(".variant-popdown-select")
      .find(".varianttitle-size")
      .text(selectSizeVal);
      stickyProductInfoset();
      bundleProductInfoset();
  });
  if ($('input[name="Size"]:checked').val() != "") {
    var selectSizeVal = $('input[name="Size"]:checked').val();
    $(".apex-custom-product-box-1 .variant-input-wrap-size")
      .find("label")
      .removeClass("active");
    $(".apex-custom-product-box-2 .variant-input-wrap-size")
      .find("label")
      .removeClass("active");
    if (
      $(".apex-custom-product-box-2 .variant-input-wrap-size").find(
        '[data-value="' + selectSizeVal + '"]'
      )
    ) {
      $(".apex-custom-product-box-2 .variant-input-wrap-size")
        .find('[data-value="' + selectSizeVal + '"]')
        .find("label")
        .addClass("active");
    }
    if (
      $(".apex-custom-product-box-1 .variant-input-wrap-size").find(
        '[data-value="' + selectSizeVal + '"]'
      )
    ) {
      $(".apex-custom-product-box-1 .variant-input-wrap-size")
        .find('[data-value="' + selectSizeVal + '"]')
        .find("label")
        .addClass("active");
    }

    $(".apex-custom-product-box-3")
      .find(".variant-popdown-size")
      .find(".variant-popdown-select")
      .find(".varianttitle-size")
      .text(selectSizeVal);
  }

  // Close the dropdown when clicking outside of it
  $(document).on("click", function (event) {
    var $target = $(event.target);
    if (!$target.closest(".variant-popdown").length) {
      $(".variant-popdown-list").hide();
    }
  });

  // Close the dropdown when clicking on the select button
  $(".variant-popdown-select").on("click", function (event) {
    $(".variant-popdown-list").hide();
    if ($(this).hasClass("d-open")) {
      $(".variant-popdown-list").hide();
      $(this).removeClass("d-open");
    } else {
      $(this).addClass("d-open");
      var currentSeclVal = $(this).attr("data-val");
      $(".varianttitle-" + currentSeclVal).show();
      event.stopPropagation();
    }
  });
});

// product page block style 2 & 3
$(".varianttitle-color li").on("click", function (e) {
  e.preventDefault();
  $(".varianttitle-color li").removeClass("select");
  $(this).addClass("select");

  var selectColorImg = $(this).data("img");
  var selectColorVal = $(this).data("value");
  $(".apex-custom-product-box-3")
    .find(".variant-popdown-color")
    .find(".variant-popdown-select")
    .find(".vpopdown-img")
    .find("img")
    .attr("src", selectColorImg);
  $(".apex-custom-product-box-3")
    .find(".variant-popdown-color")
    .find(".variant-popdown-select")
    .find(".varianttitle-color")
    .text(selectColorVal);
  $(".variant-popdown-list").hide();
  $(".variant-popdown-select").removeClass("d-open");

  $(".variant__input--color-swatch").each(function (index, element) {
    if ($(this).val() == selectColorVal) {
      $(this).trigger("click");
    }
  });
});

$(".varianttitle-size li").on("click", function (e) {
  e.preventDefault();
  $(".varianttitle-size li").removeClass("select");
  $(this).addClass("select");

  var selectSizeVal = $(this).data("value");
  $(".apex-custom-product-box-3")
    .find(".variant-popdown-size")
    .find(".variant-popdown-select")
    .find(".varianttitle-size")
    .text(selectSizeVal);
  $(".variant-popdown-list").hide();
  $(".variant-popdown-select").removeClass("d-open");

  $(".variant__input--other-swatch").each(function (index, element) {
    if ($(this).val() == selectSizeVal) {
      $(this).trigger("click");
    }
  });
});
// end of product page block style 2 & 3
jQuery(document).ready(function () {
  jQuery(".size-guide-cta").click(function () {
    jQuery(".modal-product-size").show();
    jQuery(".modal-product-size").addClass("active");
    jQuery(".modal-backdrop").remove();
    jQuery("body").append('<div class="modal-backdrop fade"></div>');
  });
  jQuery(".modal-btn").click(function () {
      closeModal();
  });
  jQuery(".modal-product-size").click(function (e) {
      if (!jQuery(e.target).closest(".modal-content").length) {
          closeModal();
      }
  });
  
  // jQuery(".modal-btn").click(function () {
  //   jQuery(".modal-product-size").hide();
  //   jQuery(".modal-product-size").removeClass("active");
  //   jQuery(".modal-backdrop").remove();
  // });
  
  function closeModal() {
        jQuery(".modal-product-size").hide().removeClass("active");
        jQuery(".modal-backdrop").remove();
    }
});
/*
jQuery(document).ready(function () {
    jQuery(".size-guide-cta").click(function () {
        jQuery(".modal-product-size").show().addClass("active");
        jQuery(".modal-backdrop").remove();
        jQuery("body").append('<div class="modal-backdrop fade show"></div>');
    });

    jQuery(".modal-btn").click(function () {
        closeModal();
    });

    // Close modal when clicking outside modal-content (on .modal-product-size)
    jQuery(".modal-product-size").click(function (e) {
        if (!jQuery(e.target).closest(".modal-content").length) {
            closeModal();
        }
    });

    function closeModal() {
        jQuery(".modal-product-size").hide().removeClass("active");
        jQuery(".modal-backdrop").remove();
    }
});
*/
//  product upsell.

$(document).ready(function () {
  // Close the dropdown when clicking outside of it
  $(document).on("click", function (event) {
    var $target = $(event.target);
    if (!$target.closest(".variant-popdown-upsell").length) {
      $(".variant-popdown-list").hide();
      $(".variant-popdown-upsell-select").removeClass("d-open");
    }
  });

  // Close the dropdown when clicking on the select button
  $(document).on("click", ".variant-popdown-upsell-select", function (event) {
    $(".variant-popdown-list").hide();
    if ($(this).hasClass("d-open")) {
      $(".variant-popdown-list").hide();
      $(this).removeClass("d-open");
    } else {
      $(this).addClass("d-open");
      var currentSeclVal = $(this).attr("data-val");
      $(this)
        .parent()
        .find(".varianttitle-upsell-" + currentSeclVal)
        .show();
      $(this)
        .parent()
        .find(".varianttitle-upsell-" + currentSeclVal + "-cover")
        .show();
      event.stopPropagation();
    }
  });
});

$(document).on("click", ".selectUpsellProduct", function (e) {
  if ($(this).hasClass("active")) {
    $(this).removeClass("active");
    $("#product-cover-check-2").prop("checked", false);
    $(this).find(".btn").html("<span>ADD + </span>");
  } else {
    $(this).find(".btn").html('<span class="added">&#x2713;</span>');
    $("#product-cover-check-2").prop("checked", true);
    $(this).addClass("active");
  }
});

$(document).on("click", ".varianttitle-upsell-color li", function (e) {
  e.preventDefault();
  $(".varianttitle-upsell-color li").removeClass("select");
  $(this).addClass("select");

  var selectColorImg = $(this).data("img");
  var selectColorVal = $(this).data("value");
  $(".product-cover-1")
    .find(".variant-popdown-color")
    .find(".variant-popdown-upsell-select")
    .find(".vpopdown-img")
    .find("img")
    .attr("src", selectColorImg);
  $(".product-cover-1")
    .find(".variant-popdown-color")
    .find(".variant-popdown-upsell-select")
    .find(".varianttitle-color")
    .text(selectColorVal);

  $(".product-cover-2")
    .find(".variant-popdown-color")
    .find(".variant-popdown-upsell-select")
    .find(".vpopdown-img")
    .find("img")
    .attr("src", selectColorImg);
  $(".product-cover-2")
    .find(".variant-popdown-color")
    .find(".variant-popdown-upsell-select")
    .find(".varianttitle-color")
    .text(selectColorVal);
  $(".variant-popdown-list").hide();
  $(".variant-popdown-upsell-select").removeClass("d-open");

  var tempVal = selectColorVal.toLowerCase();
  var tempVal1 = tempVal.replace(/ /g, "");
  var tempVal2 = tempVal1.replace("/", "");
  $("#upsell_pcolor").val(tempVal2.toLowerCase());
  $("#upsell_pcolor_2").val(tempVal2.toLowerCase());

  var upsell_psize = $(
    'select[name="variant-popdown-upsell-select"] option:selected'
  )
    .val()
    .toLowerCase();
  var upsellPImage = $("#" + tempVal2 + upsell_psize).attr("data-img");
  $(".pc-metaproduct-thumb img").attr("src", upsellPImage);
  $(".pc--metaproduct-thumb img").attr("src", upsellPImage);
});

/* cover upsell code start */
$(document).on("click", ".variant__button__cover-label", function (e) {
  var coverPid = $(this).attr("data-cover-id");
  var coverTitle = $(this).attr("data-short-title");
  $(".variant__button__cover-label").removeClass("active");
  $(this).addClass("active");
  $(".pb-variant").hide();
  $("#pb_cover_" + coverPid).show();
  $("#pb_cover_" + coverPid + "_v4").show();
  $("#pb_cover_" + coverPid + "_v2").show();
  $("#coverUpsellId").val(coverPid);

  var upcover_pcolor = $("#upsell_pcolor_cover_" + coverPid)
    .val()
    .toLowerCase();
  var upcover_psize = $(
    'select[name="variant-popdown-upsell-select-cover-' +
      coverPid +
      '"] option:selected'
  )
    .val()
    .toLowerCase();
  var upCoverPrice = "";
  if (upcover_pcolor != "" && upcover_psize != "") {
    var upCoverPrice = $(
      "#" + upcover_pcolor + upcover_psize + "_" + coverPid
    ).attr("data-price");
  } else if (upcover_pcolor != "") {
    var upCoverPrice = $("#" + upcover_pcolor + "_" + coverPid).attr(
      "data-price"
    );
  } else if (upcover_psize != "") {
    var upCoverPrice = $("#" + upcover_psize + "_" + coverPid).attr(
      "data-price"
    );
  }
  $(".de-select").hide();
  $(".optional_text").hide();
  $(this).parent().find(".de-select").show();
  $(".variant__label-info").show();
  $(".add_cover_view").show();
  $(".add_glossy_price").html("(+" + upCoverPrice + ")");
  $(".glossy_text").html(coverTitle);
});

$(document).on("click", ".de-select", function (e) {
  $("#coverUpsellId").val("");
  $(".de-select").hide();
  $(".optional_text").show();
  $(".pb-variant").hide();
  $(".add_cover_view").hide();
  $(".variant__label-info").hide();
  $(".variant__button__cover-label").removeClass("active");
});

// Product Gallery Zoom on Click event
$(document).on("click", ".magnify-button-new", function (e) {
  $(".magnify-button").trigger("click");
});

$(document).on("click", ".varianttitle-upsell-color-cover li", function (e) {
  e.preventDefault();
  $(".varianttitle-upsell-color-cover li").removeClass("select");
  $(this).addClass("select");

  var selectColorImg = $(this).data("img");
  var selectColorVal = $(this).data("value");
  var selectPid = $(this).data("pid");
  $("#pb_cover_" + selectPid)
    .find(".variant-popdown-color")
    .find(".variant-popdown-upsell-select")
    .find(".vpopdown-img")
    .find("img")
    .attr("src", selectColorImg);
  $("#pb_cover_" + selectPid)
    .find(".variant-popdown-color")
    .find(".variant-popdown-upsell-select")
    .find(".varianttitle-color")
    .text(selectColorVal);

  $("#pb_cover_" + selectPid + "_v4")
    .find(".variant-popdown-color")
    .find(".variant-popdown-upsell-select")
    .find(".vpopdown-img")
    .find("img")
    .attr("src", selectColorImg);
  $("#pb_cover_" + selectPid + "_v4")
    .find(".variant-popdown-color")
    .find(".variant-popdown-upsell-select")
    .find(".varianttitle-color")
    .text(selectColorVal);

  $("#pb_cover_" + selectPid + "_v2")
    .find(".variant-popdown-color")
    .find(".variant-popdown-upsell-select")
    .find(".vpopdown-img")
    .find("img")
    .attr("src", selectColorImg);
  $("#pb_cover_" + selectPid + "_v2")
    .find(".variant-popdown-color")
    .find(".variant-popdown-upsell-select")
    .find(".varianttitle-color")
    .text(selectColorVal);

  $(".variant-popdown-list").hide();
  $(".variant-popdown-upsell-select").removeClass("d-open");

  var tempVal = selectColorVal.toLowerCase();
  var tempVal1 = tempVal.replace(/ /g, "");
  var tempVal2 = tempVal1.replace("/", "");
  $("#upsell_pcolor_cover_" + selectPid).val(tempVal2.toLowerCase());
});

/* cover upsell code end */

// $('.varianttitle-upsell-size li').on('click', function(e) {
//   e.preventDefault();
//   $(".varianttitle-upsell-size li").removeClass("select");
//   $(this).addClass('select');

//   var selectSizeVal = $(this).data('value');
//   $('.product-cover-1').find('.variant-popdown-size').find('.variant-popdown-upsell-select').find('.varianttitle-size').text(selectSizeVal);
//   $('.product-cover-2').find('.variant-popdown-size').find('.variant-popdown-upsell-select').find('.varianttitle-size').text(selectSizeVal);
//   $('.variant-popdown-list').hide();
//   $('.variant-popdown-upsell-select').removeClass('d-open');

//   var tempVal = selectSizeVal.toLowerCase();
//   var tempVal1 = tempVal.replace(/ /g,"");
//   var tempVal2 = tempVal1.replace("/","");
//   $('#upsell_psize').val(tempVal2.toLowerCase());
//   $('#upsell_psize_2').val(tempVal2.toLowerCase());
// });

// var interval = setInterval(function() {
//   var cookieKey = 'freeProductId' ;
//   var freeProductId = localStorage.getItem(cookieKey);

//   if (freeProductId != '' && freeProductId !== null) {
//     $('.free_prod_not_added').hide();
//     $('.free_prod_added').show();
//   }
// }, 100);

$("body.template-product").addClass("product_section_style_3");

$(".product_section_style_2 .product-slideshow .flickity-previous").html(
  '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"> <mask id="mask0_1_49" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24"> <rect width="24" height="24" transform="matrix(-1 0 0 1 24 0)" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_1_49)"> <path d="M9.99403 18.1913L11.5853 16.5619L8.16088 13.1375H20.2033V10.8625H8.16088L11.5853 7.43805L9.99403 5.8087L3.79673 12L9.99403 18.1913Z" fill="#1C1B1F"/> </g> </svg>'
);
$(".product_section_style_2 .product-slideshow .flickity-next").html(
  '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"> <mask id="mask0_1_58" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24"> <rect width="24" height="24" fill="#D9D9D9"/> </mask> <g mask="url(#mask0_1_58)"> <path d="M14.006 18.1913L12.4147 16.5619L15.8391 13.1375H3.79672V10.8625H15.8391L12.4147 7.43805L14.006 5.8087L20.2033 12L14.006 18.1913Z" fill="#1C1B1F"/> </g> </svg>'
);

// productinfotab
$(document).ready(function () {
  $("ul.productinfotab li").click(function () {
    var tab_id = $(this).attr("data-tab");

    $("ul.productinfotab li").removeClass("current");
    $(".productinfotab-content").removeClass("current");

    $(this).addClass("current");
    $("#" + tab_id).addClass("current");
  });

  // $('.mobile-nav__has-sublist').click(function(){
  //   var subMenuId = $(this).attr('data-subid');
  //   $(this).find('.collapsible-trigger').addClass('is-open');
  //   $('#'+subMenuId).addClass('is-open');
  // });
  if(jQuery(window).width()>767){
    if(jQuery('.product_gallery .product-slideshow').find('.product-main-video-slide').find('video').length>0 && jQuery('body').hasClass('product_gallery_column')){
      jQuery('.product_gallery .product-slideshow').find('.product-main-video-slide').find('.product__video-wrapper').removeClass('product__video-wrapper');
    }
    galleryTwoColumnAutoplay();
  }
});

function galleryTwoColumnAutoplay(){
  if(jQuery('.product_gallery .product-slideshow').find('.product-main-video-slide').find('video').length>0 && jQuery('body').hasClass('product_gallery_column')){
    //console.log("video found");
    setTimeout(function(){
      var VidoObj = jQuery('.product_gallery .product-slideshow').find('.product-main-video-slide').find('video');
      //console.log("VidoObj[0]",VidoObj[0]);
      VidoObj.show();
      VidoObj.attr('autoplay', 'autoplay');
      VidoObj.prop('muted', true);
      VidoObj[0].load();
      VidoObj[0].play();
    },500);
  }
}

$(window).bind('load', function() {
  $('#NavDrawer').find('.mobile-nav__has-sublist').each(function(){
    $(this).find('.collapsible-trigger').removeClass('is-open');
    $(this).next('div').removeClass('is-open');
    $(this).next('div').removeAttr('style');
  })
});

//video slider enbled
jQuery(window).bind('load',function(){
  setInterval(function(){
    if(jQuery('.page-content--product').hasClass('video-slider-enabled')){
      jQuery('.product__thumbs').eq(0).hide();
      jQuery('.product-slideshow').eq(0).hide();
      jQuery('.product__thumbs--scroller').eq(0).hide();
      jQuery('.product__thumbs-video').show();
      jQuery('.product-slideshow-video').show();
      jQuery('.product__thumbs--scroller-video').show();
      mainThumb.resize();
    }
  },100);
});
$(document).on("click",".product__thumbs-video .product__thumb-item.product__video-item",function(e){
    e.preventDefault();
    var getIndex = jQuery(this).data('index');
    setTimeout(function(){
      var VidoObj = jQuery('.product-slideshow-video .product-main-video-slide.is-selected').find('video');
      VidoObj.attr('autoplay', 'autoplay');
      VidoObj.prop('muted', true);
      VidoObj[0].load();  // Reload video to apply autoplay
      VidoObj[0].play();  //
    },1000);
    slideshowThumb.select(getIndex);
});
 slideshowThumb.on('dragMove.flickity', function(event, pointer, moveVector) {
    console.log("Dragging", moveVector);

    var index = flkty.selectedIndex;
    var $cell = $(flkty.selectedElement);
    console.log("getIndex", index);

    var $video = $cell.find('video');
    if ($video.length) {
        $video.attr('autoplay', 'autoplay');
        $video.prop('muted', true);
        $video[0].load();  // Reload video to apply autoplay
        $video[0].play();
    }

    slideshowThumb.select(index);
});
/*$(document).on("click",".flickity-page-dots li",function(){
  var labelText = jQuery(this).attr('aria-label').replace(/[^0-9]/gi, '');
  var getIndex = (labelText-1);
  console.log("getIndex",getIndex);
  setTimeout(function(){
    var VidoObj = jQuery('.product-main-video-slide.is-selected').find('video');
    if(VidoObj!=undefined){
      VidoObj.attr('autoplay', 'autoplay');
      VidoObj.prop('muted', true);
      VidoObj[0].load();  // Reload video to apply autoplay
      VidoObj[0].play();  //
    }
  },1000);
  slideshowThumb.select(getIndex);
});*/
$(document).on("click",".flickity-page-dots li",function(){
  var labelText = jQuery(this).attr('aria-label').replace(/[^0-9]/gi, '');
  var getIndex = (labelText-1);
  console.log("getIndex",getIndex);
  setTimeout(function(){
    var VidoObj = jQuery('.product-main-video-slide.is-selected').find('video');
    VidoObj.attr('autoplay', 'autoplay');
    VidoObj.prop('muted', true);
    if(VidoObj!=undefined){
      VidoObj[0].load();  // Reload video to apply autoplay
      VidoObj[0].play();  //
    }
  },1000);
  slideshowThumb.select(getIndex);
});


// collection filter [snippets/collection-grid-filters-form.liquid] :: START
jQuery(document).ready(function(){
  jQuery(document).on("click",".cfilter-tab .cfilter-tab-button",function(){
      var tab_id = jQuery(this).attr('data-index');
      jQuery('.cfilter-tab-button').removeClass('active');
      jQuery('.cfilter-tab-content').removeClass('active');
      jQuery(this).addClass('active');
      jQuery("."+tab_id).addClass('active');
  });

  jQuery(document).on("click",".show_all__li",function(){
    jQuery('.li-viewless').show();
    jQuery('.li-viewall').hide();
    jQuery(".filter__color_li").removeClass('hide-vl');
    jQuery('.hide_all__li').show();
    jQuery(this).hide();
  });

  jQuery(document).on("click",".hide_all__li",function(){
    jQuery('.li-viewless').hide();
    jQuery('.li-viewall').show();
    jQuery('.show_all__li').show();
    jQuery(".show-vl").addClass('hide-vl');
    jQuery(this).hide();
  });
})
// collection filter [snippets/collection-grid-filters-form.liquid] :: END

// panels [tab-new.liquid || tab-video.liquid] :: START
jQuery(document).ready(function() {
  // accordian
  jQuery(".tab-collapse .tab-heading").on("click", function() {
    if (jQuery(this).hasClass("active")) {
      jQuery(this).removeClass("active");
      jQuery(this)
        .siblings(".tab-content")
        .slideUp(200);
      jQuery(".tab-collapse .tab-heading i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
    } else {
     jQuery(".tab-collapse .tab-heading i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
      jQuery(this)
        .find("i")
        .removeClass("fa-plus")
        .addClass("fa-minus");
      jQuery(".tab-collapse .tab-heading").removeClass("active");
      jQuery(this).addClass("active");
      jQuery(".tab-content").slideUp(200);
      jQuery(this)
        .siblings(".tab-content")
        .slideDown(200);
    }
  });
  // Show the popup when the play button is clicked
  jQuery(document).on("click",".video-play-button",function(){  
    jQuery('body').addClass('tabv-popup-body');
    //setTimeout(function(){
      jQuery('.tabv-popup').css('display', 'flex');
      jQuery('body').addClass('tabv-popup-scroll');
      $('.tabv-popup video')[0].play();
    //},500);
  });
  // Hide the popup when the close button is clicked
  jQuery(document).on("click",".tabv-popup-close",function(){    
    jQuery('.tabv-popup').css('display', 'none');
    jQuery('body').removeClass('tabv-popup-body');
    jQuery('body').removeClass('tabv-popup-scroll');
    $('.tabv-popup video')[0].pause();
  });
});
// panels [tab-new.liquid || tab-video.liquid] :: END
// collapsible panels [collapsible-panels.liquid] :: START
jQuery(document).ready(function() {
  jQuery(".collapsible__panel > .collapsible__heading").on("click", function() {
    if (jQuery(this).hasClass("active")) {
      jQuery(this).removeClass("active");
      jQuery(this)
        .siblings(".collapsible__content")
        .slideUp(200);
      jQuery(".collapsible__panel > .collapsible__heading i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
    } else {
      jQuery(".collapsible__panel > .collapsible__heading i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
      jQuery(this)
        .find("i")
        .removeClass("fa-plus")
        .addClass("fa-minus");
      jQuery(".collapsible__panel > .collapsible__heading").removeClass("active");
      jQuery(this).addClass("active");
      jQuery(".collapsible__content").slideUp(200);
      jQuery(this)
        .siblings(".collapsible__content")
        .slideDown(200);
    }
  });
});
// collapsible panels [collapsible-panels.liquid] :: END

//load more scroll down mouse disabled after all products show 
jQuery(document).ready(function(){
  if(jQuery('.template-collection').length>0){
    jQuery(window).on('scroll',function(){
      if(jQuery('.products_count').length>0){
        if(jQuery('#AjaxinatePagination a').attr('href')!=undefined){
          var pagecollectArr = jQuery('#AjaxinatePagination a').attr('href').split('?');
          if(pagecollectArr[1]!=undefined){
            var pageGet = pagecollectArr[1].replace('page=','');
            var pageCount = jQuery('.products_count').attr('data-page');
            console.log("pageGet",pageGet,pageCount);
            if(parseInt(pageGet)>parseInt(pageCount)){
              jQuery('#AjaxinatePagination').hide();
              jQuery('.new_collections').addClass('load-complete');
            }
          }
        }
      }
    });
  }
});

/* START -- PRODUCT RECOMMENDATION */

$(document).ready(function(){
  $('ul.pr_tabs_titles li').click(function(){
    var tab_id = $(this).attr('data-tab');

    $('ul.pr_tabs_titles li').removeClass('current');
    $('.pr_tab_content').removeClass('current');

    $(this).addClass('current');
    $("#"+tab_id).addClass('current');

    $('.pro-collection-gallery').slick('refresh');
  });

  var sliderInterval = setInterval(function(){
    if($('.product_recommndation_new').hasClass('product_recommndation_v1')){
      $('.pro-collection-gallery').slick('refresh');
      clearInterval(sliderInterval);
    }
  }, 1000);
})


/* END -- PRODUCT RECOMMENDATION */


/* START - Collection Page Extra Section Load Slider */
var collectionInterval = setInterval(function(){
  if(jQuery('.new_collections').hasClass('load-complete')){
    jQuery('.new_collections.load-complete').find('.pro-collection-gallery').slick('refresh');
    clearInterval(collectionInterval);
  }
},1000);


/* START -- COVER VARIANT PICKER */

const selectedEl = document.querySelector('.select-selected');
if (selectedEl) {
  selectedEl.addEventListener('click', function () {
    this.parentElement.classList.toggle('open');
  });
}


document.querySelectorAll('.select-items li').forEach(function(item) {
    item.addEventListener('click', function() {
        const selected = this.textContent;
        document.querySelector('.select-selected').textContent = selected;
        this.closest('.custom-select').classList.remove('open');
    });
});

// Close dropdown if clicked outside
document.addEventListener('click', function(event) {
    const customSelect = document.querySelector('.custom-select');
    if (customSelect && !customSelect.contains(event.target)) {
        customSelect.classList.remove('open');
    }
});

/* END -- COVER VARIANT PICKER */

document.addEventListener("DOMContentLoaded", function() {
    var elements = document.querySelectorAll(".custom-shipping-price");

    if (elements.length === 0) {
      console.warn(".custom-shipping-price not found in DOM.");
      return;
    }

    elements.forEach(function(el) {
      var rawPrice = parseFloat(el.dataset.price);
      console.log("rawPrice -->", rawPrice);

      if (Shopify && Shopify.currency && Shopify.currency.rate) {
        var rate = parseFloat(Shopify.currency.rate);
        console.log("rate -->", rate);

        var converted = (rawPrice * rate).toFixed(2);
        console.log("converted -->", converted);

        el.textContent = Shopify.formatMoney(converted * 100, Shopify.currency.active_format);
      }
    });
  });

// bogo price snippet
document.addEventListener("DOMContentLoaded", function() {
    var elements = document.querySelectorAll(".bogoprice");

    if (elements.length === 0) {
      console.warn(".bogoprice not found in DOM.");
      return;
    }

    elements.forEach(function(el) {
      var rawPrice = parseFloat(el.dataset.price);
      console.log("rawPrice -->", rawPrice);

      if (Shopify && Shopify.currency && Shopify.currency.rate) {
        var rate = parseFloat(Shopify.currency.rate);
        console.log("rate -->", rate);

        var converted = (rawPrice * rate).toFixed(2);
        console.log("converted -->", converted);

        el.textContent = Shopify.formatMoney(converted * 100, Shopify.currency.active_format);
      }
    });
  });

// home page
document.addEventListener("DOMContentLoaded", function() {
    var elements = document.querySelectorAll(".bfcmmoney");

    if (elements.length === 0) {
      console.warn(".bfcmmoney not found in DOM.");
      return;
    }

    elements.forEach(function(el) {
      var rawPrice = parseFloat(el.dataset.price);
      console.log("rawPrice -->", rawPrice);

      if (Shopify && Shopify.currency && Shopify.currency.rate) {
        var rate = parseFloat(Shopify.currency.rate);
        console.log("rate -->", rate);

        var converted = (rawPrice * rate).toFixed(2);
        console.log("converted -->", converted);

        el.textContent = Shopify.formatMoney(converted * 100, Shopify.currency.active_format);
      }
    });
  });


/****************************** COLLECTION PAGE FOR GRID LAYOUT JS START ********************************/
jQuery(document).ready(function(){
  if(jQuery('.collection-grid__wrapper .layout-button.active').length>0){
    var getLayout = jQuery('.collection-grid__wrapper .layout-button.active').attr('data-layout');
    if(jQuery('#CollectionAjaxContent').find('#AjaxinateContainer').length>0){
      jQuery('#CollectionAjaxContent').find('#AjaxinateContainer').addClass('layout-grid-'+getLayout);
    }
  }
});
jQuery(document).on('click','.collection-grid__wrapper .layout-button',function(){
  var getLayout = jQuery(this).attr('data-layout');
  jQuery('.collection-grid__wrapper .layout-button').removeClass('active');
  jQuery(this).addClass('active');
  if(jQuery('#CollectionAjaxContent').find('#AjaxinateContainer').length>0){
    jQuery('#CollectionAjaxContent').find('#AjaxinateContainer').removeAttr('class');
    jQuery('#CollectionAjaxContent').find('#AjaxinateContainer').addClass('layout-grid-'+getLayout);
    slickRefreshSlider();
  }
});

function slickRefreshSlider(){
  var $slider = $('.pro-collection-gallery')
  $slider.css('visibility', 'hidden');
  if ($slider.hasClass('slick-initialized')) {
    $slider.slick('unslick');
  }
  $slider.slick({
    dots:true
  });
  $slider.css('visibility', 'visible');
}
/****************************** COLLECTION PAGE FOR GRID LAYOUT JS END **********************************/

/****************************** PDP PAGE LIMITED GALLERT PAGE JS START *********************************/
//jQuery('body').addClass('limited-edition-active');
//if(jQuery('body').hasClass('limited-edition-active')){
  jQuery(document).ready(function(){
    //Color wise variant image show start if condition only that
    setTimeout(function(){
      if(!jQuery('body').hasClass('color-variant-wise-gallery')){
        limitedEditionGalleryChange(1);
      }
    },400);

    var colorInterId = setInterval(function(){
      if(jQuery('body').hasClass('color-variant-wise-gallery')){
        console.log("color variant wise");
        if(jQuery('.page-content--product').find(".variant__input--color-swatch").length>0){
          var selectedColorGet = jQuery('.page-content--product').find(".variant__input--color-swatch:checked").attr('data-color-name');
          colorWiseGallery(selectedColorGet,1);
          clearInterval(colorInterId);
        }
      }
    },200);
  });
  jQuery(document).off('change', '.page-content--product [name="Version"]')
    .on('change', '.page-content--product [name="Version"]', function(e) {
      if(!jQuery('body').hasClass('color-variant-wise-gallery')){
        if(jQuery('.page-content--product').find('.version-variant').find('.variant__label-info').length>0){
          var getVersion = jQuery('.page-content--product').find('[name="Version"]:checked').val();
          jQuery('.page-content--product').find('.version-variant').find('.variant__label-info span').text(getVersion);
          if(getVersion!="" && getVersion!=undefined){
            getVersion = getVersion.toLowerCase();
            if(getVersion=='limited edition'){
              if(jQuery('.product_gallery').find('[data-product-photos]').is(":visible")){
                jQuery('.product_gallery').find('.product-slideshow').hide();
                jQuery('.product_gallery').find('.product-slideshow-limited').show();
                
              }
            }else{
              if(jQuery('.product_gallery').find('[data-product-photos]').is(":visible")){
                jQuery('.product_gallery').find('.product-slideshow').show();
                jQuery('.product_gallery').find('.product-slideshow-limited').hide();
              }
            }
          }
        }
        limitedEditionGalleryChange();
      }else{
        //Color wise variant image show start
        if(jQuery('body').hasClass('color-variant-wise-gallery')){
          if(jQuery('.page-content--product').find(".variant__input--color-swatch").length>0){
            var selectedColorGet = jQuery('.page-content--product').find(".variant__input--color-swatch:checked").attr('data-color-name');
            colorWiseGallery(selectedColorGet);
          }
        }
        //Color wise variant image show end
      }
      bundleProductInfoset();
  });

  jQuery(document).off('change', '.page-content--product [name="Color"]')
    .on('change', '.page-content--product [name="Color"]', function(e) {
      if(!jQuery('body').hasClass('color-variant-wise-gallery')){
        limitedEditionGalleryChange();
      }
  });
//}
function limitedEditionGalleryChange(flag=""){
  if(jQuery('.flickity-enabled').find('.flickity-page-dots').length>0){
    jQuery('.flickity-enabled').find('.flickity-page-dots').hide();
  }
   var activeStyles = {
      "opacity": "1",
      "visibility": "visible",
      "pointer-events": "auto",
      "height":"auto",
      "position":"unset"
    };

    var hiddenStyles = {
      "opacity": "0",
      "visibility": "hidden",
      "pointer-events": "none",
      "position":"absolute"
    };
    if(jQuery('body').hasClass('limited-edition-active')){
      if(jQuery('.page-content--product').find('[name="Version"]').length>0){
        var getVersion = jQuery('.page-content--product').find('[name="Version"]:checked').val();
        if(jQuery('.page-content--product').find('[name="Color"]').length>0){
          var getColorImg = jQuery('.page-content--product').find('input[type="radio"][name="Color"]:checked').attr('limited-edition-img');
        }
        
        getVersion = stringToHandle(getVersion);
        //console.log("getColorImg",getColorImg,mainLimited);
        if(getVersion=="limited-edition" && getColorImg!=undefined){
          if(jQuery('.product__photos').find('.product__thumbs-limited--scroller').length>0){
            jQuery('.product__photos').find('.product__thumbs-limited--scroller').css(activeStyles);
            jQuery('.product__photos').find('.product__limited_thumbs').css(activeStyles);
            jQuery('.product__photos').find('.limited-edition-gallery').css(activeStyles);
            jQuery('.product__photos').find('[data-product-photos]').css(hiddenStyles);
            jQuery('.product__photos').find('.product__thumbs--scroller').css(hiddenStyles);
            jQuery('.product__photos').find('.product__thumbs').css(hiddenStyles);
          }
          //console.log("imgggg",getColorImg);
          if(jQuery('.product__photos').find('.limited-edition-gallery').find('.product-main-slide [data-main-image="'+getColorImg+'"]').length>0){
            var getIndexThumb = jQuery('.product__photos').find('.limited-edition-gallery').find('.product-main-slide [data-main-image="'+getColorImg+'"]').attr('data-index');
            if(getIndexThumb>0){
              getIndexThumb=(getIndexThumb-1);
            }
            //console.log("getIndexThumb",getIndexThumb);
            if(getIndexThumb!=undefined){
              if(mainLimited!=undefined){
                jQuery('.product_gallery').find('.product-slideshow.product-slideshow-limited').show();
                if(jQuery('.product_gallery').find('.product-slideshow:not(.product-slideshow-limited)').length>0){
                  jQuery('.product_gallery').find('.product-slideshow:not(.product-slideshow-limited)').hide();
                }
              }
              //setTimeout(function(){
                //setTimeout(function(){
                  if (mainLimited.slideshow.el!=null) {
                    mainLimited.goToSlide(getIndexThumb);
                    mainLimited.reloadCells();
                    mainLimited.resize();
                    //mainLimited.reposition();
                  }else{
                    this.flickitylimited = new theme.Slideshow(
                      '.limited-edition-gallery',
                      mainSliderArgs2
                    );
                    mainLimited = this.flickitylimited;
                    mainLimited.goToSlide(getIndexThumb);
                    mainLimited.reloadCells();
                    mainLimited.resize();
                  }
                //},300);
              //},500);
            }
          }
          setTimeout(function () {
            if(jQuery('.flickity-enabled').find('.flickity-page-dots').length>0){
              jQuery('.flickity-enabled').find('.flickity-page-dots').show();
            }
          }, 500);
        }else if(getVersion!=undefined && getVersion!=""){
          if(jQuery('.product__photos').find('.product__thumbs-limited--scroller').length>0){
            jQuery('.product__photos').find('.product__thumbs-limited--scroller').css(hiddenStyles);
            jQuery('.product__photos').find('.product__limited_thumbs').css(hiddenStyles);
            jQuery('.product__photos').find('.limited-edition-gallery').css(hiddenStyles);

            jQuery('.product__photos').find('[data-product-photos]').css(activeStyles);
            jQuery('.product__photos').find('.product__thumbs--scroller').css(activeStyles);
            jQuery('.product__photos').find('.product__thumbs').css(activeStyles);
            jQuery('.product__photos').find('.product__thumbs-video').css(activeStyles);

            // 🔥 Ensure main slider is re-initialized
            //if (typeof window.product !== "undefined" && typeof window.product.initProductSlider === "function") {
            setTimeout(function () {
              if (mainSliderInit && typeof mainSliderInit.reloadCells === "function") {

                // force browser to calculate correct width first
                var sliderEl = jQuery('.product__photos').find('[data-product-photos]')[0];
                if (sliderEl) sliderEl.offsetWidth;  // triggers reflow safely


                // always call with capital C
                mainSliderInit.reloadCells();
                mainSliderInit.resize();
                var indexToShow = 0;
                if(flag==""){
                  indexToShow = jQuery('.product__photos').find('[data-product-thumbs]').find('.product__thumb.is-active').parent().parent('div').attr('data-index');
                  console.log("indexToShow",indexToShow);
                }
                if (typeof mainSliderInit.goToSlide === "function") {
                  // theme.Slideshow wrapper
                  mainSliderInit.goToSlide(indexToShow, true);
                } else if (typeof mainSliderInit.select === "function") {
                  // plain Flickity
                  mainSliderInit.select(indexToShow, false, true);
                }
              }
              if(jQuery('.flickity-enabled').find('.flickity-page-dots').length>0){
                jQuery('.flickity-enabled').find('.flickity-page-dots').show();
              }
            }, 200);


            //}
          }
        }
      }
    }else{
      if(jQuery('.product__photos').find('.product__thumbs-limited--scroller').length>0){
        jQuery('.product__photos').find('.product__thumbs-limited--scroller').css(hiddenStyles);
        jQuery('.product__photos').find('.product__limited_thumbs').css(hiddenStyles);
        jQuery('.product__photos').find('.limited-edition-gallery').css(hiddenStyles);

        jQuery('.product__photos').find('[data-product-photos]').css(activeStyles);
        jQuery('.product__photos').find('.product__thumbs--scroller').css(activeStyles);
        jQuery('.product__photos').find('.product__thumbs').css(activeStyles);
        jQuery('.product__photos').find('.product__thumbs-video').css(activeStyles);

        console.log("slider load");
        // 🔥 Ensure main slider is re-initialized
        //if (typeof window.product !== "undefined" && typeof window.product.initProductSlider === "function") {
          setTimeout(function(){
            if (mainSliderInit && typeof mainSliderInit.resize === "function") {
              mainSliderInit.resize();
              mainSliderInit.reposition();
            }
            if(jQuery('.flickity-enabled').find('.flickity-page-dots').length>0){
              jQuery('.flickity-enabled').find('.flickity-page-dots').show();
            }
          },300);
        //}
      }
    }
    var secondDots = 700;
    if(flag==""){
      secondDots = 200;
    }
    setTimeout(function(){
      if(jQuery('.flickity-enabled').find('.flickity-page-dots').length>0){
        jQuery('.flickity-enabled').find('.flickity-page-dots').show();
      }
    },secondDots);
}
/****************************** PDP PAGE LIMITED GALLERT PAGE JS END *********************************/


document.addEventListener("DOMContentLoaded", function() {
  // Only run if body does NOT have 'limited-edition-active'
  const intervalId = setInterval(function() {
    if (document.body.classList.contains("limited-edition-active")) {
      const classicRadio = document.querySelector('input[name="Version"][value="Limited Edition"]');
      if (classicRadio) {
        classicRadio.checked = true;
        classicRadio.dispatchEvent(new Event("change")); // trigger change if needed
        clearInterval(intervalId);
      }
    }
  }, 50);
});

function stringToHandle(str) {
  return str
    .toLowerCase()                  // convert to lowercase
    .trim()                         // remove leading/trailing spaces
    .replace(/[^a-z0-9\s-]/g, '')  // remove invalid characters
    .replace(/\s+/g, '-')           // replace spaces with hyphens
    .replace(/-+/g, '-');           // replace multiple hyphens with single
}


//Breast Cancer Announcement For Rose Gold Color show js start
jQuery(document).ready(function() {
  function updateRoseGoldIcon(variantTitle) {
      const isRoseGold = variantTitle?.includes('Rose Gold');

      document.querySelectorAll('.rose_gold_icon').forEach(icon => {
          icon.style.display = isRoseGold ? 'block' : 'none';
          icon.classList.toggle('active', isRoseGold);
      });
  }

  // Function to get the currently selected color/variant title
  function getSelectedVariantTitle() {
      let selectedColor = '';
      const $colorInput = jQuery('.page-content--product').find('[name="Color"]:checked');

      if ($colorInput.length > 0) {
          selectedColor = $colorInput.val();
      }
      return selectedColor;
  }

  // Only run if body has the class
  var checkImgId = setInterval(function(){
    if (jQuery('body').hasClass('rose_gold_active')) {
      const initialColor = getSelectedVariantTitle();
      console.log("Selected color on load:", initialColor);
      updateRoseGoldIcon(initialColor);
      document.addEventListener('variant:change', function(event) {
          const variantTitle = event.detail?.variant?.title;
          if (!variantTitle) return;

          updateRoseGoldIcon(variantTitle);
      });
      clearInterval(checkImgId);
    }
    if(jQuery('.flickity-enabled').find('.flickity-page-dots').length>0){
      jQuery('.flickity-enabled').find('.flickity-page-dots').show();
    }
  },500);
   setTimeout(() => {
      clearInterval(checkImgId);
  }, 15000);
});
//Breast Cancer Announcement For Rose Gold Color show js end

//Collection Page hide show filter sticky start
jQuery(document).ready(function($){
  if(jQuery('body').hasClass('template-collection')){
    $(window).on('scroll', function() {
        var footerTop = $('.site-footer').offset().top;
        var scrollBottom = $(window).scrollTop() + $(window).height();

        if(scrollBottom >= footerTop) {
            $('.collection-filter').fadeOut(); // hide when footer appears
        } else {
            $('.collection-filter').fadeIn(); // show when not at footer
        }
    });
  }
});

//PDP PAGE COLOR WISE VARIANT GALLERY SHOW JS START
function colorWiseGallery(color,flag=''){
  if(color!=undefined && color!=""){
    var colorHandle = stringToHandle(color);
    if (
      jQuery('.product__main-photos').find('.product-slideshow.color-variant-wise').length > 0 &&
      jQuery('.product__main-photos')
        .find('.product-slideshow.color-variant-wise')
        .find('.product-main-slide[data-color="' + colorHandle + '"]').length > 0
    ) {

      if (jQuery('.product__main-photos').find('.product-slideshow[data-product-photos]').length > 0) {
        jQuery('.product__main-photos').find('.product-slideshow[data-product-photos]').hide();
        jQuery('.product__main-photos').find('.limited-edition-gallery').hide();
        jQuery('.product__main-photos').find('.product-slideshow.color-variant-wise').show();
      }

      // =========================
      // MAIN SLIDER COLOR WISE
      // =========================

      var objSlider = jQuery('.product__main-photos').find('.product-slideshow.color-variant-wise');
      var $slides = objSlider.find('.product-main-slide');

      $slides.hide().addClass('ignore-slide');

      if (objSlider.find('.product-main-slide[data-color="' + colorHandle + '"]').length > 0) {
        $slides.each(function () {
          if (jQuery(this).attr('data-color') == colorHandle) {
            jQuery(this).show().removeClass('ignore-slide');
          }
        });
      }

      // Destroy old sliders safely
      if (typeof mainSliderInitColor !== 'undefined' && mainSliderInitColor.destroy) {
        mainSliderInitColor.destroy();
      }

      if (typeof navSliderinitColor !== 'undefined' && navSliderinitColor.destroy) {
        navSliderinitColor.destroy();
      }

      // Remove Flickity leftovers (MAIN)
      objSlider.find('.flickity-viewport, .flickity-slider, .flickity-page-dots, .flickity-button').remove();

      // =========================
      // THUMB NAV SLIDER
      // =========================

      if (jQuery('.product__photos').find('.product__color_thumbs').is(":visible")) {

        var navObjSlider = jQuery('.product__photos').find('.product__thumbs.product__color_thumbs');
        var $navSlides = navObjSlider.find('.product__thumb-item');

        $navSlides.hide().addClass('ignore-slide');

        if (navObjSlider.find('.product__thumb-item[data-color="' + colorHandle + '"]').length > 0) {
          $navSlides.each(function () {
            if (jQuery(this).attr('data-color') == colorHandle) {
              jQuery(this).show().removeClass('ignore-slide');
            }
          });
        }

        // Remove Flickity leftovers (NAV)
        navObjSlider.find('.flickity-viewport, .flickity-slider, .flickity-page-dots, .flickity-button').remove();

        // INIT NAV FIRST
        navSliderinitColor = new theme.Slideshow(navSliderCacheColor, navArgsColor);

        const navFlkty = navSliderinitColor && navSliderinitColor.slideshow;
        if (!navFlkty) return;

        navFlkty.on("settle", function (index) {
          const navSliderObj = document.querySelector(
            ".color-variant-wise-gallery .product__color_thumbs"
          );
          if (!navSliderObj) return;

          // only visible thumbs
          const visibleThumbs = navSliderObj.querySelectorAll(
            ".product__thumb-item:not(.ignore-slide)"
          );
          // set active by current visible index
          const activeThumb = visibleThumbs[index];
          if (activeThumb) activeThumb.classList.remove("is-selected");
          if(jQuery('.color-variant-wise.color-gallery').is(':visible')){
            if(jQuery('.color-variant-wise.color-gallery').find('.product-main-slide.is-selected').length>0){
              var mainIndex = jQuery('.color-variant-wise.color-gallery').find('.product-main-slide.is-selected').attr('data-index');
              const activeMainThumb = visibleThumbs[mainIndex];
            if (activeMainThumb) activeMainThumb.classList.add("is-selected");
            }
          }
        });
      }

      // =========================
      // RE-ATTACH NAV TO MAIN
      // =========================

      mainSliderArgsColor.childNav = navSliderCacheColor;
      mainSliderArgsColor.childNavScroller = navSliderCacheColor;

      // INIT MAIN AFTER NAV
      mainSliderInitColor = new theme.Slideshow(mainSliderCacheColor, mainSliderArgsColor);
      
      // Adjust height
      var $visibleSlides = objSlider.find('.product-main-slide:not(.ignore-slide)');
      if ($visibleSlides.length > 0) {
        var getHeightSlider = $visibleSlides.first().outerHeight();
        objSlider.css('height', getHeightSlider);
      }
    }else if(jQuery('body').hasClass('limited-edition-active') && jQuery('.page-content--product').find('[name="Version"]').length>0){
      var getVersion = jQuery('.page-content--product').find('[name="Version"]:checked').val();
      if(jQuery('.page-content--product').find('[name="Color"]').length>0){
        var getColorImg = jQuery('.page-content--product').find('input[type="radio"][name="Color"]:checked').attr('limited-edition-img');
      }
      getVersion = stringToHandle(getVersion);
      console.log("getColorImg",getColorImg,getVersion);
      if(getVersion=="limited-edition" && getColorImg!=undefined){
        if(jQuery('.product__photos').find('.product__thumbs-limited--scroller').length>0){
          jQuery('.product__photos').find('.product__thumbs-limited--scroller').show();
          jQuery('.product__photos').find('.product__limited_thumbs').show();
          jQuery('.product__photos').find('.limited-edition-gallery').show();
          jQuery('.product__photos').find('.product-slideshow.color-variant-wise').hide();
          jQuery('.product__photos').find('.product__color-limited--scroller').hide();
          jQuery('.product__photos').find('.product__color_thumbs').hide();
          jQuery('.product__photos').find('.product-slideshow[data-product-photos]').hide();

        }
        //console.log("imgggg",getColorImg);
        if(jQuery('.product__photos').find('.limited-edition-gallery').find('.product-main-slide [data-main-image="'+getColorImg+'"]').length>0){
          var getIndexThumb = jQuery('.product__photos').find('.limited-edition-gallery').find('.product-main-slide [data-main-image="'+getColorImg+'"]').attr('data-index');
          if(getIndexThumb>0){
            getIndexThumb=(getIndexThumb-1);
          }
          //console.log("getIndexThumb",getIndexThumb);
          if(getIndexThumb!=undefined){
            if(mainLimited!=undefined){
              jQuery('.product_gallery').find('.product-slideshow.product-slideshow-limited').show();
              if(jQuery('.product_gallery').find('.product-slideshow:not(.product-slideshow-limited)').length>0){
                jQuery('.product_gallery').find('.product-slideshow:not(.product-slideshow-limited)').hide();
              }
            }
            //setTimeout(function(){
              //setTimeout(function(){
                if (mainLimited && typeof mainLimited.resize === "function") {
                  mainLimited.goToSlide(getIndexThumb);
                  mainLimited.reloadCells();
                  mainLimited.resize();
                  //mainLimited.reposition();
                }
              //},300);
            //},500);
          }
        }
        setTimeout(function () {
          if(jQuery('.flickity-enabled').find('.flickity-page-dots').length>0){
            jQuery('.flickity-enabled').find('.flickity-page-dots').show();
          }
        }, 500);
      }else{
        console.log("elsee classic");
        var getSlider = 0;
        if(jQuery('.product__main-photos').find('.product-slideshow[data-product-photos]').length>0){
          if(jQuery('.product__main-photos').find('.product-slideshow.color-variant-wise').length > 0) {
            jQuery('.product__main-photos').find('.product-slideshow.color-variant-wise').hide();
            jQuery('.product__main-photos').find('.product-slideshow.limited-edition-gallery').hide();
            jQuery('.product__main-photos').find('.product-slideshow[data-product-photos]').show();
            getSlider = 1;
          }
          mainSliderInit.reloadCells();
          mainSliderInit.resize();
          if(getSlider == 1){
            var getHeightSlider = jQuery('.product__main-photos').find('.product-slideshow[data-product-photos]').outerHeight();
            jQuery('.product__main-photos').find('.product-slideshow[data-product-photos]').css('height',getHeightSlider);
          }
        }
      }
    }else{
      console.log("defualt else");
      var getSlider = 0;
      if(jQuery('.product__main-photos').find('.product-slideshow[data-product-photos]').length>0){
        if(jQuery('.product__main-photos').find('.product-slideshow.color-variant-wise').length > 0) {
          jQuery('.product__main-photos').find('.product-slideshow.color-variant-wise').hide();
          jQuery('.product__main-photos').find('.product-slideshow.limited-edition-gallery').hide();
          jQuery('.product__main-photos').find('.product-slideshow[data-product-photos]').show();
          getSlider = 1;
        }
        mainSliderInit.reloadCells();
        mainSliderInit.resize();
        if(getSlider == 1){
          var getHeightSlider = jQuery('.product__main-photos').find('.product-slideshow[data-product-photos]').outerHeight();
          jQuery('.product__main-photos').find('.product-slideshow[data-product-photos]').css('height',getHeightSlider);
        }
      }
    }
  }
}

function galleryColorVideoAutoplay() {
  var $slider = jQuery('.product-slideshow.color-variant-wise');
  if (!$slider.length) return;

  var $activeSlide = $slider.find('.is-selected');
  if (!$activeSlide.length) return;

  var video = $activeSlide.find('video').get(0);
  if (!video) return;

  // Pause all other videos
  $slider.find('video').each(function () {
    if (this !== video) {
      this.pause();
      this.currentTime = 0;
    }
  });

  video.muted = true;
  video.playsInline = true;
  video.currentTime = 0; // 🔥 restart every time

  var p = video.play();
  if (p) p.catch(function () {});
}



function handleSliderVideo(slider) {
  if (!slider || !slider.flickity) return;

  var flkty = slider.flickity;
  var playToken = 0;

  function playSelectedVideo() {
    playToken++;
    var token = playToken;

    var $slider = jQuery(flkty.element);
    var $selected = $slider.find('.is-selected');
    var video = $selected.find('video').get(0);

    // Pause all other videos
    $slider.find('video').each(function () {
      if (this !== video) {
        this.pause();
        this.currentTime = 0;
      }
    });

    if (!video) return;

    video.muted = true;
    video.playsInline = true;
    video.autoplay = true;

    function safePlay() {
      if (token !== playToken) return;

      var p = video.play();
      if (p) p.catch(function () {});
    }

    // Ensure video is loaded before playing
    if (video.readyState >= 2) {
      safePlay();
    } else {
      video.load();
      video.addEventListener(
        'canplay',
        function () {
          safePlay();
        },
        { once: true }
      );
    }
  }
}

//PDP PAGE COLOR WISE VARIANT GALLERY SHOW JS END


/**************************  PRODUCT ATC BUTTON STICKY BAR JS -- START ************************/
function stickyProductInfoset() {
  setTimeout(function(){
  //console.log("function called");
  const $stickyBar = jQuery('.sticky_product_bar');
  if (!$stickyBar.length) return;
  const $checkedColor = jQuery('.page-content--product .variant-input-wrap-color input[name="Color"]:checked');
  if (!$checkedColor.length) return;
  const imgSrc = $checkedColor.closest('.variant-input').find('.variant__button-label img').attr('src');

  if (!imgSrc) return;

  console.log("Image src:", imgSrc);
  var getColor = $checkedColor.val();
  $stickyBar.find('.sticky_product_banner img').attr('src', imgSrc);
  var variantStr = '';
  if(!jQuery('body').hasClass('variant-show-title') && !jQuery('body').hasClass('variant-selected')){
    if(getColor!="" && getColor!=undefined){
      variantStr+='<div class="sp_variant_item">';
      variantStr+='<span class="sp_variant_label">Color -</span>';
      variantStr+='<span class="sp_variant_select">'+getColor+'</span></div>';
    }
    if(jQuery('.page-content--product').find('.variant__input--other-swatch').length>0){
      var otherSwtch = jQuery('.page-content--product').find('.variant__input--other-swatch');
      otherSwtch.each(function(){
        if(jQuery(this).is(":checked")){
            var nameAttr = jQuery(this).attr('name');
            var valueSwatch = jQuery(this).val();
            variantStr+='<div class="sp_variant_item">';
            variantStr+='<span class="sp_variant_label">'+nameAttr+' -</span>';
            variantStr+='<span class="sp_variant_select">'+valueSwatch+'</span></div>';
        }
      });
    }

    if(variantStr!=""){
      jQuery('.sticky_product_bar').find('.sticky_product_details .sticky_product_variantbox').html('');
      jQuery('.sticky_product_bar').find('.sticky_product_details .sticky_product_variantbox').html(variantStr);
    }
  }else if(jQuery('body').hasClass('variant-show-title')){
    if(jQuery('.pdp--main-product-section').find('.sticky_product_bar').length>0){
      var productObj = jQuery('.pdp--main-product-section');
      var getSelectedVariant = productObj.find(".product-single__variants option:selected").attr('data-variant');
      //console.log("getSelectedVariant",getSelectedVariant);
      if(productObj.find('.sticky_product_bar .sp_variant_select').length>0){
        productObj.find('.sticky_product_bar .sp_variant_select').text('');
        var selectedVerison='';
        if(jQuery('.pdp--main-product-section').find('.variant-input-wrap-version').length>0){
          var versionSwatch = jQuery('.pdp--main-product-section').find('.variant-input-wrap-version');
          if(versionSwatch.length>0){
            console.log("vestion data",versionSwatch.find('[type="radio"]:checked').val());
            var selectedVerison = versionSwatch.find('[type="radio"]:checked').val();
          }
        }
        var stringappend='';
        if(selectedVerison!="" && selectedVerison!=undefined){
          if(getColor!="" && getColor!=undefined){
            stringappend+=selectedVerison + ' - '+getColor;
          }
        }else{
          if(getColor!="" && getColor!=undefined){
              stringappend+=getColor;
          }
        }
        if(jQuery('.pdp--main-product-section').find('.variant-input-wrap-size').length>0){
          var sizeSwatch = jQuery('.pdp--main-product-section').find('.variant-input-wrap-size');
          if(sizeSwatch.length>0){
            console.log("size data",sizeSwatch.find('[type="radio"]:checked').val());
            var selectedSize = sizeSwatch.find('[type="radio"]:checked').val();
            stringappend+=' - '+selectedSize;
          }
        }
        productObj.find('.sticky_product_bar .sp_variant_select').eq(0).text('');
        productObj.find('.sticky_product_bar .sp_variant_select').eq(0).text(stringappend);
      }
    }
  }else if(jQuery('body').hasClass('variant-selected')){
    if(jQuery('.pdp--main-product-section').find('.sticky_product_bar').length>0){
      //console.log("helloooo");
      var productObj = jQuery('.pdp--main-product-section');
      var getSelectedVariant = productObj.find(".product-single__variants option:selected").val();
      //console.log("getSelectedVariant",getSelectedVariant);
      if(productObj.find('.sticky_product_bar .sp_variant_dropdown').length>0){
        productObj.find('.sticky_product_bar .sp_variant_dropdown').val('');
        if(getSelectedVariant!="" && getSelectedVariant!=undefined){
          productObj.find('.sticky_product_bar .sp_variant_dropdown select').val(getSelectedVariant);
        }
      }
    }
  }
  },500);
}

jQuery(document).on("click",".pdp--main-product-section .sticky_product_bar .sp_btn_link",function(){
  if(jQuery('.pdp--main-product-section').find('.product-block.buy-atc').find('.add-to-cart').length>0){
    var btnObj = jQuery(this);
    btnObj.addClass('btn--loading');
    jQuery('.pdp--main-product-section').find('.product-block.buy-atc').find('.add-to-cart').trigger("click");
    var loaderId = setInterval(function(){
      if(jQuery('.pdp--main-product-section').find('.product-block.buy-atc').find('.add-to-cart.btn--loading').length==0){
        btnObj.removeClass('btn--loading');
        clearInterval(loaderId);
      }
    },300);
  }
});

jQuery(document).on("change", ".sticky_product_bar .sp_variant_dropdown select", function () {
  var selectedVariant = jQuery(this).val();

  if (selectedVariant) {
    jQuery('.pdp--main-product-section')
      .find('.product-block.buy-atc')
      .find('[name="id"]')
      .val(selectedVariant);

    // Get selected option text
    var variantText = jQuery(this).find("option:selected").text();
    var colorOption = jQuery(this).find("option:selected").attr('data-color');
    var sizeOption = jQuery(this).find("option:selected").attr('data-size');
    var versionOption = jQuery(this).find("option:selected").attr('data-version');

    setTimeout(function () {
      jQuery('.pdp--main-product-section')
        .find('.product-block.buy-atc')
        .find('[name="id"]')
        .trigger('change');
    }, 200);

    if(typeof colorOption !== "undefined" && colorOption !== ""){
      $(".variant__input--color-swatch").each(function (index, element) {
        if ($(this).val() == colorOption) {
          $(this).trigger("click");
        }
      });
    }

    if(typeof sizeOption !== "undefined" && sizeOption !== ""){
      $(".variant__input--other-swatch").each(function (index, element) {
        if($(this).val() == sizeOption) {
          $(this).trigger("click");
        }
      });
    }

    if(typeof versionOption !== "undefined" && versionOption !== ""){
      $(".variant__input--other-swatch").each(function (index, element) {
        if($(this).val() == versionOption) {
          $(this).trigger("click");
        }
      });
    }
  }
});


function setpriceSetSticky(){
  if(jQuery('.pdp--main-product-section').find('.product_main_price').find('.original___price').length>0){
    var priceObj = jQuery('.pdp--main-product-section').find('.product_main_price');
    var mainPrice = Shopify.formatMoney(0);
    var comparePrice = Shopify.formatMoney(0);
    if(priceObj.find('.original___price').length>0){
      mainPrice = priceObj.find('.original___price').eq(0).text();
      if(mainPrice!="" && mainPrice!=undefined){
        //console.log("mainPrice",mainPrice);
        if(jQuery('.pdp--main-product-section').find('.sticky_product_bar .sp_sale_price').length>0){
          jQuery('.pdp--main-product-section').find('.sticky_product_bar .sp_sale_price').text('');
          jQuery('.pdp--main-product-section').find('.sticky_product_bar .sp_sale_price').text(mainPrice);
        }
      }
    }
    if(priceObj.find('.compare___price').length>0){
      jQuery('.pdp--main-product-section').find('.sticky_product_bar .sp_compare_price').show();
      comparePrice = priceObj.find('.compare___price').eq(0).text();
      if(comparePrice!="" && comparePrice!=undefined){
        //console.log("comparePrice",comparePrice);
        if(jQuery('.pdp--main-product-section').find('.sticky_product_bar .sp_compare_price').length>0){
          jQuery('.pdp--main-product-section').find('.sticky_product_bar .sp_compare_price').text('');
          jQuery('.pdp--main-product-section').find('.sticky_product_bar .sp_compare_price').text(comparePrice);
        }
      }
    }else{
      jQuery('.pdp--main-product-section').find('.sticky_product_bar .sp_compare_price').hide();
    }
  }
}

jQuery(document).ready(function(){
  setTimeout(function(){
    if (jQuery('body').hasClass('sticky-atc-after-before')) {
      setpriceSetSticky();
    }
  },2000);
});

jQuery(document).on("click",".sticky_product_bar .sticky_product_details",function(){
  if(jQuery('.product-block.buy-atc').find('.add-to-cart').length>0){
    jQuery('.product-block.buy-atc').find('.add-to-cart').trigger('click');
  }
});

function isInViewport(el) {
  const rect = el.getBoundingClientRect();
  return (
    rect.top < window.innerHeight &&
    rect.bottom > 0
  );
}
jQuery(document).ready(function(){
  const atcBlockload = document.querySelector('.product-block.buy-atc');
  const stickyBarload = document.querySelector('.sticky_product_bar');

  if (!atcBlockload || !stickyBarload) return;
  if (document.body.classList.contains('sticky-atc-always')) {
    stickyBarload.classList.add('prod-sticky-atc--is-visible');
  }
  //console.log("diiii",jQuery(window).width());
  if(jQuery(window).width()<=767){
    if(jQuery('body').hasClass('sticky-atc-always') && jQuery('.product-block.buy-atc').find('.add-to-cart').length>0){
      jQuery('.product-block.buy-atc').find('.add-to-cart').hide();
    }
  }
});

jQuery(window).on('scroll', function () {
  const atcBlock = document.querySelector('.product-block.buy-atc');
  const stickyBar = document.querySelector('.sticky_product_bar');

  if (!atcBlock || !stickyBar) return;
  if(document.body.classList.contains('sticky-atc-after-before')) {
    const atcOffsetTop = atcBlock.getBoundingClientRect().top + window.scrollY;
    const atcHeight = atcBlock.offsetHeight;
    const triggerPoint = atcOffsetTop + atcHeight;

    if (window.scrollY > triggerPoint) {
      stickyBar.classList.add('prod-sticky-atc--is-visible');
    } else {
      stickyBar.classList.remove('prod-sticky-atc--is-visible');
    }

    // if (isInViewport(atcBlock)) {
    //   stickyBar.classList.remove('prod-sticky-atc--is-visible');
    // } else {
    //   stickyBar.classList.add('prod-sticky-atc--is-visible');
    // }
  }else if (document.body.classList.contains('sticky-atc-always')) {
    //console.log("add class sticky");
    stickyBar.classList.add('prod-sticky-atc--is-visible');
  }
});
/**************************  PRODUCT STICKY BAR JS -- END   ************************/

/**************************  Collection Filter Podal Switch -- START   ************************/
var filterModalSwitch = setInterval(function () {
  if (window.matchMedia("(max-width: 767px)").matches) {
    if (jQuery('body').hasClass('collection_filter_modal_switch')) {
      var $toggle = jQuery("#collectionToggle");
      var $grid = jQuery(".collection-grids");
      var $wrapper = jQuery(".modaltoggle-swatch");

      $grid.removeClass("active-switch");
      $wrapper.removeClass("active");

      $grid.addClass("active-switch");
      $wrapper.addClass("active");

      jQuery('.collection-filter__item--modalswatch #collectionToggle')
        .prop('checked', true);

      clearInterval(filterModalSwitch);
    }
  }
}, 100);
/**************************  Collection Filter Podal Switch -- END   ************************/

/*-------------------------------------------------------------------------------- 
                   START :: MPS_091_product PDP SHOP THE LOOK 
--------------------------------------------------------------------------------*/
//jQuery('body').addClass('limited-edition-active');
jQuery(document).ready(function(){
  var lookIdset = setInterval(function(){
    if(jQuery('.mps-lookbook-products--section').find('.productlook-grid').length>0){
      var objLookup = jQuery('.mps-lookbook-products--section').find('.productlook-grid').find('.productlook.grid__item');
      console.log("objLookup",objLookup);
      if(objLookup.length>0){
        objLookup.each(function(){
          var getPid = jQuery(this).attr('data-product-id');
          lookupGalleryChange(getPid);
        });
        clearInterval(lookIdset);
      }
    }
  },500);
});
jQuery(document)
  .off('change', '.mps-lookbook-products--section [name="Color"]')
  .on('change', '.mps-lookbook-products--section [name="Color"]', function () {
    var $this = jQuery(this);
    var pid = $this.attr('data-pid');
    var vid = $this.attr('data-vid');
    var $productcheck = $this.closest('.productlook');
    if ($productcheck.length) {
      $productcheck.find('label').removeClass('active');
    }
    lookupGalleryChange(pid, vid);
  });

jQuery(document)
  .off('change', '.mps-lookbook-products--section [name="Version"]')
  .on('change', '.mps-lookbook-products--section [name="Version"]', function () {
    if(jQuery('.mps-lookbook-products--section [name="Color"]').length>0){
      jQuery('.mps-lookbook-products--section [name="Color"]:checked').trigger('change');
    }
  });

function lookupGalleryChange(pid,vid){
  var mainProdutcObj = '';
  if(jQuery('.productlook-grid').find('.productlook[data-product-id="'+pid+'"]').length>0){
    mainProdutcObj=jQuery('.productlook-grid').find('.productlook[data-product-id="'+pid+'"]');
  }
  if(jQuery('.flickity-enabled').find('.flickity-page-dots').length>0){
    jQuery('.flickity-enabled').find('.flickity-page-dots').hide();
  }
  var activeStyles = {
    "opacity": "1",
    "visibility": "visible",
    "pointer-events": "auto",
    "position":"unset"
  };

  var hiddenStyles = {
    "opacity": "0",
    "visibility": "hidden",
    "pointer-events": "none",
    "position":"absolute"
  };
  //console.log("mainProdutcObj",mainProdutcObj,pid,mainProdutcObj.find('[name="Version"]:checked').val());
  var flagVersion = 0;
  if(mainProdutcObj!=undefined){
    if($(mainProdutcObj).find('[name="Version"]').length > 0) {
      var getVersion = mainProdutcObj.find('[name="Version"]:checked').val();
      if(mainProdutcObj.find('[name="Color"]').length>0){
        var getColorImg = mainProdutcObj.find('input[type="radio"][name="Color"]:checked').attr('limited-edition-img');
      }
      
      getVersion = stringToHandle(getVersion);
      //console.log("getColorImg",getColorImg);
      if(getVersion=="limited-edition" && getColorImg!=undefined){
        if(mainProdutcObj.find('.limited-gallery-slider.pro-collection-gallery-'+pid).length>0){
          mainProdutcObj.find('.limited-gallery-slider.pro-collection-gallery-'+pid).show();
          mainProdutcObj.find('.limited-gallery-slider.pro-collection-gallery-'+pid).css(activeStyles);
          mainProdutcObj.find('.main-collection-slider.pro-collection-gallery-'+pid).css(hiddenStyles);
        }
        if(mainProdutcObj.find('.limited-gallery-slider.pro-collection-gallery-'+pid).find('.grid-product__link [data-main-image="'+getColorImg+'"]').length>0){
          var getIndexThumb = mainProdutcObj.find('.limited-gallery-slider.pro-collection-gallery-'+pid).find('.grid-product__link [data-main-image="'+getColorImg+'"]').parent().parent('a').attr('data-slick-index');
          mainProdutcObj.find('.limited-gallery-slider.pro-collection-gallery-'+pid).slick('setPosition');
          if(getIndexThumb!=undefined){
            mainProdutcObj.find('.limited-gallery-slider.pro-collection-gallery-'+pid).slick('slickGoTo',getIndexThumb);
          }
        }
      }else if(getVersion!=undefined && getVersion!=""){
        flagVersion=1;
      }
    }else{
      flagVersion=1;
    }
    //console.log("flagVersion",flagVersion,mainProdutcObj);
    if(flagVersion==1){
      if(mainProdutcObj.length>0){
        var getColorImg='';
        if($(mainProdutcObj).find('[name="Color"]').length>0){
          console.log("length color",pid);
          if(mainProdutcObj.find('.main-collection-slider.pro-collection-gallery-'+pid).length>0){
            mainProdutcObj.find('.limited-gallery-slider.pro-collection-gallery-'+pid).hide();
            mainProdutcObj.find('.limited-gallery-slider.pro-collection-gallery-'+pid).css(hiddenStyles);
            mainProdutcObj.find('.main-collection-slider.pro-collection-gallery-'+pid).css(activeStyles);
            mainProdutcObj.find('.main-collection-slider.pro-collection-gallery-'+pid).parent('.pgi-rsquare.pgi-gallery').show();
          }
          console.log("vid",vid);
          if(mainProdutcObj.find('.main-collection-slider.pro-collection-gallery-'+pid).find('.grid-product__link.image-variant-'+vid).length>0){
            var getIndexThumb = mainProdutcObj.find('.main-collection-slider.pro-collection-gallery-'+pid).find('.grid-product__link.image-variant-'+vid).attr('data-slick-index');
            console.log("getIndexThumb",getIndexThumb);
            if(getIndexThumb!=undefined){
              mainProdutcObj.find('.main-collection-slider.pro-collection-gallery-'+pid).slick('slickGoTo',getIndexThumb);
            }
          }
        }
      }
    }
  }
}

//ATC BUTTON FOR MOBILE VERSION JS START
jQuery(document).on("change",".mps-lookbook-plist .product-card_variant .variant-select",function(){
  var selectedObj = jQuery(this).parent().parent('div');
  getVariantSelected(selectedObj);
});

function getVariantSelected(selectedObj){
  if(selectedObj.find('.variant-select').length>0){
    var variantObj = selectedObj.find('.variant-select');
    var variantStr = '';
    variantObj.each(function(){
      if(variantStr!=""){
        variantStr+='-';
      }
      if(jQuery(this).find('option:selected').attr('data-handle')){
        variantStr+=jQuery(this).find('option:selected').attr('data-handle');
      }else{
        variantStr+=jQuery(this).find('option').eq(1).attr('data-handle');
      }
    });
    if(variantStr) {
      console.log("variantStr",variantStr);
      var $variantSelect = selectedObj.find('.product-single__variants');
      var variantGetId = $variantSelect
        .find('option[data-handle="' + variantStr + '"]')
        .val();

      if (variantGetId) {
        $variantSelect.val(variantGetId).trigger('change');
      }
    }
  }
}

//ATC BUTTON FOR MOBILE VERSION JS END

/*--------------------------------------------------------------------------------
                    END :: MPS_091_product PDP SHOP THE LOOK 
--------------------------------------------------------------------------------*/

/**************************  PRODUCT BUNDLE SELECTOR -- START  ************************/

jQuery(document).ready(function ($) {
  var proBundleLoad = setInterval(function(){
    if(bundleActiveVersion()){
      bundleProductInfoset();
      var $bundleContent = $('.bundle_selector_content');
      var $strapAccessories = $('.bundle_selector_option.option_strap_accessories .bundle_selector_label');
      var $singleStrap = $('.bundle_selector_option.option_single_strap .bundle_selector_label');

      if (!$bundleContent.length) return;

      function resetClasses() {
        $bundleContent.removeClass('strap_accessories_active single_strap_active');
      }

      if ($strapAccessories.length) {
        $strapAccessories.on('click', function () {
          resetClasses();
          $bundleContent.addClass('strap_accessories_active');
          bundleProductInfoset();
        });
      }

      if ($singleStrap.length) {
        $singleStrap.on('click', function () {
          resetClasses();
          $bundleContent.addClass('single_strap_active');
        });
      }

      // Default click
      // if ($strapAccessories.length) {
      //   $strapAccessories.trigger('click');
      // }
      clearInterval(proBundleLoad);
    }
  },100);
});

jQuery(document).on("change",".product_bundle_selector .strap_product_cover .bsc_select_variant, .product_bundle_selector .bsc_strap_size_select .bsc_select_variant",function(){
  strapAccessoriesSet(jQuery(this));
});

jQuery(document).on("click",".page-content--product .variant-input-wrap-color,.page-content--product .variant-input-wrap-size",function(){
  if(jQuery('.variant-input-wrap-color').find('[name="Color"]').length>0 || jQuery('.variant-input-wrap-color').find('[name="Size"]').length){
    colorWiseAccessories();
  }
});

jQuery(document).on(
  "change",
  ".bundle_selector_wrapper .strap_accessories_item .watch_cover_dropdown, .bundle_selector_wrapper .bsc_strap_size_select .watch_cover_dropdown",
  function () {
    var getVariantImage = jQuery(this)
      .find(':selected')
      .data('color-img');
    console.log("getVariantImage:", getVariantImage);
    if (getVariantImage) {
      if (
        jQuery('body').hasClass('bundle_selector_vone') ||
        jQuery('body').hasClass('bundle_selector_vtwo') ||
        jQuery('body').hasClass('bundle_selector_vthree')
      ) {

        var selectClass = '.bundle_selector_wrapper .strap_product_cover';

        jQuery(selectClass)
          .find('.bsc_product_banner img')
          .attr('src', getVariantImage);
      }
    }
  }
);

function strapAccessoriesSet(selectObj) {
  if (!selectObj || !selectObj.length) return;

  var $selected = selectObj.find('option:selected');
  var mainPrice = $selected.attr('data-price');
  var availProduct = $selected.attr('data-avail');
  //console.log("availProduct",availProduct);
  if(availProduct){
    var priceObj = jQuery('.product_bundle_selector').find('.strap_accessories_item');

    if (priceObj.find('.bsc_product_sale').length > 0) {
      priceObj.find('.bsc_product_sale').eq(1).text(mainPrice);
    }

    var comparePrice = $selected.attr('data-cprice');
    if (comparePrice) {
      priceObj.find('.bsc_product_compare').eq(1).text(comparePrice);
    }

    var getSize = $selected.attr('data-size');
    if (getSize) {
      priceObj.find('.accessories_product .bsc_variant_select_cover').text(getSize);
      if(/series\s*10/i.test(getSize)) {
        getSize =  getSize.replace(/\s*&.*?\)/, ')');
      }
      var $protectOption = priceObj
        .find('.strap_accessories_product .protect_cover_dropdown option[data-size="' + getSize + '"]');

      if ($protectOption.length) {
        $protectOption.prop('selected', true)
          .closest('select')
          .trigger('change');
      }
    }
  }
}



function handleize(str){
    return str
        .toLowerCase()
        .trim()
        .replace(/['"]/g, '')
        .replace(/\s+/g, '-')
        .replace(/[^a-z0-9\-]/g, '');
}

jQuery(document).ready(function(){
  if(jQuery('body').hasClass('bundle_selector_vone') || jQuery('body').hasClass('bundle_selector_vtwo') || jQuery('body').hasClass('bundle_selector_vthree')){
    var selectClass = '.bundle_selector_wrapper .strap_accessories_item';
    if(jQuery('body').hasClass('bundle_selector_vtwo') || jQuery('body').hasClass('bundle_selector_vthree')){
      selectClass = '.bundle_selector_wrapper .bsc_strap_size_select';
    }
    var interColorId = setInterval(function(){
      if(jQuery(selectClass).find('.bsc_select_variant').length>0 && jQuery('.variant-input-wrap-color').find('[name="Color"]').length>0){
        colorWiseAccessories();
        clearInterval(interColorId);
      }
    },1000);
  }
});

function colorWiseAccessories(){
  if(jQuery('.variant-input-wrap-color').find('[name="Color"]').length>0){
    var getColorVal = jQuery('.variant-input-wrap-color').find('[name="Color"]:checked').val();
    var getSizeVal = '';
    if (jQuery('.variant-input-wrap-size').find('[name="Size"]').length>0) {
      getSizeVal = jQuery('.variant-input-wrap-size').find('[name="Size"]:checked').val();
      if(/series\s*10/i.test(getSizeVal)) {
        getSizeVal =  getSizeVal.replace(/\s*&.*?\)/, ')');
      }
      getSizeVal = getSizeVal.split('/')[0].trim();
    }
    
    if(getColorVal!="" && getColorVal!=undefined && getSizeVal!=""){
      var selectClass = '.bundle_selector_wrapper .strap_accessories_item';
      if(jQuery('body').hasClass('bundle_selector_vtwo') || jQuery('body').hasClass('bundle_selector_vthree')){
        selectClass = '.bundle_selector_wrapper .bsc_strap_size_select';
      }
      getColorVal = handleize(getColorVal);
      var getbundleHandle = ''; 
      if(jQuery('.main-content').find('.product-section').attr('data-product-handle')!=null){
        getbundleHandle = jQuery('.main-content').find('.product-section').attr('data-product-handle');
      }
      if(getbundleHandle!="" && getbundleHandle == 'diva-strap'){
        if(getColorVal == 'peachblow'){
          if(jQuery(selectClass).find('.bsc_select_variant').find('option[data-color-handle="'+getColorVal+'"]').length==0){
            getColorVal='gold';
          }
        }else if(getColorVal == 'pink-petal'){
          if(jQuery(selectClass).find('.bsc_select_variant').find('option[data-color-handle="'+getColorVal+'"]').length==0){
            getColorVal='starlight';
          }
        }else if(getColorVal == 'cloud-white'){
          if(jQuery(selectClass).find('.bsc_select_variant').find('option[data-color-handle="'+getColorVal+'"]').length==0){
            getColorVal='starlight';
          }
        }
      }else if(getbundleHandle!="" && getbundleHandle == 'bijou-apple-watch-strap'){
        if(getColorVal == 'white-and-silver' || getColorVal == 'black-and-silver'){
          if(jQuery(selectClass).find('.bsc_select_variant').find('option[data-color-handle="'+getColorVal+'"]').length==0){
            getColorVal='silver-gem';
          }
        }else if(getColorVal == 'white-and-gold' || getColorVal == 'black-and-gold'){
          if(jQuery(selectClass).find('.bsc_select_variant').find('option[data-color-handle="'+getColorVal+'"]').length==0){
            getColorVal='gold';
          }
        }
      }else if(getbundleHandle!="" && getbundleHandle == 'key-to-my-luck-strap'){
        if(getColorVal == 'starlight-and-white'){
          if(jQuery(selectClass).find('.bsc_select_variant').find('option[data-color-handle="'+getColorVal+'"]').length==0){
            getColorVal='white-and-silver';
          }
        }else if(getColorVal == 'starlight-and-black'){
          if(jQuery(selectClass).find('.bsc_select_variant').find('option[data-color-handle="'+getColorVal+'"]').length==0){
            getColorVal='black-and-silver';
          }
        }
      }else{
        if(getColorVal=='rose-gold'){
          if(jQuery(selectClass).find('.bsc_select_variant').find('option[data-color-handle="'+getColorVal+'"]').length==0){
            getColorVal='sunset-rose-gold';
          }
        }else if(getColorVal=='space-gem'){
          getColorVal='black';
        }
      }
      if(jQuery('.strap_accessories_item').find('.strap_product_cover .bsc_select_variant').length>0 && jQuery('.strap_accessories_item').find('.strap_accessories_product .bsc_select_variant').length>0){
        jQuery(selectClass).each(function(){
          var $select = jQuery(this).find('.bsc_select_variant');
          var $option = $select.find('option[data-color-handle="'+getColorVal+'"][data-size="'+getSizeVal+'"]');
          if ($option.length && $select.val() != $option.val()) {
            $select.val($option.val());
            var getVariantImage = $option.attr('data-color-img');
            if(getVariantImage!="" && getVariantImage!=undefined){
              jQuery('.strap_product_cover').find('.bsc_product_banner img').attr('src',getVariantImage);
            }
          }
        });
      }
    }else if(getColorVal!="" && getColorVal!=undefined){
      var selectClass = '.bundle_selector_wrapper .strap_accessories_item';
        if(jQuery('body').hasClass('bundle_selector_vtwo') || jQuery('body').hasClass('bundle_selector_vthree')){
          selectClass = '.bundle_selector_wrapper .bsc_strap_size_select';
        }
        jQuery(selectClass).each(function(){
          var $select = jQuery(this).find('.bsc_select_variant');
          var $option = $select.find('option[data-color-handle="'+getColorVal+'"]');
          if ($option.length && $select.val() != $option.val()) {
              $select.val($option.val());
              var getVariantImage = $option.attr('data-color-img');
              if(getVariantImage!="" && getVariantImage!=undefined){
                jQuery('.strap_product_cover').find('.bsc_product_banner img').attr('src',getVariantImage);
              }
          }
        });
    }
  }
}

/*function preparePDPBundle() {
  var bundleData = [];
  if(jQuery('body').hasClass('bundle_selector_vone')){
    var activeItems = jQuery('.product_bundle_selector').find('.bsc_variant_dropdown');
    if(activeItems.length>0){
      activeItems.each(function () {
        var getvariant = jQuery(this).find('option:selected').val();
        if(getvariant!="" && getvariant!=undefined){
          if(!bundleData.includes(getvariant)) {
            bundleData.push(getvariant);
          }
        }
      });
    }
  }else if(jQuery('body').hasClass('bundle_selector_vtwo') || jQuery('body').hasClass('bundle_selector_vthree')){
    var activeItems = jQuery('.product_bundle_selector').find('.bsc_strap_size_select .bsc_select_variant');
    activeItems.each(function () {
      var getvariant = jQuery(this).find('option:selected').val();
      if(getvariant!="" && getvariant!=undefined){
        if(!bundleData.includes(getvariant)) {
          bundleData.push(getvariant);
        }
      }
    });
    var activeItems = jQuery('.product_bundle_selector').find('.strap_accessories_product .protect_cover_dropdown');
    activeItems.each(function () {
      var getvariant = jQuery(this).find('option:selected').val();
      if(getvariant!="" && getvariant!=undefined){
        if(!bundleData.includes(getvariant)) {
          bundleData.push(getvariant);
        }
      }
    });
  }
  return bundleData;
}*/

function preparePDPBundle() {
  var bundleData = [];

  function addVariantData(selectEl){
    var selectedOption = jQuery(selectEl).find('option:selected');
    var variantId = selectedOption.val();

    if(variantId && variantId !== ""){

      var productTitle = selectedOption.attr('data-ptitle'); 
      var productHandle = selectedOption.attr('data-handle'); 
      var productImg = selectedOption.attr('data-img');
      var productPrice = selectedOption.attr('data-oprice');
      var variantName = selectedOption.text().trim();
      var avail = selectedOption.attr('data-avail');
      // check duplicate variant
      if(avail){
        if(!bundleData.some(item => item.variant_id == variantId)){
          bundleData.push({
            product_title: productTitle,
            variant_id: variantId,
            variant_name: variantName,
            variant_handle:productHandle,
            variant_image:productImg,
            variant_price:productPrice
          });
        }
      }
    }
  }

  if(jQuery('body').hasClass('bundle_selector_vone')){

    jQuery('.product_bundle_selector .bsc_variant_dropdown').each(function(){
      addVariantData(this);
    });

  }else if(
    jQuery('body').hasClass('bundle_selector_vtwo') || 
    jQuery('body').hasClass('bundle_selector_vthree')
  ){

    jQuery('.product_bundle_selector .bsc_strap_size_select .bsc_select_variant').each(function(){
      addVariantData(this);
    });

    jQuery('.product_bundle_selector .strap_accessories_product .protect_cover_dropdown').each(function(){
      addVariantData(this);
    });

  }

  return bundleData;
}

function bundlePriceTotal(){
  var totalPrice = 0;
  var totalCPrice=0;
  var bundleData1 = [];
  var activeItems = jQuery('.product_bundle_selector').find('.bsc_variant_dropdown');
  if(activeItems.length>0){
    activeItems.each(function () {
      var getvariant = jQuery(this).find('option:selected').val();
      if(getvariant!="" && getvariant!=undefined){
        var price = jQuery(this).find('option:selected').attr('data-oprice');
        var cprice = jQuery(this).find('option:selected').attr('data-ocprice');
        if(!bundleData1.includes(getvariant)) {
          totalPrice+=parseFloat(price);
          if(cprice!="" && cprice!=undefined){
            totalCPrice+=parseFloat(cprice);
          }
        }
      }
    });
    if(jQuery('.pdp--main-product-section').find('.buy-atc').find('[name="id"]').length>0){
      var defaultSelect = jQuery('.pdp--main-product-section').find('.buy-atc').find('[name="id"]');
      var price = defaultSelect.find('option:selected').attr('data-oprice');
      var cprice = defaultSelect.find('option:selected').attr('data-ocprice');
      totalPrice+=parseFloat(price);
      if(cprice!="" && cprice!=undefined){
        totalCPrice+=parseFloat(cprice);
      }
      console.log("price",price,cprice);
      if(price!="" && jQuery('.product_bundle_selector').find('.bsl_prices_inner .bsl_price_sale').length>0){
        jQuery('.product_bundle_selector').find('.bs_label_prices').find('.bsl_price_sale').eq(0).text(Shopify.formatMoney(price));
      }
      if(cprice!="" && jQuery('.product_bundle_selector').find('.bsl_prices_inner .bsl_price_compare').length>0){
        jQuery('.product_bundle_selector').find('.bs_label_prices').find('.bsl_prices_inner .bsl_price_compare').eq(0).text(Shopify.formatMoney(cprice));
      }
    }
  }
  if(totalPrice!=0 && jQuery('.product_bundle_selector').find('.bsl_prices_inner .bsl_price_sale').length>0){
    jQuery('.product_bundle_selector').find('.bs_label_prices').find('.bsl_price_sale').eq(1).text(Shopify.formatMoney(totalPrice));
  }
  if(totalCPrice!=0 && jQuery('.product_bundle_selector').find('.bsl_prices_inner .bsl_price_compare').length>0){
    var getOff = getDiscountPercent(totalCPrice,totalPrice);
    jQuery('.product_bundle_selector').find('.bs_label_heading_bundle').find('.bsl_heading_save').text('Save '+getOff+'%');
    jQuery('.product_bundle_selector').find('.bs_label_prices').find('.bsl_prices_savelabel').text('Save '+getOff+'%');
    jQuery('.product_bundle_selector').find('.bs_label_prices').find('.bsl_prices_inner .bsl_price_compare').eq(1).text(Shopify.formatMoney(totalCPrice));
  }
}

function getDiscountPercent(comparePrice, salePrice) {
  if (!comparePrice || !salePrice || comparePrice <= salePrice) return 0;

  var percentOff = ((comparePrice - salePrice) / comparePrice) * 100;
  return Math.round(percentOff); // round to nearest whole number
}

function bundleActiveVersion(){
  if(jQuery('body').hasClass('bundle_selector_vone') || jQuery('body').hasClass('bundle_selector_vtwo') || jQuery('body').hasClass('bundle_selector_vthree')){
    return true;
  }
  return false;
}

function bundleProductInfoset() {
  setTimeout(function(){
    const $checkedColor = jQuery('.page-content--product .variant-input-wrap-color input[name="Color"]:checked');
    if (!$checkedColor.length) return;
    const imgSrc = $checkedColor.closest('.variant-input').find('.variant__button-label img').attr('src');

    if (!imgSrc) return;

   
    var getColor = $checkedColor.val();
    //console.log("Image src:", imgSrc,getColor);
    var variantStr = '';
    if(jQuery('.pdp--main-product-section').find('.product_bundle_selector').length>0){
      if(jQuery('.bs_content_item.strap_accessories_item').find('.bsc_product_banner img').length>0){
        jQuery('.bs_content_item.strap_accessories_item').find('.bsc_product_banner img').eq(0).attr('src', imgSrc);
      }
      var productObj = jQuery('.pdp--main-product-section');
      var getSelectedVariant = productObj.find(".product-single__variants option:selected").attr('data-variant');
      if(productObj.find('.bsc_product_content .bsc_variant_select').length>0){
        productObj.find('.bsc_product_content .bsc_variant_select').text('');
        var selectedVerison='';
        if(jQuery('.pdp--main-product-section').find('.variant-input-wrap-version').length>0){
          var versionSwatch = jQuery('.pdp--main-product-section').find('.variant-input-wrap-version');
          if(versionSwatch.length>0){
            var selectedVerison = versionSwatch.find('[type="radio"]:checked').val();
          }
        }
        var stringappend='';
        if(selectedVerison!="" && selectedVerison!=undefined){
          if(getColor!="" && getColor!=undefined){
            stringappend+=selectedVerison + ' - '+getColor;
          }
        }else{
          if(getColor!="" && getColor!=undefined){
              stringappend+=getColor;
          }
        }
        if(jQuery('.pdp--main-product-section').find('.variant-input-wrap-size').length>0){
          var sizeSwatch = jQuery('.pdp--main-product-section').find('.variant-input-wrap-size');
          if(sizeSwatch.length>0){
            //console.log("size data",sizeSwatch.find('[type="radio"]:checked').val());
            var selectedSize = sizeSwatch.find('[type="radio"]:checked').val();
            stringappend+=' - '+selectedSize;
          }
        }
        productObj.find('.bsc_product_content .bsc_variant_select').eq(0).text('');
        productObj.find('.bsc_product_content .bsc_variant_select').eq(0).text(stringappend);
      }
    }
    bundleSetPrice();
    bundlePriceTotal();
    if(jQuery('.product_bundle_selector').find('.bs_content_item.strap_accessories_item').find('.bsc_select_variant').length>0){
      var selectObj = jQuery('.product_bundle_selector').find('.bs_content_item.strap_accessories_item').find('.bsc_select_variant');
      strapAccessoriesSet(selectObj);
    }
  },100);
}

function bundleSetPrice(){
  if(jQuery('.pdp--main-product-section').find('.product_main_price').find('.original___price').length>0){
    var priceObj = jQuery('.pdp--main-product-section').find('.product_main_price');
    var mainPrice = Shopify.formatMoney(0);
    var comparePrice = Shopify.formatMoney(0);
    var objPrice =  jQuery('.pdp--main-product-section').find('.product_bundle_selector').find('.bsc_product_content');
    if(priceObj.find('.original___price').length>0){
      mainPrice = priceObj.find('.original___price').eq(0).text();
      if(mainPrice!="" && mainPrice!=undefined){
        //console.log("mainPrice",mainPrice);
        if(objPrice.length>0){
          objPrice.find('.bsc_product_sale').eq(0).text('');
          objPrice.find('.bsc_product_sale').eq(0).text(mainPrice);
        }
      }
    }
    if(priceObj.find('.compare___price').length>0){
      objPrice.find('.bsc_product_compare').show();
      comparePrice = priceObj.find('.compare___price').eq(0).text();
      if(comparePrice!="" && comparePrice!=undefined){
        //console.log("comparePrice",comparePrice);
        if(objPrice.find('.bsc_product_compare').length>0){
          objPrice.find('.bsc_product_compare').eq(0).text('');
          objPrice.find('.bsc_product_compare').eq(0).text(comparePrice);
        }
      }
    }
    else{
      objPrice.find('.bsc_product_compare').hide();
    }
  }
}
/**************************  PRODUCT BUNDLE SELECTOR -- END  ************************/

/**************************  PDP WITH SHOP THE LOOK VARIANT SELECTION -- START  ************************/
jQuery(document).ready(function ($) {
  jQuery(document).on("change",".productlook-grid .product_lookcontent_innr .product-block [data-variant-input]",function(){
    var selectedObj = jQuery(this).parent().parent().parent().parent('div');
    getVariantLookupSelected(selectedObj);
  });


  function createHandle(str) {
    return str
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function getVariantLookupSelected(selectedObj) {
    if (selectedObj.find('[data-variant-input]').length > 0) {
      var variantObj = selectedObj.find('[data-variant-input]');
      var variantParts = [];

      variantObj.each(function () {
        if (jQuery(this).is(":checked")) {
          var val = jQuery(this).val().toString().trim();
          variantParts.push(createHandle(val));
        }
      });
      if (variantParts.length > 0) {
        var variantStr = variantParts.join('-');
        setTimeout(function () {
          var $variantSelect = selectedObj.find('.product-block').find('.product-single__variants');
          if ($variantSelect.length === 0) {
            console.warn("Variant select not found");
            return;
          }
          //console.log("variantObj",variantObj);
          //variantObj.closest('label').removeClass('active');
          // if(variantObj.next('label')!=null && variantObj.next('label')!=undefined){
          //   variantObj.next('label').removeClass('active');
          // }
          var $matchedOption = $variantSelect.find('option[data-handle="' + variantStr + '"]');

          if ($matchedOption.length > 0) {
            var variantId = $matchedOption.val();

            // Properly set selected attribute
            $variantSelect.find('option').removeAttr('selected');
            $matchedOption.attr('selected', 'selected');
            $variantSelect.val(variantId);

            // Trigger multiple events to ensure Shopify picks it up
            $variantSelect.trigger('change');
            //$variantSelect.trigger('input');
            $variantSelect[0].dispatchEvent(new Event('change', { bubbles: true }));
            updateURL(variantId);
          } else {
            console.warn("No variant matched for handle:", variantStr);
          }
        }, 100);
      }
    }
  }

  function updateURL(variantid){
    if (!variantid) return;

    var params = new URLSearchParams(window.location.search);
    params.set("variant", variantid);

    var newURL = window.location.pathname + "?" + params.toString();

    window.history.replaceState(
      { path: newURL },
      "",
      newURL
    );
  }
});
/**************************  PDP WITH SHOP THE LOOK VARIANT SELECTION -- END  ************************/